<template>
    <div>
        <b-list-group>
            <b-list-group-item class="flex-column align-items-start" button >
                <b-form-checkbox  size="sm" switch v-model="baseFunc.check" inline></b-form-checkbox>
                <b-button size="sm" class="margin-bottom: 40%" variant="outline-info" @click="baseFunc.button ? baseFunc.button = false : baseFunc.button = true"> {{$t('Base functions')}}</b-button>
                <b-list-group v-if="baseFunc.button">
                    <b-list-group-item  v-for="i in baseFuncsIDs" :key="i.id">
                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                    </b-list-group-item>
                </b-list-group>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start" button >
                <b-form-checkbox  size="sm" switch v-model="mainView.check" inline></b-form-checkbox>
                <b-button size="sm" variant="outline-info" @click="clickMainView">  {{$t('Main window')}}</b-button>
                    <b-list-group v-if="mainView.button">
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="userAndGroup.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clickuserAndGroup">  {{$t('Users & Groups')}}</b-button>
                                  <b-list-group v-if="userAndGroup.button">
                                    <b-list-group-item>
                                      <b-form-checkbox  size="sm" switch v-model="UaGUsers.check" inline></b-form-checkbox>
                                      <b-button size="sm" variant="outline-info" @click="clickUaGUsers">  {{$t('Users')}}</b-button>
                                      <b-list-group v-if="UaGUsers.button">
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGUsersRefresh.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGUsersRefresh.button?UaGUsersRefresh.button = false : UaGUsersRefresh.button = true">{{$t('Refresh')}}</b-button>
                                        <b-list-group v-if="UaGUsersRefresh.button">
                                            <b-list-group-item  v-for="i in mainUgUsers[0].funcs" :key="i.id">
                                              <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                            </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGUsersAdd.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGUsersAdd.button?UaGUsersAdd.button = false : UaGUsersAdd.button = true">{{$t('Add user')}}</b-button>
                                        <b-list-group v-if="UaGUsersAdd.button">
                                            <b-list-group-item  v-for="i in mainUgUsers[1].funcs" :key="i.id">
                                              <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                            </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGUsersView.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGUsersView.button?UaGUsersView.button = false : UaGUsersView.button = true">{{$t('View user')}}</b-button>
                                        <b-list-group v-if="UaGUsersView.button">
                                          <b-list-group-item  v-for="i in mainUgUsers[2].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGUsersEdit.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGUsersEdit.button?UaGUsersEdit.button = false : UaGUsersEdit.button = true">{{$t('Edit user')}}</b-button>
                                        <b-list-group v-if="UaGUsersEdit.button">
                                          <b-list-group-item  v-for="i in mainUgUsers[3].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGUsersSearch.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGUsersSearch.button?UaGUsersSearch.button = false : UaGUsersSearch.button = true">{{$t('Search users')}}</b-button>
                                        <b-list-group v-if="UaGUsersSearch.button">
                                          <b-list-group-item  v-for="i in mainUgUsers[4].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGUsersNew.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGUsersNew.button?UaGUsersNew.button = false : UaGUsersNew.button = true">{{$t('New payment')}}</b-button>
                                        <b-list-group v-if="UaGUsersNew.button">
                                          <b-list-group-item  v-for="i in mainUgUsers[5].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGUsersPayment.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGUsersPayment.button?UaGUsersPayment.button = false : UaGUsersPayment.button = true">{{$t('Payment for invoice')}}</b-button>
                                        <b-list-group v-if="UaGUsersPayment.button">
                                          <b-list-group-item  v-for="i in mainUgUsers[6].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGUsersAddtogroup.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGUsersAddtogroup.button?UaGUsersAddtogroup.button = false : UaGUsersAddtogroup.button = true">{{$t('Add to group')}}</b-button>
                                        <b-list-group v-if="UaGUsersAddtogroup.button">
                                          <b-list-group-item  v-for="i in mainUgUsers[7].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGUsersChange.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGUsersChange.button?UaGUsersChange.button = false : UaGUsersChange.button = true">{{$t('Change Internet status')}}</b-button>
                                        <b-list-group v-if="UaGUsersChange.button">
                                          <b-list-group-item  v-for="i in mainUgUsers[8].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                      </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                      <b-form-checkbox  size="sm" switch v-model="UaGDealers.check" inline></b-form-checkbox>
                                      <b-button size="sm" variant="outline-info" @click="clickUaGDealers">  {{$t('Dealers')}}</b-button>
                                      <b-list-group v-if="UaGDealers.button">
                                        <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGDealerRefresh.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGDealerRefresh.button?UaGDealerRefresh.button = false : UaGDealerRefresh.button = true">{{$t('Refresh')}}</b-button>
                                         <b-list-group v-if="UaGDealerRefresh.button">
                                          <b-list-group-item  v-for="i in mainUgDealers[0].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGDealerAdd.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGDealerAdd.button?UaGDealerAdd.button = false : UaGDealerAdd.button = true">{{$t('Add')}}</b-button>
                                        <b-list-group v-if="UaGDealerAdd.button">
                                          <b-list-group-item  v-for="i in mainUgDealers[1].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGDealerRead.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGDealerRead.button?UaGDealerRead.button = false : UaGDealerRead.button = true">{{$t('Read')}}</b-button>
                                        <b-list-group v-if="UaGDealerRead.button">
                                        <b-list-group-item  v-for="i in mainUgDealers[2].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGDealerEdit.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGDealerEdit.button?UaGDealerEdit.button = false : UaGDealerEdit.button = true">{{$t('Edit')}}</b-button>
                                        <b-list-group v-if="UaGDealerEdit.button">
                                        <b-list-group-item  v-for="i in mainUgDealers[3].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGDealerDelete.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGDealerDelete.button?UaGDealerDelete.button = false : UaGDealerDelete.button = true">{{$t('Delete')}}</b-button>
                                        <b-list-group v-if="UaGDealerDelete.button">
                                        <b-list-group-item  v-for="i in mainUgDealers[4].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                      </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                      <b-form-checkbox  size="sm" switch v-model="UaGGroups.check" inline></b-form-checkbox>
                                      <b-button size="sm" variant="outline-info" @click="clickUaGGroups">  {{$t('Groups')}}</b-button>
                                      <b-list-group v-if="UaGGroups.button">
                                      <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGGroupsRefresh.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGGroupsRefresh.button?UaGGroupsRefresh.button = false : UaGGroupsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                        <b-list-group v-if="UaGGroupsRefresh.button">
                                        <b-list-group-item  v-for="i in mainUgGroups[0].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGGroupsAdd.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGGroupsAdd.button?UaGGroupsAdd.button = false : UaGGroupsAdd.button = true">{{$t('Add')}}</b-button>
                                        <b-list-group v-if="UaGGroupsAdd.button">
                                        <b-list-group-item  v-for="i in mainUgGroups[1].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGGroupsRead.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGGroupsRead.button?UaGGroupsRead.button = false : UaGGroupsRead.button = true">{{$t('Read')}}</b-button>
                                        <b-list-group v-if="UaGGroupsRead.button">
                                        <b-list-group-item  v-for="i in mainUgGroups[2].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGGroupsEdit.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGGroupsEdit.button?UaGGroupsEdit.button = false : UaGGroupsEdit.button = true">{{$t('Edit')}}</b-button>
                                        <b-list-group v-if="UaGGroupsEdit.button">
                                        <b-list-group-item  v-for="i in mainUgGroups[3].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGGroupsDelete.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGGroupsDelete.button?UaGGroupsDelete.button = false : UaGGroupsDelete.button = true">{{$t('Delete')}}</b-button>
                                        <b-list-group v-if="UaGGroupsDelete.button">
                                        <b-list-group-item  v-for="i in mainUgGroups[4].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGGroupsOp.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGGroupsOp.button?UaGGroupsOp.button = false : UaGGroupsOp.button = true">{{$t('Group operations')}}</b-button>
                                        <b-list-group v-if="UaGGroupsOp.button">
                                        <b-list-group-item  v-for="i in mainUgGroups[5].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                      </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                      <b-form-checkbox  size="sm" switch v-model="UaGIPgroups.check" inline></b-form-checkbox>
                                      <b-button size="sm" variant="outline-info" @click="clickUaGIPgroups">  {{$t('IP Groups')}}</b-button>
                                      <b-list-group v-if="UaGIPgroups.button">
                                        <b-list-group-item  v-for="i in mainUgIPGroups[0].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                    </b-list-group-item>
                                      <b-list-group-item>
                                      <b-form-checkbox  size="sm" switch v-model="UaGSysGroups.check" inline></b-form-checkbox>
                                      <b-button size="sm" variant="outline-info" @click="clickUaGSysGroups">  {{$t('System groups')}}</b-button>
                                    <b-list-group v-if="UaGSysGroups.button">
                                      <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGSysGroupsRefresh.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGSysGroupsRefresh.button?UaGSysGroupsRefresh.button = false : UaGSysGroupsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                         <b-list-group v-if="UaGSysGroupsRefresh.button">
                                        <b-list-group-item  v-for="i in mainUgSysGroups[0].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGSysGroupsAdd.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGSysGroupsAdd.button?UaGSysGroupsAdd.button = false : UaGSysGroupsAdd.button = true">{{$t('Add')}}</b-button>
                                        <b-list-group v-if="UaGSysGroupsAdd.button">
                                        <b-list-group-item  v-for="i in mainUgSysGroups[1].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGSysGroupsRead.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGSysGroupsRead.button?UaGSysGroupsRead.button = false : UaGSysGroupsRead.button = true">{{$t('Read')}}</b-button>
                                        <b-list-group v-if="UaGSysGroupsRead.button">
                                        <b-list-group-item  v-for="i in mainUgSysGroups[2].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGSysGroupsEdit.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGSysGroupsEdit.button?UaGSysGroupsEdit.button = false : UaGSysGroupsEdit.button = true">{{$t('Edit')}}</b-button>
                                        <b-list-group v-if="UaGSysGroupsEdit.button">
                                        <b-list-group-item  v-for="i in mainUgSysGroups[3].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                      </b-list-group-item>
                                      </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                      <b-form-checkbox  size="sm" switch v-model="UaGSysUsers.check" inline></b-form-checkbox>
                                      <b-button size="sm" variant="outline-info" @click="clickUaGSysUsers">  {{$t('System Users')}}</b-button>
                                      <b-list-group v-if="UaGSysUsers.button">
                                        <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGSysUsersRefresh.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGSysUsersRefresh.button?UaGSysUsersRefresh.button = false : UaGSysUsersRefresh.button = true">{{$t('Refresh')}}</b-button>
                                         <b-list-group v-if="UaGSysUsersRefresh.button">
                                        <b-list-group-item  v-for="i in mainUgSysUsers[0].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGSysUsersAdd.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGSysUsersAdd.button?UaGSysUsersAdd.button = false : UaGSysUsersAdd.button = true">{{$t('Add')}}</b-button>
                                         <b-list-group v-if="UaGSysUsersAdd.button">
                                        <b-list-group-item  v-for="i in mainUgSysUsers[1].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGSysUsersRead.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGSysUsersRead.button?UaGSysUsersRead.button = false : UaGSysUsersRead.button = true">{{$t('Read')}}</b-button>
                                        <b-list-group v-if="UaGSysUsersRead.button">
                                        <b-list-group-item  v-for="i in mainUgSysUsers[2].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGSysUsersEdit.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGSysUsersEdit.button?UaGSysUsersEdit.button = false : UaGSysUsersEdit.button = true">{{$t('Edit')}}</b-button>
                                        <b-list-group v-if="UaGSysUsersEdit.button">
                                        <b-list-group-item  v-for="i in mainUgSysUsers[3].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGSysUsersDelete.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGSysUsersDelete.button?UaGSysUsersDelete.button = false : UaGSysUsersDelete.button = true">{{$t('Delete')}}</b-button>
                                        <b-list-group v-if="UaGSysUsersDelete.button">
                                        <b-list-group-item  v-for="i in mainUgSysUsers[4].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                      </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                      <b-form-checkbox  size="sm" switch v-model="UaGCardPool.check" inline></b-form-checkbox>
                                      <b-button size="sm" variant="outline-info" @click="clickUaGCardPool">  {{$t('Card pools')}}</b-button>
                                      <b-list-group v-if="UaGCardPool.button">
                                      <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGCardPoolRefresh.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGCardPoolRefresh.button?UaGCardPoolRefresh.button = false : UaGCardPoolRefresh.button = true">{{$t('Refresh')}}</b-button>
                                         <b-list-group v-if="UaGCardPoolRefresh.button">
                                        <b-list-group-item  v-for="i in mainUgCardPools[0].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGCardPoolAddcardowner.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGCardPoolAddcardowner.button?UaGCardPoolAddcardowner.button = false : UaGCardPoolAddcardowner.button = true">{{$t('Add card owner')}}</b-button>
                                        <b-list-group v-if="UaGCardPoolAddcardowner.button">
                                        <b-list-group-item  v-for="i in mainUgCardPools[1].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGCardPoolRemove.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGCardPoolRemove.button?UaGCardPoolRemove.button = false : UaGCardPoolRemove.button = true">{{$t('Remove card owner')}}</b-button>
                                        <b-list-group v-if="UaGCardPoolRemove.button">
                                        <b-list-group-item  v-for="i in mainUgCardPools[2].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGCardPoolMove.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGCardPoolMove.button?UaGCardPoolMove.button = false : UaGCardPoolMove.button = true">{{$t('Move expired cards')}}</b-button>
                                        <b-list-group v-if="UaGCardPoolMove.button">
                                        <b-list-group-item  v-for="i in mainUgCardPools[3].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGCardPoolBlock.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGCardPoolBlock.button?UaGCardPoolBlock.button = false : UaGCardPoolBlock.button = true">{{$t('Block card')}}</b-button>
                                        <b-list-group v-if="UaGCardPoolBlock.button">
                                        <b-list-group-item  v-for="i in mainUgCardPools[4].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGCardPoolUnblock.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGCardPoolUnblock.button?UaGCardPoolUnblock.button = false : UaGCardPoolUnblock.button = true">{{$t('Unblock card')}}</b-button>
                                        <b-list-group v-if="UaGCardPoolUnblock.button">
                                        <b-list-group-item  v-for="i in mainUgCardPools[5].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGCardPoolRead.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGCardPoolRead.button?UaGCardPoolRead.button = false : UaGCardPoolRead.button = true">{{$t('Read')}}</b-button>
                                        <b-list-group v-if="UaGCardPoolRead.button">
                                        <b-list-group-item  v-for="i in mainUgCardPools[6].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGCardPoolAdd.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGCardPoolAdd.button?UaGCardPoolAdd.button = false : UaGCardPoolAdd.button = true">{{$t('Add cards')}}</b-button>
                                        <b-list-group v-if="UaGCardPoolAdd.button">
                                        <b-list-group-item  v-for="i in mainUgCardPools[7].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="UaGCardPoolSearch.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="UaGCardPoolSearch.button?UaGCardPoolSearch.button = false : UaGCardPoolSearch.button = true">{{$t('Search cards')}}</b-button>
                                        <b-list-group v-if="UaGCardPoolSearch.button">
                                        <b-list-group-item  v-for="i in mainUgCardPools[8].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                      </b-list-group>
                                    </b-list-group-item>
                                  </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="messages.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickmessages">  {{$t('Messages')}}</b-button>
                            <b-list-group v-if="messages.button">
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="msgIncoming.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clickmsgIncoming">  {{$t('Incoming')}}</b-button>
                                 <b-list-group v-if="msgIncoming.button">
                                  <b-list-group-item  v-for="i in mainMessages[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="msgOutgoing.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clickmsgOutgoing">  {{$t('Outgoing')}}</b-button>
                                <b-list-group v-if="msgOutgoing.button">
                                  <b-list-group-item  v-for="i in mainMessages[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="msgNew.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clickmsgNew">  {{$t('New')}}</b-button>
                                <b-list-group v-if="msgNew.button">
                                  <b-list-group-item  v-for="i in mainMessages[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="msgDeleted.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clickmsgDeleted">  {{$t('Deleted')}}</b-button>
                                 <b-list-group v-if="msgDeleted.button">
                                  <b-list-group-item  v-for="i in mainMessages[3].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Tariffication.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickTariffication">  {{$t('Tariffication')}}</b-button>
                              <b-list-group v-if="Tariffication.button">
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="tarifficationAccPeriod.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clicktarifficationAccPeriod">  {{$t('Accounting period')}}</b-button>
                                <b-list-group v-if="tarifficationAccPeriod.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationAccPeriodRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationAccPeriodRefresh.button?tarifficationAccPeriodRefresh.button = false : tarifficationAccPeriodRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="tarifficationAccPeriodRefresh.button">
                                  <b-list-group-item  v-for="i in mainTrfAccPer[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationAccPeriodAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationAccPeriodAdd.button?tarifficationAccPeriodAdd.button = false : tarifficationAccPeriodAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="tarifficationAccPeriodAdd.button">
                                    <b-list-group-item  v-for="i in mainTrfAccPer[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationAccPeriodRead.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationAccPeriodRead.button?tarifficationAccPeriodRead.button = false : tarifficationAccPeriodRead.button = true">{{$t('Read')}}</b-button>
                                    <b-list-group v-if="tarifficationAccPeriodRead.button">
                                    <b-list-group-item  v-for="i in mainTrfAccPer[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationAccPeriodEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationAccPeriodEdit.button?tarifficationAccPeriodEdit.button = false : tarifficationAccPeriodEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="tarifficationAccPeriodEdit.button">
                                    <b-list-group-item  v-for="i in mainTrfAccPer[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="tarifficationServices.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clicktarifficationServices">  {{$t('Services')}}</b-button>
                                <b-list-group v-if="tarifficationServices.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationServicesRefresh.check" inline></b-form-checkbox>
                                      <b-button size="sm" variant="outline-info" @click="tarifficationServicesRefresh.button?tarifficationServicesRefresh.button = false : tarifficationServicesRefresh.button = true">{{$t('Refresh')}}</b-button>
                                      <b-list-group v-if="tarifficationServicesRefresh.button">
                                      <b-list-group-item  v-for="i in mainTrfSrv[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                      <b-form-checkbox  size="sm" switch v-model="tarifficationServicesAdd.check" inline></b-form-checkbox>
                                      <b-button size="sm" variant="outline-info" @click="tarifficationServicesAdd.button?tarifficationServicesAdd.button = false : tarifficationServicesAdd.button = true">{{$t('Add')}}</b-button>
                                      <b-list-group v-if="tarifficationServicesAdd.button">
                                      <b-list-group-item  v-for="i in mainTrfSrv[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                      <b-form-checkbox  size="sm" switch v-model="tarifficationServicesEdit.check" inline></b-form-checkbox>
                                      <b-button size="sm" variant="outline-info" @click="tarifficationServicesEdit.button?tarifficationServicesEdit.button = false : tarifficationServicesEdit.button = true">{{$t('Edit')}}</b-button>
                                      <b-list-group v-if="tarifficationServicesEdit.button">
                                      <b-list-group-item  v-for="i in mainTrfSrv[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                      <b-form-checkbox  size="sm" switch v-model="tarifficationServicesDelete.check" inline></b-form-checkbox>
                                      <b-button size="sm" variant="outline-info" @click="tarifficationServicesDelete.button?tarifficationServicesDelete.button = false : tarifficationServicesDelete.button = true">{{$t('Delete')}}</b-button>
                                      <b-list-group v-if="tarifficationServicesDelete.button">
                                      <b-list-group-item  v-for="i in mainTrfSrv[3].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                    </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="tarifficationTemplServ.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clicktarifficationTemplServ">  {{$t('Template services')}}</b-button>
                                <b-list-group v-if="tarifficationTemplServ.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="clicktarifficationTemplServRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="clicktarifficationTemplServRefresh.button?clicktarifficationTemplServRefresh.button = false : clicktarifficationTemplServRefresh.button = true">{{$t('Refresh')}}</b-button>
                                     <b-list-group v-if="clicktarifficationTemplServRefresh.button">
                                      <b-list-group-item  v-for="i in mainTrfTmplSrv[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="clicktarifficationTemplServAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="clicktarifficationTemplServAdd.button?clicktarifficationTemplServAdd.button = false : clicktarifficationTemplServAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="clicktarifficationTemplServAdd.button">
                                      <b-list-group-item  v-for="i in mainTrfTmplSrv[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="clicktarifficationTemplServDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="clicktarifficationTemplServDelete.button?clicktarifficationTemplServDelete.button = false : clicktarifficationTemplServDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="clicktarifficationTemplServDelete.button">
                                      <b-list-group-item  v-for="i in mainTrfTmplSrv[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="tarifficationChargePolicies.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clicktarifficationChargePolicies">  {{$t('Charge policies')}}</b-button>
                                  <b-list-group v-if="tarifficationChargePolicies.button">
                                    <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationChargePoliciesRefresh.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationChargePoliciesRefresh.button?tarifficationChargePoliciesRefresh.button = false : tarifficationChargePoliciesRefresh.button = true">{{$t('Refresh')}}</b-button>
                                        <b-list-group v-if="tarifficationChargePoliciesRefresh.button">
                                      <b-list-group-item  v-for="i in mainTrfChP[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationChargePoliciesAdd.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationChargePoliciesAdd.button?tarifficationChargePoliciesAdd.button = false : tarifficationChargePoliciesAdd.button = true">{{$t('Add')}}</b-button>
                                        <b-list-group v-if="tarifficationChargePoliciesAdd.button">
                                      <b-list-group-item  v-for="i in mainTrfChP[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationChargePoliciesRead.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationChargePoliciesRead.button?tarifficationChargePoliciesRead.button = false : tarifficationChargePoliciesRead.button = true">{{$t('Read')}}</b-button>
                                        <b-list-group v-if="tarifficationChargePoliciesRead.button">
                                      <b-list-group-item  v-for="i in mainTrfChP[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationChargePoliciesEdit.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationChargePoliciesEdit.button?tarifficationChargePoliciesEdit.button = false : tarifficationChargePoliciesEdit.button = true">{{$t('Edit')}}</b-button>
                                        <b-list-group v-if="tarifficationChargePoliciesEdit.button">
                                      <b-list-group-item  v-for="i in mainTrfChP[3].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationChargePoliciesDelete.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationChargePoliciesDelete.button?tarifficationChargePoliciesDelete.button = false : tarifficationChargePoliciesDelete.button = true">{{$t('Delete')}}</b-button>
                                      <b-list-group v-if="tarifficationChargePoliciesDelete.button">
                                      <b-list-group-item  v-for="i in mainTrfChP[4].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                       </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="tarifficationTimeRanges.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clicktarifficationTimeRanges">  {{$t('Time ranges')}}</b-button>
                                  <b-list-group v-if="tarifficationTimeRanges.button">
                                   <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationTimeRangesRefresh.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationTimeRangesRefresh.button?tarifficationTimeRangesRefresh.button = false : tarifficationTimeRangesRefresh.button = true">{{$t('Refresh')}}</b-button>
                                       <b-list-group v-if="tarifficationTimeRangesRefresh.button">
                                      <b-list-group-item  v-for="i in mainTrfTR[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationTimeRangesAdd.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationTimeRangesAdd.button?tarifficationTimeRangesAdd.button = false : tarifficationTimeRangesAdd.button = true">{{$t('Add')}}</b-button>
                                        <b-list-group v-if="tarifficationTimeRangesAdd.button">
                                        <b-list-group-item  v-for="i in mainTrfTR[1].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationTimeRangesEdit.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationTimeRangesEdit.button?tarifficationTimeRangesEdit.button = false : tarifficationTimeRangesEdit.button = true">{{$t('Edit')}}</b-button>
                                        <b-list-group v-if="tarifficationTimeRangesEdit.button">
                                        <b-list-group-item  v-for="i in mainTrfTR[2].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationTimeRangesDelete.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationTimeRangesDelete.button?tarifficationTimeRangesDelete.button = false : tarifficationTimeRangesDelete.button = true">{{$t('Delete')}}</b-button>
                                        <b-list-group v-if="tarifficationTimeRangesDelete.button">
                                        <b-list-group-item  v-for="i in mainTrfTR[3].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="tarifficationTrafficClasses.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clicktarifficationTrafficClasses">  {{$t('Traffic classes')}}</b-button>
                                <b-list-group v-if="tarifficationTrafficClasses.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationTrafficClassesRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationTrafficClassesRefresh.button?tarifficationTrafficClassesRefresh.button = false : tarifficationTrafficClassesRefresh.button = true">{{$t('Refresh')}}</b-button>
                                     <b-list-group v-if="tarifficationTrafficClassesRefresh.button">
                                        <b-list-group-item  v-for="i in mainTrfTrfClasses[0].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                  </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationTrafficClassesAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationTrafficClassesAdd.button?tarifficationTrafficClassesAdd.button = false : tarifficationTrafficClassesAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="tarifficationTrafficClassesAdd.button">
                                        <b-list-group-item  v-for="i in mainTrfTrfClasses[1].funcs" :key="i.id">
                                          <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationTrafficClassesRead.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationTrafficClassesRead.button?tarifficationTrafficClassesRead.button = false : tarifficationTrafficClassesRead.button = true">{{$t('Read')}}</b-button>
                                    <b-list-group v-if="tarifficationTrafficClassesRead.button">
                                      <b-list-group-item  v-for="i in mainTrfTrfClasses[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationTrafficClassesEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationTrafficClassesEdit.button?tarifficationTrafficClassesEdit.button = false : tarifficationTrafficClassesEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="tarifficationTrafficClassesEdit.button">
                                      <b-list-group-item  v-for="i in mainTrfTrfClasses[3].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationTrafficClassesDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationTrafficClassesDelete.button?tarifficationTrafficClassesDelete.button = false : tarifficationTrafficClassesDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="tarifficationTrafficClassesDelete.button">
                                      <b-list-group-item  v-for="i in mainTrfTrfClasses[4].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                        </b-list-group-item>
                                      </b-list-group>
                                  </b-list-group-item>

                                  </b-list-group>
                                </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="tarifficationTariffPlans.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clicktarifficationTariffPlans">  {{$t('Tariff plans')}}</b-button>
                                <b-list-group v-if="tarifficationTariffPlans.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTariffPlansRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTariffPlansRefresh.button?tarifficationTariffPlansRefresh.button = false : tarifficationTariffPlansRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="tarifficationTariffPlansRefresh.button">
                                    <b-list-group-item  v-for="i in mainTrfTrfPlans[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTariffPlansAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTariffPlansAdd.button?tarifficationTariffPlansAdd.button = false : tarifficationTariffPlansAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="tarifficationTariffPlansAdd.button">
                                    <b-list-group-item  v-for="i in mainTrfTrfPlans[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTariffPlansRead.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTariffPlansRead.button?tarifficationTariffPlansRead.button = false : tarifficationTariffPlansRead.button = true">{{$t('Read')}}</b-button>
                                  <b-list-group v-if="tarifficationTariffPlansRead.button">
                                    <b-list-group-item  v-for="i in mainTrfTrfPlans[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTariffPlansEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTariffPlansEdit.button?tarifficationTariffPlansEdit.button = false : tarifficationTariffPlansEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="tarifficationTariffPlansEdit.button">
                                    <b-list-group-item  v-for="i in mainTrfTrfPlans[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTariffPlansDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTariffPlansDelete.button?tarifficationTariffPlansDelete.button = false : tarifficationTariffPlansDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="tarifficationTariffPlansDelete.button">
                                    <b-list-group-item  v-for="i in mainTrfTrfPlans[4].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="tarifficationTelZones.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clicktarifficationTelZones">  {{$t('Telephone zones')}}</b-button>
                                <b-list-group v-if="tarifficationTelZones.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTelZonesRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTelZonesRefresh.button?tarifficationTelZonesRefresh.button = false : tarifficationTelZonesRefresh.button = true">{{$t('Refresh')}}</b-button>
                                   <b-list-group v-if="tarifficationTelZonesRefresh.button">
                                    <b-list-group-item  v-for="i in mainTrfTelZones[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTelZonesAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTelZonesAdd.button?tarifficationTelZonesAdd.button = false : tarifficationTelZonesAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="tarifficationTelZonesAdd.button">
                                    <b-list-group-item  v-for="i in mainTrfTelZones[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTelZonesRead.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTelZonesRead.button?tarifficationTelZonesRead.button = false : tarifficationTelZonesRead.button = true">{{$t('Read')}}</b-button>
                                  <b-list-group v-if="tarifficationTelZonesRead.button">
                                    <b-list-group-item  v-for="i in mainTrfTelZones[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTelZonesEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTelZonesEdit.button?tarifficationTelZonesEdit.button = false : tarifficationTelZonesEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="tarifficationTelZonesEdit.button">
                                    <b-list-group-item  v-for="i in mainTrfTelZones[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTelZonesDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTelZonesDelete.button?tarifficationTelZonesDelete.button = false : tarifficationTelZonesDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="tarifficationTelZonesDelete.button">
                                    <b-list-group-item  v-for="i in mainTrfTelZones[4].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="tarifficationTelDirs.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clicktarifficationTelDirs">  {{$t('Telephone directions')}}</b-button>
                                <b-list-group v-if="tarifficationTelDirs.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTelDirsRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTelDirsRefresh.button?tarifficationTelDirsRefresh.button = false : tarifficationTelDirsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="tarifficationTelDirsRefresh.button">
                                    <b-list-group-item  v-for="i in mainTrfTelDirs[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTelDirsRead.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTelDirsRead.button?tarifficationTelDirsRead.button = false : tarifficationTelDirsRead.button = true">{{$t('Read')}}</b-button>
                                  <b-list-group v-if="tarifficationTelDirsRead.button">
                                    <b-list-group-item  v-for="i in mainTrfTelDirs[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTelDirsEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTelDirsEdit.button?tarifficationTelDirsEdit.button = false : tarifficationTelDirsEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="tarifficationTelDirsEdit.button">
                                    <b-list-group-item  v-for="i in mainTrfTelDirs[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTelDirsAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTelDirsAdd.button?tarifficationTelDirsAdd.button = false : tarifficationTelDirsAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="tarifficationTelDirsAdd.button">
                                    <b-list-group-item  v-for="i in mainTrfTelDirs[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="tarifficationTelDirsDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="tarifficationTelDirsDelete.button?tarifficationTelDirsDelete.button = false : tarifficationTelDirsDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="tarifficationTelDirsDelete.button">
                                    <b-list-group-item  v-for="i in mainTrfTelDirs[4].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="tarifficationCoefScheme.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clicktarifficationCoefScheme">  {{$t('Coefficient scheme')}}</b-button>
                                <b-list-group v-if="tarifficationCoefScheme.button">
                                  <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationCoefSchemeRefresh.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationCoefSchemeRefresh.button?tarifficationCoefSchemeRefresh.button = false : tarifficationCoefSchemeRefresh.button = true">{{$t('Refresh')}}</b-button>
                                        <b-list-group v-if="tarifficationCoefSchemeRefresh.button">
                                          <b-list-group-item  v-for="i in mainTrfTelCoefScheme[0].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationCoefSchemeAdd.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationCoefSchemeAdd.button?tarifficationCoefSchemeAdd.button = false : tarifficationCoefSchemeAdd.button = true">{{$t('Add')}}</b-button>
                                        <b-list-group v-if="tarifficationCoefSchemeAdd.button">
                                          <b-list-group-item  v-for="i in mainTrfTelCoefScheme[1].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationCoefSchemeEdit.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationCoefSchemeEdit.button?tarifficationCoefSchemeEdit.button = false : tarifficationCoefSchemeEdit.button = true">{{$t('Edit')}}</b-button>
                                        <b-list-group v-if="tarifficationCoefSchemeEdit.button">
                                          <b-list-group-item  v-for="i in mainTrfTelCoefScheme[2].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                       <b-list-group-item>
                                        <b-form-checkbox  size="sm" switch v-model="tarifficationCoefSchemeDelete.check" inline></b-form-checkbox>
                                        <b-button size="sm" variant="outline-info" @click="tarifficationCoefSchemeDelete.button?tarifficationCoefSchemeDelete.button = false : tarifficationCoefSchemeDelete.button = true">{{$t('Delete')}}</b-button>
                                        <b-list-group v-if="tarifficationCoefSchemeDelete.button">
                                          <b-list-group-item  v-for="i in mainTrfTelCoefScheme[3].funcs" :key="i.id">
                                            <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                          </b-list-group-item>
                                        </b-list-group>
                                       </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="tarifficationCoefSchedule.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clicktarifficationCoefScheme">  {{$t('Coefficient schedule')}}</b-button>
                                <b-list-group v-if="tarifficationCoefScheme.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationCoefScheduleRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationCoefScheduleRefresh.button?tarifficationCoefScheduleRefresh.button = false : tarifficationCoefScheduleRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="tarifficationCoefScheduleRefresh.button">
                                      <b-list-group-item  v-for="i in mainTrfTelCoefShed[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationCoefScheduleAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationCoefScheduleAdd.button?tarifficationCoefScheduleAdd.button = false : tarifficationCoefScheduleAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="tarifficationCoefScheduleAdd.button">
                                      <b-list-group-item  v-for="i in mainTrfTelCoefShed[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationCoefScheduleEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationCoefScheduleEdit.button?tarifficationCoefScheduleEdit.button = false : tarifficationCoefScheduleEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="tarifficationCoefScheduleEdit.button">
                                      <b-list-group-item  v-for="i in mainTrfTelCoefShed[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationCoefScheduleDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationCoefScheduleDelete.button?tarifficationCoefScheduleDelete.button = false : tarifficationCoefScheduleDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="tarifficationCoefScheduleDelete.button">
                                      <b-list-group-item  v-for="i in mainTrfTelCoefShed[3].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="tarifficationContractType.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clicktarifficationContractType">  {{$t('Contract type')}}</b-button>
                                <b-list-group v-if="tarifficationContractType.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationContractTypeRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationContractTypeRefresh.button?tarifficationContractTypeRefresh.button = false : tarifficationContractTypeRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="tarifficationContractTypeRefresh.button">
                                      <b-list-group-item  v-for="i in mainTrfTelContractType[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationContractTypeAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationContractTypeAdd.button?tarifficationContractTypeAdd.button = false : tarifficationContractTypeAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="tarifficationContractTypeAdd.button">
                                      <b-list-group-item  v-for="i in mainTrfTelContractType[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationContractTypeEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationContractTypeEdit.button?tarifficationContractTypeEdit.button = false : tarifficationContractTypeEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="tarifficationContractTypeEdit.button">
                                      <b-list-group-item  v-for="i in mainTrfTelContractType[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="tarifficationContractTypeDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="tarifficationContractTypeDelete.button?tarifficationContractTypeDelete.button = false : tarifficationContractTypeDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="tarifficationContractTypeDelete.button">
                                      <b-list-group-item  v-for="i in mainTrfTelContractType[3].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                          <b-form-checkbox  size="sm" switch v-model="Refbook.check" inline></b-form-checkbox>
                          <b-button size="sm" variant="outline-info" @click="clickRefbook">  {{$t('Refbook')}}</b-button>
                          <b-list-group v-if="Refbook.button">
                            <b-list-group-item>
                              <b-form-checkbox  size="sm" switch v-model="RBPaymentMethods.check" inline></b-form-checkbox>
                              <b-button size="sm" variant="outline-info" @click="click_RBPaymentMethods">  {{$t('Payment Methods')}}</b-button>
                              <b-list-group v-if="RBPaymentMethods.button">
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBPaymentMethodsRefresh.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBPaymentMethodsRefresh.button?RBPaymentMethodsRefresh.button = false : RBPaymentMethodsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                <b-list-group v-if="RBPaymentMethodsRefresh.button">
                                  <b-list-group-item  v-for="i in RefBookPaymentM[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBPaymentMethodsAdd.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBPaymentMethodsAdd.button?RBPaymentMethodsAdd.button = false : RBPaymentMethodsAdd.button = true">{{$t('Add')}}</b-button>
                                <b-list-group v-if="RBPaymentMethodsAdd.button">
                                  <b-list-group-item  v-for="i in RefBookPaymentM[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBPaymentMethodsEdit.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBPaymentMethodsEdit.button?RBPaymentMethodsEdit.button = false : RBPaymentMethodsEdit.button = true">{{$t('Edit')}}</b-button>
                                <b-list-group v-if="RBPaymentMethodsEdit.button">
                                  <b-list-group-item  v-for="i in RefBookPaymentM[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                              </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                              <b-form-checkbox  size="sm" switch v-model="RBCurrency.check" inline></b-form-checkbox>
                              <b-button size="sm" variant="outline-info" @click="click_RBCurrency">  {{$t('Currency')}}</b-button>
                              <b-list-group v-if="RBCurrency.button">
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBCurrencyRefresh.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBCurrencyRefresh.button?RBCurrencyRefresh.button = false : RBCurrencyRefresh.button = true">{{$t('Refresh')}}</b-button>
                                <b-list-group v-if="RBCurrencyRefresh.button">
                                  <b-list-group-item  v-for="i in RefBookCurrency[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBCurrencyAdd.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBCurrencyAdd.button?RBCurrencyAdd.button = false : RBCurrencyAdd.button = true">{{$t('Add')}}</b-button>
                                <b-list-group v-if="RBCurrencyAdd.button">
                                  <b-list-group-item  v-for="i in RefBookCurrency[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBCurrencyEdit.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBCurrencyEdit.button?RBCurrencyEdit.button = false : RBCurrencyEdit.button = true">{{$t('Edit')}}</b-button>
                                <b-list-group v-if="RBCurrencyEdit.button">
                                  <b-list-group-item  v-for="i in RefBookCurrency[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBCurrencyDelete.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBCurrencyDelete.button?RBCurrencyDelete.button = false : RBCurrencyDelete.button = true">{{$t('Delete')}}</b-button>
                                <b-list-group v-if="RBCurrencyDelete.button">
                                  <b-list-group-item  v-for="i in RefBookCurrency[3].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                              </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                              <b-form-checkbox  size="sm" switch v-model="RBBuildings.check" inline></b-form-checkbox>
                              <b-button size="sm" variant="outline-info" @click="click_RBBuildings">  {{$t('Buildings')}}</b-button>
                              <b-list-group v-if="RBBuildings.button">
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBBuildingsRefresh.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBBuildingsRefresh.button?RBBuildingsRefresh.button = false : RBBuildingsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                <b-list-group v-if="RBBuildingsRefresh.button">
                                  <b-list-group-item  v-for="i in RefBookBuildings[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBBuildingsAdd.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBBuildingsAdd.button?RBBuildingsAdd.button = false : RBBuildingsAdd.button = true">{{$t('Add')}}</b-button>
                                <b-list-group v-if="RBBuildingsAdd.button">
                                  <b-list-group-item  v-for="i in RefBookBuildings[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBBuildingsRead.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBBuildingsRead.button?RBBuildingsRead.button = false : RBBuildingsRead.button = true">{{$t('Read')}}</b-button>
                                <b-list-group v-if="RBBuildingsRead.button">
                                  <b-list-group-item  v-for="i in RefBookBuildings[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBBuildingsEdit.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBBuildingsEdit.button?RBBuildingsEdit.button = false : RBBuildingsEdit.button = true">{{$t('Edit')}}</b-button>
                                <b-list-group v-if="RBBuildingsEdit.button">
                                  <b-list-group-item  v-for="i in RefBookBuildings[3].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBBuildingsDelete.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBBuildingsDelete.button?RBBuildingsDelete.button = false : RBBuildingsDelete.button = true">{{$t('Delete')}}</b-button>
                                <b-list-group v-if="RBBuildingsDelete.button">
                                  <b-list-group-item  v-for="i in RefBookBuildings[4].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                              </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                              <b-form-checkbox  size="sm" switch v-model="RBStreets.check" inline></b-form-checkbox>
                              <b-button size="sm" variant="outline-info" @click="click_RBStreets">  {{$t('Streets')}}</b-button>
                              <b-list-group v-if="RBStreets.button">
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBStreetsRefresh.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBStreetsRefresh.button?RBStreetsRefresh.button = false : RBStreetsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                <b-list-group v-if="RBStreetsRefresh.button">
                                  <b-list-group-item  v-for="i in RefBookStreets[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBStreetsAdd.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBStreetsAdd.button?RBStreetsAdd.button = false : RBStreetsAdd.button = true">{{$t('Add')}}</b-button>
                                <b-list-group v-if="RBStreetsAdd.button">
                                  <b-list-group-item  v-for="i in RefBookStreets[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBStreetsRead.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBStreetsRead.button?RBStreetsRead.button = false : RBStreetsRead.button = true">{{$t('Read')}}</b-button>
                                <b-list-group v-if="RBStreetsRead.button">
                                  <b-list-group-item  v-for="i in RefBookStreets[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBStreetsEdit.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBStreetsEdit.button?RBStreetsEdit.button = false : RBStreetsEdit.button = true">{{$t('Edit')}}</b-button>
                                <b-list-group v-if="RBStreetsEdit.button">
                                  <b-list-group-item  v-for="i in RefBookStreets[3].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBStreetsDelete.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBStreetsDelete.button?RBStreetsDelete.button = false : RBStreetsDelete.button = true">{{$t('Delete')}}</b-button>
                                <b-list-group v-if="RBStreetsDelete.button">
                                  <b-list-group-item  v-for="i in RefBookStreets[4].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                              </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                              <b-form-checkbox  size="sm" switch v-model="RBBanks.check" inline></b-form-checkbox>
                              <b-button size="sm" variant="outline-info" @click="click_RBBanks">  {{$t('Banks')}}</b-button>
                              <b-list-group v-if="RBBanks.button">
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBBanksRefresh.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBBanksRefresh.button?RBBanksRefresh.button = false : RBBanksRefresh.button = true">{{$t('Refresh')}}</b-button>
                                <b-list-group v-if="RBBanksRefresh.button">
                                  <b-list-group-item  v-for="i in RefBookBanks[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBBanksAdd.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBBanksAdd.button?RBBanksAdd.button = false : RBBanksAdd.button = true">{{$t('Add')}}</b-button>
                                <b-list-group v-if="RBBanksAdd.button">
                                  <b-list-group-item  v-for="i in RefBookBanks[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBBanksEdit.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBBanksEdit.button?RBBanksEdit.button = false : RBBanksEdit.button = true">{{$t('Edit')}}</b-button>
                                <b-list-group v-if="RBBanksEdit.button">
                                  <b-list-group-item  v-for="i in RefBookBanks[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBBanksDelete.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="RBBanksDelete.button?RBBanksDelete.button = false : RBBanksDelete.button = true">{{$t('Delete')}}</b-button>
                                <b-list-group v-if="RBBanksDelete.button">
                                  <b-list-group-item  v-for="i in RefBookBanks[3].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                              </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="RBIPzones.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_RBIPzones">  {{$t('IP zones')}}</b-button>
                                <b-list-group v-if="RBIPzones.button">
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="RBIPzonesRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="RBIPzonesRefresh.button?RBIPzonesRefresh.button = false : RBIPzonesRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="RBIPzonesRefresh.button">
                                  <b-list-group-item  v-for="i in RefBookIPzones[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="RBIPzonesAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="RBIPzonesAdd.button?RBIPzonesAdd.button = false : RBIPzonesAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="RBIPzonesAdd.button">
                                  <b-list-group-item  v-for="i in RefBookIPzones[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="RBIPzonesRead.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="RBIPzonesRead.button?RBIPzonesRead.button = false : RBIPzonesRead.button = true">{{$t('Read')}}</b-button>
                                  <b-list-group v-if="RBIPzonesRead.button">
                                  <b-list-group-item  v-for="i in RefBookIPzones[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="RBIPzonesEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="RBIPzonesEdit.button?RBIPzonesEdit.button = false : RBIPzonesEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="RBIPzonesEdit.button">
                                  <b-list-group-item  v-for="i in RefBookIPzones[3].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                          </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Settings.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickSettings">  {{$t('Settings')}}</b-button>
                            <b-list-group v-if="Settings.button">
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsParameters.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsParameters">  {{$t('Parameters')}}</b-button>
                                <b-list-group v-if="StgsParameters.button">
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsParametersRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsParametersRefresh.button?StgsParametersRefresh.button = false : StgsParametersRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="StgsParametersRefresh.button">
                                  <b-list-group-item  v-for="i in SettingsParameters[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsAddParams.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsAddParams">  {{$t('Additional Parameters')}}</b-button>
                                <b-list-group v-if="StgsAddParams.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsAddParamsRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsAddParamsRefresh.button?StgsAddParamsRefresh.button = false : StgsAddParamsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="StgsAddParamsRefresh.button">
                                  <b-list-group-item  v-for="i in SettingsAdditionalParameters[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsAddParamsAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsAddParamsAdd.button?StgsAddParamsAdd.button = false : StgsAddParamsAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="StgsAddParamsAdd.button">
                                  <b-list-group-item  v-for="i in SettingsAdditionalParameters[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsAddParamsEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsAddParamsEdit.button?StgsAddParamsEdit.button = false : StgsAddParamsEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="StgsAddParamsEdit.button">
                                  <b-list-group-item  v-for="i in SettingsAdditionalParameters[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsAddParamsDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsAddParamsDelete.button?StgsAddParamsDelete.button = false : StgsAddParamsDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="StgsAddParamsDelete.button">
                                  <b-list-group-item  v-for="i in SettingsAdditionalParameters[3].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsFirewalls.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsFirewalls">  {{$t('Firewalls')}}</b-button>
                                <b-list-group v-if="StgsFirewalls.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsFirewallsRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsFirewallsRefresh.button?StgsFirewallsRefresh.button = false : StgsFirewallsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="StgsFirewallsRefresh.button">
                                  <b-list-group-item  v-for="i in SettingsFirewalls[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsFirewallsAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsFirewallsAdd.button?StgsFirewallsAdd.button = false : StgsFirewallsAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="StgsFirewallsAdd.button">
                                  <b-list-group-item  v-for="i in SettingsFirewalls[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsFirewallsEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsFirewallsEdit.button?StgsFirewallsEdit.button = false : StgsFirewallsEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="StgsFirewallsEdit.button">
                                  <b-list-group-item  v-for="i in SettingsFirewalls[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsFirewallsDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsFirewallsDelete.button?StgsFirewallsDelete.button = false : StgsFirewallsDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="StgsFirewallsDelete.button">
                                  <b-list-group-item  v-for="i in SettingsFirewalls[3].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsFrwRoles.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsFrwRoles">  {{$t('Firewall rules')}}</b-button>
                                <b-list-group v-if="StgsFrwRoles.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsFrwRolesRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsFrwRolesRefresh.button?StgsFrwRolesRefresh.button = false : StgsFrwRolesRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="StgsFrwRolesRefresh.button">
                                  <b-list-group-item  v-for="i in SettingsFirewallrules[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsFrwRolesAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsFrwRolesAdd.button?StgsFrwRolesAdd.button = false : StgsFrwRolesAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="StgsFrwRolesAdd.button">
                                  <b-list-group-item  v-for="i in SettingsFirewallrules[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsFrwRolesEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsFrwRolesEdit.button?StgsFrwRolesEdit.button = false : StgsFrwRolesEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="StgsFrwRolesEdit.button">
                                  <b-list-group-item  v-for="i in SettingsFirewallrules[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsFrwRolesDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsFrwRolesDelete.button?StgsFrwRolesDelete.button = false : StgsFrwRolesDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="StgsFrwRolesDelete.button">
                                  <b-list-group-item  v-for="i in SettingsFirewallrules[3].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsNASlist.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsNASlist">  {{$t('NAS List')}}</b-button>
                                <b-list-group v-if="StgsNASlist.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsNASlistRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsNASlistRefresh.button?StgsNASlistRefresh.button = false : StgsNASlistRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="StgsNASlistRefresh.button">
                                  <b-list-group-item  v-for="i in SettingsNASList[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsNASlistAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsNASlistAdd.button?StgsNASlistAdd.button = false : StgsNASlistAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="StgsNASlistAdd.button">
                                  <b-list-group-item  v-for="i in SettingsNASList[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsNASlistRead.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsNASlistRead.button?StgsNASlistRead.button = false : StgsNASlistRead.button = true">{{$t('Read')}}</b-button>
                                  <b-list-group v-if="StgsNASlistRead.button">
                                  <b-list-group-item  v-for="i in SettingsNASList[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsNASlistEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsNASlistEdit.button?StgsNASlistEdit.button = false : StgsNASlistEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="StgsNASlistEdit.button">
                                    <b-list-group-item  v-for="i in SettingsNASList[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsNASlistDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsNASlistDelete.button?StgsNASlistDelete.button = false : StgsNASlistDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="StgsNASlistDelete.button">
                                    <b-list-group-item  v-for="i in SettingsNASList[4].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsISGprofile.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsISGprofile">  {{$t('ISG profile')}}</b-button>
                                <b-list-group v-if="StgsISGprofile.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsISGprofileRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsISGprofileRefresh.button?StgsISGprofileRefresh.button = false : StgsISGprofileRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="StgsISGprofileRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsISGprofile[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsISGprofileAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsISGprofileAdd.button?StgsISGprofileAdd.button = false : StgsISGprofileAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="StgsISGprofileAdd.button">
                                    <b-list-group-item  v-for="i in SettingsISGprofile[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsISGprofileRead.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsISGprofileRead.button?StgsISGprofileRead.button = false : StgsISGprofileRead.button = true">{{$t('Read')}}</b-button>
                                    <b-list-group v-if="StgsISGprofileRead.button">
                                    <b-list-group-item  v-for="i in SettingsISGprofile[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsISGprofileEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsISGprofileEdit.button?StgsISGprofileEdit.button = false : StgsISGprofileEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="StgsISGprofileEdit.button">
                                    <b-list-group-item  v-for="i in SettingsISGprofile[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsISGprofileDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsISGprofileDelete.button?StgsISGprofileDelete.button = false : StgsISGprofileDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="StgsISGprofileDelete.button">
                                    <b-list-group-item  v-for="i in SettingsISGprofile[4].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsISGAttr.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsISGAttr">  {{$t('ISG attributes')}}</b-button>
                                <b-list-group v-if="StgsISGAttr.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsISGAttrRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsISGAttrRefresh.button?StgsISGAttrRefresh.button = false : StgsISGAttrRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="StgsISGAttrRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsISGattributes[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsISGAttrAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsISGAttrAdd.button?StgsISGAttrAdd.button = false : StgsISGAttrAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="StgsISGAttrAdd.button">
                                    <b-list-group-item  v-for="i in SettingsISGattributes[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsISGAttrRead.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsISGAttrRead.button?StgsISGAttrRead.button = false : StgsISGAttrRead.button = true">{{$t('Read')}}</b-button>
                                  <b-list-group v-if="StgsISGAttrRead.button">
                                    <b-list-group-item  v-for="i in SettingsISGattributes[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsISGAttrEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsISGAttrEdit.button?StgsISGAttrEdit.button = false : StgsISGAttrEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="StgsISGAttrEdit.button">
                                    <b-list-group-item  v-for="i in SettingsISGattributes[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsISGAttrDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsISGAttrDelete.button?StgsISGAttrDelete.button = false : StgsISGAttrDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="StgsISGAttrDelete.button">
                                    <b-list-group-item  v-for="i in SettingsISGattributes[4].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsDocTemplates.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsDocTemplates">  {{$t('Document Templates')}}</b-button>
                                <b-list-group v-if="StgsDocTemplates.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsDocTemplatesRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsDocTemplatesRefresh.button?StgsDocTemplatesRefresh.button = false : StgsDocTemplatesRefresh.button = true">{{$t('Refresh')}}</b-button>
                                     <b-list-group v-if="StgsDocTemplatesRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsDocumentTemplates[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsDocTemplatesAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsDocTemplatesAdd.button?StgsDocTemplatesAdd.button = false : StgsDocTemplatesAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="StgsDocTemplatesAdd.button">
                                    <b-list-group-item  v-for="i in SettingsDocumentTemplates[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsDocTemplatesDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsDocTemplatesDelete.button?StgsDocTemplatesDelete.button = false : StgsDocTemplatesDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="StgsDocTemplatesDelete.button">
                                    <b-list-group-item  v-for="i in SettingsDocumentTemplates[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsDocTemplatesRead.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsDocTemplatesRead.button?StgsDocTemplatesRead.button = false : StgsDocTemplatesRead.button = true">{{$t('Read')}}</b-button>
                                    <b-list-group v-if="StgsDocTemplatesRead.button">
                                    <b-list-group-item  v-for="i in SettingsDocumentTemplates[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsDocTemplatesEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsDocTemplatesEdit.button?StgsDocTemplatesEdit.button = false : StgsDocTemplatesEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="StgsDocTemplatesEdit.button">
                                    <b-list-group-item  v-for="i in SettingsDocumentTemplates[4].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsDocTemplatesOthers.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsDocTemplatesOthers.button?StgsDocTemplatesOthers.button = false : StgsDocTemplatesOthers.button = true">{{$t('Others')}}</b-button>
                                    <b-list-group v-if="StgsDocTemplatesOthers.button">
                                    <b-list-group-item  v-for="i in SettingsDocumentTemplates[5].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsProfilesDocs.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsProfilesDocs">  {{$t('Profiles of documents')}}</b-button>
                                <b-list-group v-if="StgsProfilesDocs.button">
                                <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsProfilesDocsRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsProfilesDocsRefresh.button?StgsProfilesDocsRefresh.button = false : StgsProfilesDocsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="StgsProfilesDocsRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsProfiles[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsProfilesDocsAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsProfilesDocsAdd.button?StgsProfilesDocsAdd.button = false : StgsProfilesDocsAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="StgsProfilesDocsAdd.button">
                                    <b-list-group-item  v-for="i in SettingsProfiles[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsProfilesDocsDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsProfilesDocsDelete.button?StgsProfilesDocsDelete.button = false : StgsProfilesDocsDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="StgsProfilesDocsDelete.button">
                                    <b-list-group-item  v-for="i in SettingsProfiles[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsProfilesDocsRead.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsProfilesDocsRead.button?StgsProfilesDocsRead.button = false : StgsProfilesDocsRead.button = true">{{$t('Read')}}</b-button>
                                    <b-list-group v-if="StgsProfilesDocsRead.button">
                                    <b-list-group-item  v-for="i in SettingsProfiles[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsProfilesDocsEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsProfilesDocsEdit.button?StgsProfilesDocsEdit.button = false : StgsProfilesDocsEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="StgsProfilesDocsEdit.button">
                                    <b-list-group-item  v-for="i in SettingsProfiles[4].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsReplInDoc.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsReplInDoc">  {{$t('Replacements in document')}}</b-button>
                                <b-list-group v-if="StgsReplInDoc.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsReplInDocRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsReplInDocRefresh.button?StgsReplInDocRefresh.button = false : StgsReplInDocRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="StgsReplInDocRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsReplacements[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsReplInDocAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsReplInDocAdd.button?StgsReplInDocAdd.button = false : StgsReplInDocAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="StgsReplInDocAdd.button">
                                    <b-list-group-item  v-for="i in SettingsReplacements[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsReplInDocDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsReplInDocDelete.button?StgsReplInDocDelete.button = false : StgsReplInDocDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="StgsReplInDocDelete.button">
                                    <b-list-group-item  v-for="i in SettingsReplacements[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsReplInDocEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsReplInDocEdit.button?StgsReplInDocEdit.button = false : StgsReplInDocEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="StgsReplInDocEdit.button">
                                    <b-list-group-item  v-for="i in SettingsReplacements[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsIpPools.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsIpPools">  {{$t('IP Pools')}}</b-button>
                                <b-list-group v-if="StgsIpPools.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsIpPoolsRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsIpPoolsRefresh.button?StgsIpPoolsRefresh.button = false : StgsIpPoolsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="StgsIpPoolsRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsIPPools[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsIpPoolsAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsIpPoolsAdd.button?StgsIpPoolsAdd.button = false : StgsIpPoolsAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="StgsIpPoolsAdd.button">
                                    <b-list-group-item  v-for="i in SettingsIPPools[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsIpPoolsRead.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsIpPoolsRead.button?StgsIpPoolsRead.button = false : StgsIpPoolsRead.button = true">{{$t('Read')}}</b-button>
                                  <b-list-group v-if="StgsIpPoolsRead.button">
                                    <b-list-group-item  v-for="i in SettingsIPPools[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsIpPoolsEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsIpPoolsEdit.button?StgsIpPoolsEdit.button = false : StgsIpPoolsEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="StgsIpPoolsEdit.button">
                                    <b-list-group-item  v-for="i in SettingsIPPools[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsIpPoolsDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsIpPoolsDelete.button?StgsIpPoolsDelete.button = false : StgsIpPoolsDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="StgsIpPoolsDelete.button">
                                    <b-list-group-item  v-for="i in SettingsIPPools[4].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsDynamicShaping.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsDynamicShaping">  {{$t('Dynamic shaping')}}</b-button>
                                <b-list-group v-if="StgsDynamicShaping.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsDynamicShapingRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsDynamicShapingRefresh.button?StgsDynamicShapingRefresh.button = false : StgsDynamicShapingRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="StgsDynamicShapingRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsDynamicshaping[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsDynamicShapingAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsDynamicShapingAdd.button?StgsDynamicShapingAdd.button = false : StgsDynamicShapingAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="StgsDynamicShapingAdd.button">
                                    <b-list-group-item  v-for="i in SettingsDynamicshaping[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsDynamicShapingRead.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsDynamicShapingRead.button?StgsDynamicShapingRead.button = false : StgsDynamicShapingRead.button = true">{{$t('Read')}}</b-button>
                                    <b-list-group v-if="StgsDynamicShapingRead.button">
                                    <b-list-group-item  v-for="i in SettingsDynamicshaping[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsDynamicShapingEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsDynamicShapingEdit.button?StgsDynamicShapingEdit.button = false : StgsDynamicShapingEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="StgsDynamicShapingEdit.button">
                                    <b-list-group-item  v-for="i in SettingsDynamicshaping[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsDynamicShapingDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsDynamicShapingDelete.button?StgsDynamicShapingDelete.button = false : StgsDynamicShapingDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="StgsDynamicShapingDelete.button">
                                    <b-list-group-item  v-for="i in SettingsDynamicshaping[4].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsCompanies.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsCompanies">  {{$t('Companies')}}</b-button>
                                <b-list-group v-if="StgsCompanies.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsCompaniesRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsCompaniesRefresh.button?StgsCompaniesRefresh.button = false : StgsCompaniesRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="StgsCompaniesRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsCompanies[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsCompaniesAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsCompaniesAdd.button?StgsCompaniesAdd.button = false : StgsCompaniesAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="StgsCompaniesAdd.button">
                                    <b-list-group-item  v-for="i in SettingsCompanies[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsCompaniesRead.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsCompaniesRead.button?StgsCompaniesRead.button = false : StgsCompaniesRead.button = true">{{$t('Read')}}</b-button>
                                  <b-list-group v-if="StgsCompaniesRead.button">
                                    <b-list-group-item  v-for="i in SettingsCompanies[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsCompaniesEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsCompaniesEdit.button?StgsCompaniesEdit.button = false : StgsCompaniesEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="StgsCompaniesEdit.button">
                                    <b-list-group-item  v-for="i in SettingsCompanies[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsCompaniesDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsCompaniesDelete.button?StgsCompaniesDelete.button = false : StgsCompaniesDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="StgsCompaniesDelete.button">
                                    <b-list-group-item  v-for="i in SettingsCompanies[4].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsTelOperators.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsTelOperators">  {{$t('Telephone operators')}}</b-button>
                                <b-list-group v-if="StgsTelOperators.button">
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsTelOperatorsRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsTelOperatorsRefresh.button?StgsTelOperatorsRefresh.button = false : StgsTelOperatorsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="StgsTelOperatorsRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsTelephoneoperators[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsTelOperatorsAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsTelOperatorsAdd.button?StgsTelOperatorsAdd.button = false : StgsTelOperatorsAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="StgsTelOperatorsAdd.button">
                                    <b-list-group-item  v-for="i in SettingsTelephoneoperators[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsTelOperatorsRead.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsTelOperatorsRead.button?StgsTelOperatorsRead.button = false : StgsTelOperatorsRead.button = true">{{$t('Read')}}</b-button>
                                  <b-list-group v-if="StgsTelOperatorsRead.button">
                                    <b-list-group-item  v-for="i in SettingsTelephoneoperators[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsTelOperatorsEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsTelOperatorsEdit.button?StgsTelOperatorsEdit.button = false : StgsTelOperatorsEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="StgsTelOperatorsEdit.button">
                                    <b-list-group-item  v-for="i in SettingsTelephoneoperators[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsTelOperatorsDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsTelOperatorsDelete.button?StgsTelOperatorsDelete.button = false : StgsTelOperatorsDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="StgsCompaniesDelete.button">
                                    <b-list-group-item  v-for="i in SettingsTelephoneoperators[4].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsEmrgsCalls.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsEmrgsCalls">  {{$t('Emergency Calls')}}</b-button>
                                <b-list-group v-if="StgsEmrgsCalls.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsEmrgsCallsRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsEmrgsCallsRefresh.button?StgsEmrgsCallsRefresh.button = false : StgsEmrgsCallsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="StgsEmrgsCallsRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsEmergencyCalls[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsEmrgsCallsEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsEmrgsCallsEdit.button?StgsEmrgsCallsEdit.button = false : StgsEmrgsCallsEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="StgsEmrgsCallsEdit.button">
                                    <b-list-group-item  v-for="i in SettingsEmergencyCalls[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsEmrgsCallsDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsEmrgsCallsDelete.button?StgsEmrgsCallsDelete.button = false : StgsEmrgsCallsDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="StgsEmrgsCallsDelete.button">
                                    <b-list-group-item  v-for="i in SettingsEmergencyCalls[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsEmrgsCallsAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsEmrgsCallsAdd.button?StgsEmrgsCallsAdd.button = false : StgsEmrgsCallsAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="StgsEmrgsCallsAdd.button">
                                    <b-list-group-item  v-for="i in SettingsEmergencyCalls[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsRadAccs.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsRadAccs">  {{$t('RADIUS accounts')}}</b-button>
                                <b-list-group v-if="StgsRadAccs.button">
                                <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsRadAccsRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsRadAccsRefresh.button?StgsRadAccsRefresh.button = false : StgsRadAccsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="StgsRadAccsRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsRADIUSaccounts[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsRadAccsAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsRadAccsAdd.button?StgsRadAccsAdd.button = false : StgsRadAccsAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="StgsRadAccsAdd.button">
                                    <b-list-group-item  v-for="i in SettingsRADIUSaccounts[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsRadAccsEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsRadAccsEdit.button?StgsRadAccsEdit.button = false : StgsRadAccsEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="StgsRadAccsEdit.button">
                                    <b-list-group-item  v-for="i in SettingsRADIUSaccounts[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsRadAccsDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsRadAccsDelete.button?StgsRadAccsDelete.button = false : StgsRadAccsDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="StgsRadAccsDelete.button">
                                    <b-list-group-item  v-for="i in SettingsRADIUSaccounts[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsArchiveDB.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsArchiveDB">  {{$t('Archive DB')}}</b-button>
                                <b-list-group v-if="StgsArchiveDB.button">
                                    <b-list-group-item  v-for="i in SettingsArchiveDB[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsNetFlowProvider.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsNetFlowProvider">  {{$t('NetFlow Providers')}}</b-button>
                                <b-list-group v-if="StgsNetFlowProvider.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsNetFlowProviderRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsNetFlowProviderRefresh.button?StgsNetFlowProviderRefresh.button = false : StgsNetFlowProviderRefresh.button = true">{{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="StgsNetFlowProviderRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsNetFlowProviders[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsNetFlowProviderAdd.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsNetFlowProviderAdd.button?StgsNetFlowProviderAdd.button = false : StgsNetFlowProviderAdd.button = true">{{$t('Add')}}</b-button>
                                  <b-list-group v-if="StgsNetFlowProviderAdd.button">
                                    <b-list-group-item  v-for="i in SettingsNetFlowProviders[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsNetFlowProviderEdit.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsNetFlowProviderEdit.button?StgsNetFlowProviderEdit.button = false : StgsNetFlowProviderEdit.button = true">{{$t('Edit')}}</b-button>
                                  <b-list-group v-if="StgsNetFlowProviderEdit.button">
                                    <b-list-group-item  v-for="i in SettingsNetFlowProviders[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                  <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="StgsNetFlowProviderDelete.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="StgsNetFlowProviderDelete.button?StgsNetFlowProviderDelete.button = false : StgsNetFlowProviderDelete.button = true">{{$t('Delete')}}</b-button>
                                  <b-list-group v-if="StgsNetFlowProviderDelete.button">
                                    <b-list-group-item  v-for="i in SettingsNetFlowProviders[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="StgsTrafficCollectors.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="click_StgsTrafficCollectors">  {{$t('Traffic collectors')}}</b-button>
                                <b-list-group v-if="StgsTrafficCollectors.button">
                                <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsTrafficCollectorsRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsTrafficCollectorsRefresh.button?StgsTrafficCollectorsRefresh.button = false : StgsTrafficCollectorsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="StgsTrafficCollectorsRefresh.button">
                                    <b-list-group-item  v-for="i in SettingsTrafficcollectors[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsTrafficCollectorsAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsTrafficCollectorsAdd.button?StgsTrafficCollectorsAdd.button = false : StgsTrafficCollectorsAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="StgsTrafficCollectorsAdd.button">
                                    <b-list-group-item  v-for="i in SettingsTrafficcollectors[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsTrafficCollectorsEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsTrafficCollectorsEdit.button?StgsTrafficCollectorsEdit.button = false : StgsTrafficCollectorsEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="StgsTrafficCollectorsEdit.button">
                                    <b-list-group-item  v-for="i in SettingsTrafficcollectors[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="StgsTrafficCollectorsDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="StgsTrafficCollectorsDelete.button?StgsTrafficCollectorsDelete.button = false : StgsTrafficCollectorsDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="StgsTrafficCollectorsDelete.button">
                                    <b-list-group-item  v-for="i in SettingsTrafficcollectors[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Additional.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickAdditional">  {{$t('Additional')}}</b-button>
                            <b-list-group v-if="Additional.button">
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="AdditionalSymbols.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="AdditionalSymbols.button ? AdditionalSymbols.button = false : AdditionalSymbols.button = true">  {{$t('Symbols')}}</b-button>
                                <b-list-group v-if="AdditionalSymbols.button">
                                  <b-list-group-item  v-for="i in MainAddSymbols[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="AdditionalLibURFAPlugins.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="AdditionalLibURFAPlugins.button ? AdditionalLibURFAPlugins.button = false : AdditionalLibURFAPlugins.button = true">  {{$t('LibURFA Plugins')}}</b-button>
                                <b-list-group v-if="AdditionalLibURFAPlugins.button">
                                <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="AdditionalLibURFAPluginsRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="AdditionalLibURFAPluginsRefresh.button?AdditionalLibURFAPluginsRefresh.button = false : AdditionalLibURFAPluginsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                   <b-list-group v-if="AdditionalLibURFAPluginsRefresh.button">
                                    <b-list-group-item  v-for="i in MainAddLibURFA[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="AdditionalLibURFAPluginsLoad.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="AdditionalLibURFAPluginsLoad.button?AdditionalLibURFAPluginsLoad.button = false : AdditionalLibURFAPluginsLoad.button = true">{{$t('Load')}}</b-button>
                                <b-list-group v-if="AdditionalLibURFAPluginsLoad.button">
                                  <b-list-group-item  v-for="i in MainAddLibURFA[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="AdditionalLibURFAPluginsUnload.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="AdditionalLibURFAPluginsUnload.button?AdditionalLibURFAPluginsUnload.button = false : AdditionalLibURFAPluginsUnload.button = true">{{$t('Unload')}}</b-button>
                                <b-list-group v-if="AdditionalLibURFAPluginsUnload.button">
                                  <b-list-group-item  v-for="i in MainAddLibURFA[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="AdditionalLibURFAPluginsReload.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="AdditionalLibURFAPluginsReload.button?AdditionalLibURFAPluginsReload.button = false : AdditionalLibURFAPluginsReload.button = true">{{$t('Reload')}}</b-button>
                                <b-list-group v-if="AdditionalLibURFAPluginsReload.button">
                                  <b-list-group-item  v-for="i in MainAddLibURFA[3].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                                </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="AdditionalConnections.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="AdditionalConnections.button ? AdditionalConnections.button = false : AdditionalConnections.button = true">  {{$t('Connections')}}</b-button>
                                <b-list-group v-if="AdditionalConnections.button">
                                  <b-list-group-item  v-for="i in MainAddConn[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="AdditionalHSsession.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="AdditionalHSsession.button ? AdditionalHSsession.button = false : AdditionalHSsession.button = true">  {{$t('Hotspot Sessions')}}</b-button>
                                <b-list-group v-if="AdditionalHSsession.button">
                                  <b-list-group-item  v-for="i in MainAddHotspotSessions[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="AdditionalRadSession.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="AdditionalRadSession.button ? AdditionalRadSession.button = false : AdditionalRadSession.button = true">  {{$t('RADIUS Sessions')}}</b-button>
                                <b-list-group v-if="AdditionalRadSession.button">
                                  <b-list-group-item  v-for="i in MainAddRADIUSSessions[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="AdditionalRadAttrs.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="AdditionalRadAttrs.button ? AdditionalRadAttrs.button = false : AdditionalRadAttrs.button = true">  {{$t('RADIUS Attributes')}}</b-button>
                                <b-list-group v-if="AdditionalRadAttrs.button">
                                  <b-list-group-item  v-for="i in MainAddRADIUSAttributes[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="AdditionalChangePass.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="AdditionalChangePass.button ? AdditionalChangePass.button = false : AdditionalChangePass.button = true">  {{$t('Change password')}}</b-button>
                                <b-list-group v-if="AdditionalChangePass.button">
                                  <b-list-group-item  v-for="i in MainAddChangepassword[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                            </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Interfaces.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickInterfaces">  {{$t('Interfaces')}}</b-button>
                            <b-list-group v-if="Interfaces.button">
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="InterfacesTraysettings.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="InterfacesTraysettings.button ? InterfacesTraysettings.button = false : InterfacesTraysettings.button = true">  {{$t('Tray settings')}}</b-button>
                                  <b-list-group v-if="InterfacesTraysettings.button">
                                  <b-list-group-item  v-for="i in MainInterfaceTray[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="InterfacesCashierSettings.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="InterfacesCashierSettings.button ? InterfacesCashierSettings.button = false : InterfacesCashierSettings.button = true">  {{$t('Cashier Settings')}}</b-button>
                                  <b-list-group v-if="InterfacesCashierSettings.button">
                                  <b-list-group-item  v-for="i in MainInterfaceCashier[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="InterfacesSwitchtariff.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="InterfacesSwitchtariff.button ? InterfacesSwitchtariff.button = false : InterfacesSwitchtariff.button = true">  {{$t('Switch tariff')}}</b-button>
                                  <b-list-group v-if="InterfacesSwitchtariff.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesSwitchtariffRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesSwitchtariffRefresh.button?InterfacesSwitchtariffRefresh.button = false : InterfacesSwitchtariffRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="InterfacesSwitchtariffRefresh.button">
                                    <b-list-group-item  v-for="i in MainInterfaceSwitch[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesSwitchtariffAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesSwitchtariffAdd.button?InterfacesSwitchtariffAdd.button = false : InterfacesSwitchtariffAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="InterfacesSwitchtariffAdd.button">
                                    <b-list-group-item  v-for="i in MainInterfaceSwitch[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesSwitchtariffEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesSwitchtariffEdit.button?InterfacesSwitchtariffEdit.button = false : InterfacesSwitchtariffEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="InterfacesSwitchtariffEdit.button">
                                    <b-list-group-item  v-for="i in MainInterfaceSwitch[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesSwitchtariffDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesSwitchtariffDelete.button?InterfacesSwitchtariffDelete.button = false : InterfacesSwitchtariffDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="InterfacesSwitchtariffDelete.button">
                                    <b-list-group-item  v-for="i in MainInterfaceSwitch[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="InterfacesVoluntary.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="InterfacesVoluntary.button ? InterfacesVoluntary.button = false : InterfacesVoluntary.button = true">  {{$t('Voluntary suspension')}}</b-button>
                                  <b-list-group v-if="InterfacesVoluntary.button">
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesVoluntaryRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesVoluntaryRefresh.button?InterfacesVoluntaryRefresh.button = false : InterfacesVoluntaryRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="InterfacesVoluntaryRefresh.button">
                                    <b-list-group-item  v-for="i in MainInterfaceVoluntary[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesVoluntaryAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesVoluntaryAdd.button?InterfacesVoluntaryAdd.button = false : InterfacesVoluntaryAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="InterfacesVoluntaryAdd.button">
                                    <b-list-group-item  v-for="i in MainInterfaceVoluntary[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesVoluntaryEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesVoluntaryEdit.button?InterfacesVoluntaryEdit.button = false : InterfacesVoluntaryEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="InterfacesVoluntaryEdit.button">
                                    <b-list-group-item  v-for="i in MainInterfaceVoluntary[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesVoluntaryDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesVoluntaryDelete.button?InterfacesVoluntaryDelete.button = false : InterfacesVoluntaryDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="InterfacesVoluntaryDelete.button">
                                    <b-list-group-item  v-for="i in MainInterfaceVoluntary[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="InterfacesPromised.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="InterfacesPromised.button ? InterfacesPromised.button = false : InterfacesPromised.button = true">  {{$t('Promised payments')}}</b-button>
                                  <b-list-group v-if="InterfacesPromised.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesPromisedRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesPromisedRefresh.button?InterfacesPromisedRefresh.button = false : InterfacesPromisedRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="InterfacesPromisedRefresh.button">
                                    <b-list-group-item  v-for="i in MainInterfacePromised[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesPromisedAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesPromisedAdd.button?InterfacesPromisedAdd.button = false : InterfacesPromisedAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="InterfacesPromisedAdd.button">
                                    <b-list-group-item  v-for="i in MainInterfacePromised[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesPromisedEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesPromisedEdit.button?InterfacesPromisedEdit.button = false : InterfacesPromisedEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="InterfacesPromisedEdit.button">
                                    <b-list-group-item  v-for="i in MainInterfacePromised[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesPromisedDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesPromisedDelete.button?InterfacesPromisedDelete.button = false : InterfacesPromisedDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="InterfacesPromisedDelete.button">
                                    <b-list-group-item  v-for="i in MainInterfacePromised[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="InterfacesInternal.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="InterfacesInternal.button ? InterfacesInternal.button = false : InterfacesInternal.button = true">  {{$t('Internal Transfer')}}</b-button>
                                  <b-list-group v-if="InterfacesInternal.button">
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesInternalRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesInternalRefresh.button?InterfacesInternalRefresh.button = false : InterfacesInternalRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="InterfacesInternalRefresh.button">
                                    <b-list-group-item  v-for="i in MainInterfaceInternal[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesInternalEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesInternalEdit.button?InterfacesInternalEdit.button = false : InterfacesInternalEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="InterfacesInternalEdit.button">
                                    <b-list-group-item  v-for="i in MainInterfaceInternal[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InterfacesInternalDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InterfacesInternalDelete.button?InterfacesInternalDelete.button = false : InterfacesInternalDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="InterfacesInternalDelete.button">
                                    <b-list-group-item  v-for="i in MainInterfaceInternal[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="About.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="About.button ? About.button = false : About.button = true">  {{$t('About')}}</b-button>
                            <b-list-group v-if="About.button">
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="AboutRefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="AboutRefresh.button ? AboutRefresh.button = false : AboutRefresh.button = true">  {{$t('Refresh')}}</b-button>
                                  <b-list-group v-if="AboutRefresh.button">
                                    <b-list-group-item  v-for="i in MainAbout[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="AboutLicensesrefresh.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="AboutLicensesrefresh.button ? AboutLicensesrefresh.button = false : AboutLicensesrefresh.button = true">  {{$t('Licenses refresh')}}</b-button>
                                  <b-list-group v-if="AboutLicensesrefresh.button">
                                    <b-list-group-item  v-for="i in MainAbout[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="f1C.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="f1C.button ? f1C.button = false : f1C.button = true">  {{$t('1C')}}</b-button>
                            <b-list-group v-if="f1C.button">
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="f1CSettings.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="f1CSettings.button ? f1CSettings.button = false : f1CSettings.button = true">  {{$t('1C Settings')}}</b-button>
                                  <b-list-group v-if="f1CSettings.button">
                                  <b-list-group-item  v-for="i in Main1C[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="f1CSyncronized.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="f1CSyncronized.button ? f1CSyncronized.button = false : f1CSyncronized.button = true">  {{$t('1C Syncronized Users')}}</b-button>
                                  <b-list-group v-if="f1CSyncronized.button">
                                  <b-list-group-item  v-for="i in Main1C[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="f1CInvoices.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="f1CInvoices.button ? f1CInvoices.button = false : f1CInvoices.button = true">  {{$t('1C Invoices')}}</b-button>
                                  <b-list-group v-if="f1CInvoices.button">
                                  <b-list-group-item  v-for="i in Main1C[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="f1CPayments.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="f1CPayments.button ? f1CPayments.button = false : f1CPayments.button = true">  {{$t('1C Payments')}}</b-button>
                                  <b-list-group v-if="f1CPayments.button">
                                  <b-list-group-item  v-for="i in Main1C[3].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Inventory.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="Inventory.button ? Inventory.button = false : Inventory.button = true">  {{$t('Inventory')}}</b-button>
                            <b-list-group v-if="Inventory.button">
                              <b-list-group-item>
                              <b-form-checkbox  size="sm" switch v-model="Inventorytypes.check" inline></b-form-checkbox>
                              <b-button size="sm" variant="outline-info" @click="Inventorytypes.button ? Inventorytypes.button = false : Inventorytypes.button = true">  {{$t('Switch types')}}</b-button>
                              <b-list-group v-if="Inventorytypes.button">
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="InventorytypesRefresh.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="InventorytypesRefresh.button?InventorytypesRefresh.button = false : InventorytypesRefresh.button = true">{{$t('Refresh')}}</b-button>
                                 <b-list-group v-if="InventorytypesRefresh.button">
                                  <b-list-group-item  v-for="i in MainInventorySwitchtypes[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="InventorytypesAdd.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="InventorytypesAdd.button?InventorytypesAdd.button = false : InventorytypesAdd.button = true">{{$t('Add')}}</b-button>
                                <b-list-group v-if="InventorytypesAdd.button">
                                  <b-list-group-item  v-for="i in MainInventorySwitchtypes[1].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="InventorytypesRead.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="InventorytypesRead.button?InventorytypesRead.button = false : InventorytypesRead.button = true">{{$t('Read')}}</b-button>
                                <b-list-group v-if="InventorytypesRead.button">
                                  <b-list-group-item  v-for="i in MainInventorySwitchtypes[2].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="InventorytypesEdit.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="InventorytypesEdit.button?InventorytypesEdit.button = false : InventorytypesEdit.button = true">{{$t('Edit')}}</b-button>
                                <b-list-group v-if="InventorytypesEdit.button">
                                  <b-list-group-item  v-for="i in MainInventorySwitchtypes[3].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                </b-list-group-item>
                                <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="InventorytypesDelete.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="InventorytypesDelete.button?InventorytypesDelete.button = false : InventorytypesDelete.button = true">{{$t('Delete')}}</b-button>
                                <b-list-group v-if="InventorytypesDelete.button">
                                  <b-list-group-item  v-for="i in MainInventorySwitchtypes[4].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                  </b-list-group>
                                </b-list-group-item>
                              </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="InventorySwitches.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="InventorySwitches.button ? InventorySwitches.button = false : InventorySwitches.button = true">  {{$t('Switches')}}</b-button>
                                  <b-list-group v-if="InventorySwitches.button">
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InventorySwitchesRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InventorySwitchesRefresh.button?InventorySwitchesRefresh.button = false : InventorySwitchesRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="InventorySwitchesRefresh.button">
                                    <b-list-group-item  v-for="i in MainInventorySwitches[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InventorySwitchesAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InventorySwitchesAdd.button?InventorySwitchesAdd.button = false : InventorySwitchesAdd.button = true">{{$t('Add')}}</b-button>
                                        <b-list-group v-if="InventorySwitchesAdd.button">
                                    <b-list-group-item  v-for="i in MainInventorySwitches[1].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InventorySwitchesRead.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InventorySwitchesRead.button?InventorySwitchesRead.button = false : InventorySwitchesRead.button = true">{{$t('Read')}}</b-button>
                                        <b-list-group v-if="InventorySwitchesRead.button">
                                    <b-list-group-item  v-for="i in MainInventorySwitches[2].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InventorySwitchesEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InventorySwitchesEdit.button?InventorySwitchesEdit.button = false : InventorySwitchesEdit.button = true">{{$t('Edit')}}</b-button>
                                        <b-list-group v-if="InventorySwitchesEdit.button">
                                    <b-list-group-item  v-for="i in MainInventorySwitches[3].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InventorySwitchesDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InventorySwitchesDelete.button?InventorySwitchesDelete.button = false : InventorySwitchesDelete.button = true">{{$t('Delete')}}</b-button>
                                      <b-list-group v-if="InventorySwitchesDelete.button">
                                      <b-list-group-item  v-for="i in MainInventorySwitches[4].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                      </b-list-group>
                                   </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="Inventorypools.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="Inventorypools.button ? Inventorypools.button = false : Inventorypools.button = true">  {{$t('DHCP pools')}}</b-button>
                                  <b-list-group v-if="Inventorypools.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InventorypoolsRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InventorypoolsRefresh.button?InventorypoolsRefresh.button = false : InventorypoolsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                     <b-list-group v-if="InventorypoolsRefresh.button">
                                      <b-list-group-item  v-for="i in MainInventoryDHCPpools[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                      </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InventorypoolsAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InventorypoolsAdd.button?InventorypoolsAdd.button = false : InventorypoolsAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="InventorypoolsAdd.button">
                                      <b-list-group-item  v-for="i in MainInventoryDHCPpools[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                      </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InventorypoolsRead.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InventorypoolsRead.button?InventorypoolsRead.button = false : InventorypoolsRead.button = true">{{$t('Read')}}</b-button>
                                    <b-list-group v-if="InventorypoolsRead.button">
                                      <b-list-group-item  v-for="i in MainInventoryDHCPpools[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                      </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InventorypoolsEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InventorypoolsEdit.button?InventorypoolsEdit.button = false : InventorypoolsEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="InventorypoolsEdit.button">
                                      <b-list-group-item  v-for="i in MainInventoryDHCPpools[3].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                      </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="InventorypoolsDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="InventorypoolsDelete.button?InventorypoolsDelete.button = false : InventorypoolsDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="InventorypoolsDelete.button">
                                      <b-list-group-item  v-for="i in MainInventoryDHCPpools[4].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                      </b-list-group>
                                   </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                  <b-form-checkbox  size="sm" switch v-model="Inventorylease.check" inline></b-form-checkbox>
                                  <b-button size="sm" variant="outline-info" @click="Inventorylease.button ? Inventorylease.button = false : Inventorylease.button = true">  {{$t('DHCP lease')}}</b-button>
                                  <b-list-group v-if="Inventorylease.button">
                                    <b-list-group-item  v-for="i in MainInventoryDHCPlease[0].funcs" :key="i.id">
                                      <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                    </b-list-group-item>
                                  </b-list-group>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                    </b-list-group>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start" button >
                <b-form-checkbox  size="sm" switch v-model="editUserWindow.check" inline></b-form-checkbox>
                <b-button size="sm" variant="outline-info" @click="clickEditUserWindow">   {{$t('User window')}}</b-button>
                    <b-list-group v-if="editUserWindow.button">
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="UETariffication.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickUETariffication">  {{$t('Tariffication')}}</b-button>
                            <b-list-group v-if="UETariffication.button">
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="UETarifficationTP.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="UETarifficationTP.button ? UETarifficationTP.button = false : UETarifficationTP.button = true">  {{$t('Technical Parameters')}}</b-button>
                                <b-list-group v-if="UETarifficationTP.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfTechParamRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfTechParamRefresh.button?UWTrfTechParamRefresh.button = false : UWTrfTechParamRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="UWTrfTechParamRefresh.button">
                                      <b-list-group-item  v-for="i in UWTrfTechnical[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfTechParamAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfTechParamAdd.button?UWTrfTechParamAdd.button = false : UWTrfTechParamAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="UWTrfTechParamAdd.button">
                                      <b-list-group-item  v-for="i in UWTrfTechnical[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfTechParamEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfTechParamEdit.button?UWTrfTechParamEdit.button = false : UWTrfTechParamEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="UWTrfTechParamEdit.button">
                                      <b-list-group-item  v-for="i in UWTrfTechnical[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfTechParamDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfTechParamDelete.button?UWTrfTechParamDelete.button = false : UWTrfTechParamDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="UWTrfTechParamDelete.button">
                                      <b-list-group-item  v-for="i in UWTrfTechnical[3].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="UETarifficationIPTVac.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="UETarifficationIPTVac.button ? UETarifficationIPTVac.button = false : UETarifficationIPTVac.button = true">  {{$t('IPTV activation cards')}}</b-button>
                                <b-list-group v-if="UETarifficationIPTVac.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfIPTVacRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfIPTVacRefresh.button?UWTrfIPTVacRefresh.button = false : UWTrfIPTVacRefresh.button = true">{{$t('Refresh')}}</b-button>
                                     <b-list-group v-if="UWTrfIPTVacRefresh.button">
                                      <b-list-group-item  v-for="i in UWTrfIPTV[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfIPTVacAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfIPTVacAdd.button?UWTrfIPTVacAdd.button = false : UWTrfIPTVacAdd.button = true">{{$t('Add')}}</b-button>
                                     <b-list-group v-if="UWTrfIPTVacAdd.button">
                                      <b-list-group-item  v-for="i in UWTrfIPTV[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="UETarifficationAccs.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="UETarifficationAccs.button ? UETarifficationAccs.button = false : UETarifficationAccs.button = true">  {{$t('Accounts')}}</b-button>
                                <b-list-group v-if="UETarifficationAccs.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfAccRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfAccRefresh.button?UWTrfAccRefresh.button = false : UWTrfAccRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="UWTrfAccRefresh.button">
                                      <b-list-group-item  v-for="i in UWTrfAccounts[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfAccAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfAccAdd.button?UWTrfAccAdd.button = false : UWTrfAccAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="UWTrfAccAdd.button">
                                      <b-list-group-item  v-for="i in UWTrfAccounts[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfAccDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfAccDelete.button?UWTrfAccDelete.button = false : UWTrfAccDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="UWTrfAccDelete.button">
                                      <b-list-group-item  v-for="i in UWTrfAccounts[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfAccEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfAccEdit.button?UWTrfAccEdit.button = false : UWTrfAccEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="UWTrfAccEdit.button">
                                      <b-list-group-item  v-for="i in UWTrfAccounts[3].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="UETarifficationTL.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="UETarifficationTL.button ? UETarifficationTL.button = false : UETarifficationTL.button = true">  {{$t('Tariff links')}}</b-button>
                                <b-list-group v-if="UETarifficationTL.button">
                                <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfTLRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfTLRefresh.button?UWTrfTLRefresh.button = false : UWTrfTLRefresh.button = true">{{$t('Refresh')}}</b-button>
                                     <b-list-group v-if="UWTrfTLRefresh.button">
                                      <b-list-group-item  v-for="i in UWTrfTarifflinks[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfTLAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfTLAdd.button?UWTrfTLAdd.button = false : UWTrfTLAdd.button = true">{{$t('Add')}}</b-button>
                                     <b-list-group v-if="UWTrfTLAdd.button">
                                      <b-list-group-item  v-for="i in UWTrfTarifflinks[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfTLEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfTLEdit.button?UWTrfTLEdit.button = false : UWTrfTLEdit.button = true">{{$t('Edit')}}</b-button>
                                     <b-list-group v-if="UWTrfTLEdit.button">
                                      <b-list-group-item  v-for="i in UWTrfTarifflinks[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfTLRead.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfTLRead.button?UWTrfTLRead.button = false : UWTrfTLRead.button = true">{{$t('Read')}}</b-button>
                                     <b-list-group v-if="UWTrfTLRead.button">
                                      <b-list-group-item  v-for="i in UWTrfTarifflinks[3].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfTLDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfTLDelete.button?UWTrfTLDelete.button = false : UWTrfTLDelete.button = true">{{$t('Delete')}}</b-button>
                                     <b-list-group v-if="UWTrfTLDelete.button">
                                      <b-list-group-item  v-for="i in UWTrfTarifflinks[4].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfTLHistory.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfTLHistory.button?UWTrfTLPrepaid.button = false : UWTrfTLHistory.button = true">{{$t('History')}}</b-button>
                                    <b-list-group v-if="UWTrfTLHistory.button">
                                      <b-list-group-item  v-for="i in UWTrfTarifflinks[5].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfTLAddSl.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfTLAddSl.button?UWTrfTLAddSl.button = false : UWTrfTLAddSl.button = true">{{$t('Add SL')}}</b-button>
                                    <b-list-group v-if="UWTrfTLAddSl.button">
                                      <b-list-group-item  v-for="i in UWTrfTarifflinks[6].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="UETarifficationSL.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="UETarifficationSL.button ? UETarifficationSL.button = false : UETarifficationSL.button = true">  {{$t('Service links')}}</b-button>
                                <b-list-group v-if="UETarifficationSL.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfSLRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfSLRefresh.button?UWTrfSLRefresh.button = false : UWTrfSLRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="UWTrfSLRefresh.button">
                                      <b-list-group-item  v-for="i in UWTrfServicelinks[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfSLAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfSLAdd.button?UWTrfSLAdd.button = false : UWTrfSLAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="UWTrfSLAdd.button">
                                      <b-list-group-item  v-for="i in UWTrfServicelinks[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfSLEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfSLEdit.button?UWTrfSLEdit.button = false : UWTrfSLEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="UWTrfSLEdit.button">
                                      <b-list-group-item  v-for="i in UWTrfServicelinks[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfSLRead.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfSLRead.button?UWTrfSLRead.button = false : UWTrfSLRead.button = true">{{$t('Read')}}</b-button>
                                    <b-list-group v-if="UWTrfSLRead.button">
                                      <b-list-group-item  v-for="i in UWTrfServicelinks[3].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfSLDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfSLDelete.button?UWTrfSLDelete.button = false : UWTrfSLDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="UWTrfSLDelete.button">
                                      <b-list-group-item  v-for="i in UWTrfServicelinks[4].funcs" :key="i.id">

                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfSLPrepaid.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfSLPrepaid.button?UWTrfSLPrepaid.button = false : UWTrfSLPrepaid.button = true">{{$t('Prepaid traffic')}}</b-button>
                                    <b-list-group v-if="UWTrfSLPrepaid.button">
                                      <b-list-group-item  v-for="i in UWTrfServicelinks[5].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWTrfSLSetRadius.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWTrfSLSetRadius.button?UWTrfSLSetRadius.button = false : UWTrfSLSetRadius.button = true">{{$t('Set RADIUS ')}}</b-button>
                                    <b-list-group v-if="UWTrfSLSetRadius.button">
                                      <b-list-group-item  v-for="i in UWTrfServicelinks[6].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="UEUsers.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickUsers">  {{$t('Users')}}</b-button>
                              <b-list-group v-if="UEUsers.button">
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="UEUsersGroups.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="UEUsersGroups.button ? UEUsersGroups.button = false : UEUsersGroups.button = true">  {{$t('Groups')}}</b-button>
                                <b-list-group v-if="UEUsersGroups.button">
                                  <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserGroupRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserGroupRefresh.button?UWUserGroupRefresh.button = false : UWUserGroupRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="UWUserGroupRefresh.button">
                                      <b-list-group-item  v-for="i in UWUserGroups[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserGroupAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserGroupAdd.button?UWUserGroupAdd.button = false : UWUserGroupAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="UWUserGroupAdd.button">
                                      <b-list-group-item  v-for="i in UWUserGroups[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserGroupDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserGroupDelete.button?UWUserGroupDelete.button = false : UWUserGroupDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="UWUserGroupDelete.button">
                                      <b-list-group-item  v-for="i in UWUserGroups[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="UEUsersAdds.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="UEUsersAdds.button ? UEUsersAdds.button = false : UEUsersAdds.button = true">  {{$t('Additional contacts')}}</b-button>
                                <b-list-group v-if="UEUsersAdds.button">
                                <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserAddContactsRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserAddContactsRefresh.button?UWUserAddContactsRefresh.button = false : UWUserAddContactsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                    <b-list-group v-if="UWUserAddContactsRefresh.button">
                                      <b-list-group-item  v-for="i in UWUserAdditional[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserAddContactsRead.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserAddContactsRead.button?UWUserAddContactsRead.button = false : UWUserAddContactsRead.button = true">{{$t('Read')}}</b-button>
                                    <b-list-group v-if="UWUserAddContactsRead.button">
                                      <b-list-group-item  v-for="i in UWUserAdditional[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserAddContactsEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserAddContactsEdit.button?UWUserAddContactsEdit.button = false : UWUserAddContactsEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="UWUserAddContactsEdit.button">
                                      <b-list-group-item  v-for="i in UWUserAdditional[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserAddContactsAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserAddContactsAdd.button?UWUserAddContactsAdd.button = false : UWUserAddContactsAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="UWUserAddContactsAdd.button">
                                      <b-list-group-item  v-for="i in UWUserAdditional[3].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserAddContactsDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserAddContactsDelete.button?UWUserAddContactsDelete.button = false : UWUserAddContactsDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="UWUserAddContactsDelete.button">
                                      <b-list-group-item  v-for="i in UWUserAdditional[4].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="UEUsersDocs.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="UEUsersDocs.button ? UEUsersDocs.button = false : UEUsersDocs.button = true">  {{$t('Documents')}}</b-button>
                                <b-list-group v-if="UEUsersDocs.button">
                                <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserDocsRefresh.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserDocsRefresh.button?UWUserDocsRefresh.button = false : UWUserDocsRefresh.button = true">{{$t('Refresh')}}</b-button>
                                     <b-list-group v-if="UWUserDocsRefresh.button">
                                      <b-list-group-item  v-for="i in UWUserDocuments[0].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                    <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserDocsAdd.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserDocsAdd.button?UWUserDocsAdd.button = false : UWUserDocsAdd.button = true">{{$t('Add')}}</b-button>
                                    <b-list-group v-if="UWUserDocsAdd.button">
                                      <b-list-group-item  v-for="i in UWUserDocuments[1].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserDocsRead.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserDocsRead.button?UWUserDocsRead.button = false : UWUserDocsRead.button = true">{{$t('Read')}}</b-button>
                                    <b-list-group v-if="UWUserDocsRead.button">
                                      <b-list-group-item  v-for="i in UWUserDocuments[2].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserDocsEdit.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserDocsEdit.button?UWUserDocsEdit.button = false : UWUserDocsEdit.button = true">{{$t('Edit')}}</b-button>
                                    <b-list-group v-if="UWUserDocsEdit.button">
                                      <b-list-group-item  v-for="i in UWUserDocuments[3].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                   <b-list-group-item>
                                    <b-form-checkbox  size="sm" switch v-model="UWUserDocsDelete.check" inline></b-form-checkbox>
                                    <b-button size="sm" variant="outline-info" @click="UWUserDocsDelete.button?UWUserDocsDelete.button = false : UWUserDocsDelete.button = true">{{$t('Delete')}}</b-button>
                                    <b-list-group v-if="UWUserDocsDelete.button">
                                      <b-list-group-item  v-for="i in UWUserDocuments[4].funcs" :key="i.id">
                                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                      </b-list-group-item>
                                    </b-list-group>
                                   </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox  size="sm" switch v-model="UEUsersGenUsr.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="UEUsersGenUsr.button ? UEUsersGenUsr.button = false : UEUsersGenUsr.button = true">  {{$t('Generate docs for user')}}</b-button>
                                <b-list-group v-if="UEUsersGenUsr.button">
                                  <b-list-group-item  v-for="i in UWUserGenerate[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Dealer.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickDealer">  {{$t('Dealers')}}</b-button>
                            <b-list-group v-if="Dealer.button">
                              <b-list-group-item  v-for="i in UWDealerLinkdealer[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Orders.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickOrders">  {{$t('Orders')}}</b-button>
                            <b-list-group v-if="Orders.button">
                              <b-list-group-item  v-for="i in UWContractsSigncontract[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                    </b-list-group>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start" button >
                 <b-form-checkbox  size="sm" switch v-model="reports.check" inline></b-form-checkbox>
                <b-button size="sm" variant="outline-info" @click="clickReports">  {{$t('Reports')}}</b-button>
                    <b-list-group v-if="reports.button">
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Blocks.check" inline></b-form-checkbox>
                                <b-button size="sm" variant="outline-info" @click="clickBlocks">  {{$t('Blocks')}}</b-button>
                                <b-list-group v-if="Blocks.button">
                                  <b-list-group-item  v-for="i in ReportsBlockings[0].funcs" :key="i.id">
                                    <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                                  </b-list-group-item>
                                </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Traffic.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickTraffic">  {{$t('Traffic')}}</b-button>
                            <b-list-group v-if="Traffic.button">
                              <b-list-group-item  v-for="i in ReportsTraffic[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Payments.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickPayments">  {{$t('Payments')}}</b-button>
                            <b-list-group v-if="Payments.button">
                              <b-list-group-item  v-for="i in ReportsPayments[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Charges.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickCharges">  {{$t('Charges')}}</b-button>
                            <b-list-group v-if="Charges.button">
                              <b-list-group-item  v-for="i in ReportsInternalTransfer[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="DialupAndVPN.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickDialupAndVPN">  {{$t('Dialup and VPN')}}</b-button>
                            <b-list-group v-if="DialupAndVPN.button">
                              <b-list-group-item  v-for="i in ReportsSessions[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="MainReport.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickMainReport">  {{$t('Main')}}</b-button>
                            <b-list-group v-if="MainReport.button">
                              <b-list-group-item  v-for="i in ReportsGeneral[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Telephony.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickTelephony">  {{$t('Telephony')}}</b-button>
                            <b-list-group v-if="Telephony.button">
                              <b-list-group-item  v-for="i in ReportsTelephony[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="ServicesReports.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickServicesReports">  {{$t('Services')}}</b-button>
                            <b-list-group v-if="ServicesReports.button">
                              <b-list-group-item  v-for="i in ReportsServices[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="OtherCharges.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickOtherCharges">  {{$t('Other charges')}}</b-button>
                            <b-list-group v-if="OtherCharges.button">
                              <b-list-group-item  v-for="i in ReportsOthercharges[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="TrafficDetail.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickTrafficDetail">  {{$t('Detailed traffic')}}</b-button>
                            <b-list-group v-if="TrafficDetail.button">
                              <b-list-group-item  v-for="i in ReportsDetailedTraffic[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="UsersCharges.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickUsersCharges">  {{$t('User change log')}}</b-button>
                            <b-list-group v-if="UsersCharges.button">
                              <b-list-group-item  v-for="i in ReportsUserLog[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="BurnPayments.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickBurnPayments">  {{$t('Expiring payments')}}</b-button>
                            <b-list-group v-if="BurnPayments.button">
                              <b-list-group-item  v-for="i in ReportsExpiringPayments[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="Invoices.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickInvoices">  {{$t('Invoices')}}</b-button>
                            <b-list-group v-if="Invoices.button">
                              <b-list-group-item  v-for="i in ReportsInvoices[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="GraphReport.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickGraphReport">  {{$t('Graphic reports')}}</b-button>
                            <b-list-group v-if="GraphReport.button">
                              <b-list-group-item  v-for="i in ReportsGraphicReport[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="PersonalServices.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickPersonalServices">  {{$t('Personal services')}}</b-button>
                            <b-list-group v-if="PersonalServices.button">
                              <b-list-group-item  v-for="i in ReportsCustomreport[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="TelDir.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickTelDir">  {{$t('Tel directions')}}</b-button>
                            <b-list-group v-if="TelDir.button">
                              <b-list-group-item  v-for="i in ReportsTelephonydir[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="DHCPLeases.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickDHCPLeases">  {{$t('DHCP leases')}}</b-button>
                            <b-list-group v-if="DHCPLeases.button">
                              <b-list-group-item  v-for="i in ReportsDHCPlease[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="GroupsReport.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickGroupsReport">  {{$t('Groups')}}</b-button>
                            <b-list-group v-if="GroupsReport.button">
                              <b-list-group-item  v-for="i in ReportsGroups[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="NewInvoicesReports.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickNewInvoicesReports">  {{$t('New invoice')}}</b-button>
                            <b-list-group v-if="NewInvoicesReports.button">
                              <b-list-group-item  v-for="i in ReportsNewinvoice[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="EmailSend.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickEmailSend">  {{$t('Send by e-mail')}}</b-button>
                            <b-list-group v-if="EmailSend.button">
                              <b-list-group-item  v-for="i in ReportsSendmail[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-form-checkbox  size="sm" switch v-model="PaymentRollBack.check" inline></b-form-checkbox>
                            <b-button size="sm" variant="outline-info" @click="clickPaymentRollBack">  {{$t('Cancel payment')}}</b-button>
                            <b-list-group v-if="PaymentRollBack.button">
                              <b-list-group-item  v-for="i in ReportsCancelpayment[0].funcs" :key="i.id">
                                <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                              </b-list-group-item>
                            </b-list-group>
                        </b-list-group-item>
                    </b-list-group>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start" button >
                <b-form-checkbox  size="sm" switch v-model="DisconnectRADIUSSession.check" inline></b-form-checkbox>
                <b-button size="sm" class="margin-bottom: 40%" variant="outline-info" @click="clickDisconnectRADIUSSession"> {{$t('Disconnect RADIUS Session')}}</b-button>
                <b-list-group v-if="DisconnectRADIUSSession.button">
                    <b-list-group-item  v-for="i in DisconnectRADIUSSessionFuncsIDs" :key="i.id">
                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                    </b-list-group-item>
                </b-list-group>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start" button >
                <b-form-checkbox  size="sm" switch v-model="DropRADIUSSession.check" inline></b-form-checkbox>
                <b-button size="sm" variant="outline-info" @click="clickDropRADIUSSession"> {{$t('Drop RADIUS Session')}}</b-button>
                <b-list-group v-if="DropRADIUSSession.button">
                    <b-list-group-item  v-for="i in DropRADIUSSessionFuncsIDs" :key="i.id">
                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                    </b-list-group-item>
                </b-list-group>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start" button >
                <b-form-checkbox  size="sm" switch v-model="DropHotspotSession.check" inline></b-form-checkbox>
                <b-button size="sm" variant="outline-info" @click="clickDropHotspotSession"> {{$t('Drop Hotspot Session')}}</b-button>
                <b-list-group v-if="DropHotspotSession.button">
                    <b-list-group-item  v-for="i in DropHotspotSessionFuncsIDs" :key="i.id">
                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                    </b-list-group-item>
                </b-list-group>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start" button >
                <b-form-checkbox  size="sm" switch v-model="Provider.check" inline> </b-form-checkbox>
                <b-button size="sm" variant="outline-info" @click="clickProvider"> {{$t('Provider')}}</b-button>
                <b-list-group v-if="Provider.button">
                    <b-list-group-item  v-for="i in ProviderFuncsIDs" :key="i.id">
                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                    </b-list-group-item>
                </b-list-group>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start" button >
                <b-form-checkbox  size="sm" switch v-model="DealerFunc.check" inline> </b-form-checkbox>
                <b-button size="sm" variant="outline-info" @click="clickDealerFunc"> {{$t('Dealer functions')}}</b-button>
                <b-list-group v-if="DealerFunc.button">
                    <b-list-group-item  v-for="i in DealerFuncsIDs" :key="i.id">
                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                    </b-list-group-item>
                </b-list-group>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start" button >
                <b-form-checkbox  size="sm" switch v-model="Cashier.check" inline> </b-form-checkbox>
                <b-button size="sm" variant="outline-info" @click="clickCashier"> {{$t('Cashier')}}</b-button>
                <b-list-group v-if="Cashier.button">
                    <b-list-group-item  v-for="i in CashierFuncsIDs" :key="i.id">
                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                    </b-list-group-item>
                </b-list-group>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start" button >
                <b-form-checkbox  size="sm" switch v-model="Other.check" inline> </b-form-checkbox>
                <b-button size="sm" variant="outline-info" @click="clickOther"> {{$t('Other')}}</b-button>
                <b-list-group v-if="Other.button">
                    <b-list-group-item  v-for="i in OtherFuncsIDs" :key="i.id">
                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                    </b-list-group-item>
                </b-list-group>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start" button >
                <b-form-checkbox  size="sm" switch v-model="WebInterfaceFunctions.check" inline> </b-form-checkbox>
                 <b-button size="sm" variant="outline-info" @click="clickWebInterfaceFunctions"> {{$t('Web interface')}}</b-button>
                <b-list-group v-if="WebInterfaceFunctions.button">
                    <b-list-group-item  v-for="i in WebInterfaceFunctionsFuncsIDs" :key="i.id">
                        <b-form-checkbox disabled class="flex-column align-items-start" size="sm" switch v-model="i.isEnabled" inline> {{i.name}}</b-form-checkbox>
                    </b-list-group-item>
                </b-list-group>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
export default {
  props: {
    enabledFids: null
  },
  data () {
    return {
      mainUgUsers: [{ liname: 'Refresh',
        funcs: [{name: 'get_users_count(0x2011)', id: 0x2011, isEnabled: false},
          {name: 'get_users_list(0x2044)', id: 0x2044, isEnabled: false}]},
      {liname: 'Add user',
        funcs: [{name: 'get-new-secret (0x60)', id: 0x60, isEnabled: false},
          {name: 'add_user_new (0x2125)', id: 0x2125, isEnabled: false},
          {name: 'remove_user (0x200e)', id: 0x200e, isEnabled: false}]},
      {liname: 'View user',
        funcs: [{name: 'rpcf_get_userinfo (0x2006)', id: 0x2006, isEnabled: false},
          {name: '__rpcf_get_uaparam_list (0x440b)', id: 0x440b, isEnabled: false},
          {name: '__rpcf_get_sys_user (0x4414)', id: 0x4414, isEnabled: false},
          {name: '__rpcs_get_routers_list (0x5043)', id: 0x5043, isEnabled: false},
          {name: 'rpcf_get_currency_list (0x2910)', id: 0x2910, isEnabled: false},
          {name: 'rpcf_get_user_othersets (0x9021)', id: 0x9021, isEnabled: false},
          {name: 'rpcf_get_tech_param_type (0x9002)', id: 0x9002, isEnabled: false}]},
      {liname: 'Edit user',
        funcs: [{name: 'rpcf_get_userinfo (0x2006)', id: 0x2006, isEnabled: false},
          {name: '__rpcf_get_uaparam_list (0x440b)', id: 0x440b, isEnabled: false},
          {name: '__rpcf_get_sys_user (0x4414)', id: 0x4414, isEnabled: false},
          {name: '__rpcs_get_routers_list (0x5043)', id: 0x5043, isEnabled: false},
          {name: 'rpcf_get_currency_list (0x2910)', id: 0x2910, isEnabled: false},
          {name: 'rpcf_get_user_othersets (0x9021)', id: 0x9021, isEnabled: false},
          {name: 'rpcf_get_tech_param_type (0x9002)', id: 0x9002, isEnabled: false},
          {name: 'rpcf_save_user_othersets (0x9022)', id: 0x9022, isEnabled: false},
          {name: 'rpcf_edit_user_new (0x2126)', id: 0x2126, isEnabled: false}]},
      {liname: 'Search users', funcs: [{name: 'rpcf_search_users_new (0x1206)', id: 0x1206, isEnabled: false}]},
      {liname: 'New payment',
        funcs: [{name: 'rpcf_get_core_time (0x11112)', id: 0x11112, isEnabled: false},
          {name: 'rpcf_get_userinfo (0x2006)', id: 0x2006, isEnabled: false},
          {name: '__rpcf_get_uaparam_list (0x440b)', id: 0x440b, isEnabled: false},
          {name: 'rpcf_get_currency_list (0x2910)', id: 0x2910, isEnabled: false},
          {name: 'rpcf_get_payment_methods_list (0x3100)', id: 0x3100, isEnabled: false},
          {name: 'rpcf_add_payment_for_account_notify (0x3113)', id: 0x3113, isEnabled: false},
          {name: 'rpcf_get_account_external_id (0x2039)', id: 0x2039, isEnabled: false}]},
      {liname: 'Payment for invoice', funcs: [{name: '__rpcf_get_invc_lst_addpay (0x8002)', id: 0x8002, isEnabled: false}]},
      {liname: 'Add to group',
        funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false},
          {name: 'rpcf_add_users_to_group (0x2407)', id: 0x2407, isEnabled: false}]},
      {liname: 'Change Internet status', funcs: [{name: 'rpcf_change_intstat_for_user (0x2003)', id: 0x2003, isEnabled: false}]}],
      mainUgDealers: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_dealers_list (0x13019)', id: 0x13019, isEnabled: false}]},
        {liname: 'Add',
          funcs: [{name: 'get-new-secret (0x60)', id: 0x60, isEnabled: false},
            {name: 'rpcf_add_dealer (0x13001)', id: 0x13001, isEnabled: false}]},
        {liname: 'Read',
          funcs: [{name: 'rpcf_get_users_count (0x2011)', id: 0x2011, isEnabled: false},
            {name: 'rpcf_get_dealer_privileges (0x1301b)', id: 0x1301b, isEnabled: false},
            {name: 'rpcf_get_dealer_users_map (0x13027)', id: 0x13027, isEnabled: false},
            {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
            {name: 'rpcf_get_tariffs_list (0x3024)', id: 0x3024, isEnabled: false},
            {name: 'rpcf_get_services_list (0x2101)', id: 0x2101, isEnabled: false},
            {name: 'rpcf_get_houses_list (0x2810)', id: 0x2810, isEnabled: false},
            {name: 'rpcf_get_dealer_info (0x13004)', id: 0x13004, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_users_count (0x2011)', id: 0x2011, isEnabled: false},
            {name: 'rpcf_get_dealer_privileges (0x1301b)', id: 0x1301b, isEnabled: false},
            {name: 'rpcf_get_dealer_users_map (0x13027)', id: 0x13027, isEnabled: false},
            {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
            {name: 'rpcf_get_tariffs_list (0x3024)', id: 0x3024, isEnabled: false},
            {name: 'rpcf_get_services_list (0x2101)', id: 0x2101, isEnabled: false},
            {name: 'rpcf_get_houses_list (0x2810)', id: 0x2810, isEnabled: false},
            {name: 'rpcf_get_dealer_info (0x13004)', id: 0x13004, isEnabled: false},
            {name: 'rpcf_get_tariff (0x3011)', id: 0x3011, isEnabled: false},
            {name: 'rpcf_grant_privileges_to_dealer (0x1301a)', id: 0x1301a, isEnabled: false},
            {name: 'rpcf_revoke_dealer_privileges (0x1301c)', id: 0x1301c, isEnabled: false},
            {name: 'rpcf_edit_dealer (0x13002)', id: 0x13002, isEnabled: false},
            {name: 'rpcf_get_dealers_list (0x13019)', id: 0x13019, isEnabled: false}]},
        {liname: 'Delete',
          funcs: [{name: 'rpcf_get_dealer_privileges (0x1301b)', id: 0x1301b, isEnabled: false},
            {name: 'rpcf_delete_dealer (0x13003)', id: 0x13003, isEnabled: false}]}],
      mainUgGroups: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_group (0x2401)', id: 0x2401, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_group_info (0x2409)', id: 0x2409, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_group_info (0x2409)', id: 0x2409, isEnabled: false},
            {name: 'rpcf_edit_group (0x2402)', id: 0x2402, isEnabled: false},
            {name: 'rpcf_remove_user_from_group (0x2408)', id: 0x2408, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_group (0x240b)', id: 0x240b, isEnabled: false}]},
        {liname: 'Group operations', funcs: [{name: 'rpcf_group_op (0x240d)', id: 0x240d, isEnabled: false}]}],
      mainUgIPGroups: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_ipgroups_list_ipv6 (0x292e)', id: 0x292e, isEnabled: false}]}],
      mainUgSysGroups: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_sysgroups_list (0x2403)', id: 0x2403, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_sysgroup (0x2404)', id: 0x2404, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_sysgroup (0x2406)', id: 0x2406, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_sysgroup (0x2406)', id: 0x2406, isEnabled: false},
            {name: 'rpcf_edit_sysgroup (0x2405)', id: 0x2405, isEnabled: false}]}],
      mainUgSysUsers: [{liname: 'Refresh', funcs: [{name: '__rpcf_get_sys_users_list (0x4413)', id: 0x4413, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: '__rpcf_add_sys_user (0x4415)', id: 0x4415, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: '__rpcf_get_sys_user (0x4414)', id: 0x4414, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: '__rpcf_get_sys_user (0x4414)', id: 0x4414, isEnabled: false},
            {name: 'rpcf_get_sysgroups_list (0x2403)', id: 0x2403, isEnabled: false},
            {name: 'rpcf_remove_user_from_group (0x2408)', id: 0x2408, isEnabled: false},
            {name: '__rpcf_edit_sys_user (0x4416)', id: 0x4416, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: '__rpcf_delete_sys_user (0x4410)', id: 0x4410, isEnabled: false}]}],
      mainUgCardPools: [{name: 'Refresh', funcs: [{name: 'card-pool-list (0x4201)', id: 0x4201, isEnabled: false}]},
        {name: 'Add card owner', funcs: [{name: 'add_card_owner (0x4291)', id: 0x4291, isEnabled: false}]},
        {name: 'Remove card owner', funcs: [{name: 'delete_card_owner (0x4290)', id: 0x4290, isEnabled: false}]},
        {name: 'Move expired cards', funcs: [{name: 'move-expired-cards (0x4206)', id: 0x4206, isEnabled: false}]},
        {name: 'Block card', funcs: [{name: 'block-card (0x4204)', id: 0x4204, isEnabled: false}]},
        {name: 'Unblock card', funcs: [{name: 'unblock-card (0x4205)', id: 0x4205, isEnabled: false}]},
        {name: 'Read', funcs: [{name: 'card-list (0x4200)', id: 0x4200, isEnabled: false}]},
        {name: 'Add cards', funcs: [{name: 'card-pool-add (0x4203)', id: 0x4203, isEnabled: false}]},
        {name: 'Search cards', funcs: [{name: 'rpcf_search_cards (0x1201)', id: 0x1201, isEnabled: false}]}],
      mainMessages: [{liname: 'Inbox messages',
        funcs: [{name: '__rpcf_get_messages_list_new (0x500b)', id: 0x500b, isEnabled: false},
          {name: '__rpcs_sent_messages_list (0x500e)', id: 0x500e, isEnabled: false},
          {name: '__rpcf_add_message_new (0x500d)', id: 0x500d, isEnabled: false},
          {name: '__rpcf_get_message (0x500c)', id: 0x500c, isEnabled: false},
          {name: '__rpcf_add_message_flag (0x5030)', id: 0x5030, isEnabled: false},
          {name: '__rpcf_remove_message_flag (0x5031)', id: 0x5031, isEnabled: false}]},
      {liname: 'Outbox messages',
        funcs: [{name: '__rpcf_get_messages_list_new (0x500b)', id: 0x500b, isEnabled: false},
          {name: '__rpcs_sent_messages_list (0x500e)', id: 0x500e, isEnabled: false},
          {name: '__rpcf_add_message_new (0x500d)', id: 0x500d, isEnabled: false},
          {name: '__rpcf_get_message (0x500c)', id: 0x500c, isEnabled: false},
          {name: '__rpcf_add_message_flag (0x5030)', id: 0x5030, isEnabled: false},
          {name: '__rpcf_remove_message_flag (0x5031)', id: 0x5031, isEnabled: false}]},
      {liname: 'New messages',
        funcs: [{name: '__rpcf_get_messages_list_new (0x500b)', id: 0x500b, isEnabled: false},
          {name: '__rpcs_sent_messages_list (0x500e)', id: 0x500e, isEnabled: false},
          {name: '__rpcf_add_message_new (0x500d)', id: 0x500d, isEnabled: false},
          {name: '__rpcf_get_message (0x500c)', id: 0x500c, isEnabled: false},
          {name: '__rpcf_add_message_flag (0x5030)', id: 0x5030, isEnabled: false},
          {name: '__rpcf_remove_message_flag (0x5031)', id: 0x5031, isEnabled: false},
          {name: '__rpcf_get_new_messages_list (0x500f)', id: 0x500f, isEnabled: false}]},
      {liname: 'Deleted messages',
        funcs: [{name: '__rpcf_get_messages_list_new (0x500b)', id: 0x500b, isEnabled: false},
          {name: '__rpcs_sent_messages_list (0x500e)', id: 0x500e, isEnabled: false},
          {name: '__rpcf_add_message_new (0x500d)', id: 0x500d, isEnabled: false},
          {name: '__rpcf_get_message (0x500c)', id: 0x500c, isEnabled: false},
          {name: '__rpcf_add_message_flag (0x5030)', id: 0x5030, isEnabled: false},
          {name: '__rpcf_remove_message_flag (0x5031)', id: 0x5031, isEnabled: false}]}],
      mainTrfAccPer: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_discount_period_return (0x2608)', id: 0x2608, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_accounting_period (0x2609)', id: 0x2609, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_accounting_period (0x2609)', id: 0x2609, isEnabled: false},
            {name: 'rpcf_add_discount_period_return (0x2608)', id: 0x2608, isEnabled: false}]}],
      mainTrfSrv: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_services_list (0x2101)', id: 0x2101, isEnabled: false}]},
        {liname: 'Add',
          funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false},
            {name: 'rpcf_get_tclasses (0x2300)', id: 0x2300, isEnabled: false},
            {name: 'rpcf_get_bytes_in_kb (0x10002)', id: 0x10002, isEnabled: false},
            {name: 'rpcf_get_time_ranges (0x10350)', id: 0x10350, isEnabled: false},
            {name: 'rpcf_add_once_service_ex (0x1500)', id: 0x1500, isEnabled: false},
            {name: 'rpcf_add_periodic_service_ex (0x1522)', id: 0x1522, isEnabled: false},
            {name: 'rpcf_add_iptraffic_service_ex (0x1510)', id: 0x1510, isEnabled: false},
            {name: 'rpcf_add_hotspot_service_ex (0x1506)', id: 0x1506, isEnabled: false},
            {name: 'rpcf_add_dialup_service_ex (0x1508)', id: 0x1508, isEnabled: false},
            {name: 'rpcf_set_traffic_aggregation_interval (0x10204)', id: 0x10204, isEnabled: false},
            {name: 'rpcf_set_hotspot_networks (0x10202)', id: 0x10202, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false},
            {name: 'rpcf_get_tclasses (0x2300)', id: 0x2300, isEnabled: false},
            {name: 'rpcf_get_bytes_in_kb (0x10002)', id: 0x10002, isEnabled: false},
            {name: 'rpcf_get_time_ranges (0x10350)', id: 0x10350, isEnabled: false},
            {name: 'rpcf_edit_once_service_ex (0x1501)', id: 0x1501, isEnabled: false},
            {name: 'rpcf_edit_periodic_service_ex (0x1523)', id: 0x1523, isEnabled: false},
            {name: 'rpcf_edit_iptraffic_service_ex (0x1511)', id: 0x1511, isEnabled: false},
            {name: 'rpcf_edit_hotspot_service_ex (0x1507)', id: 0x1507, isEnabled: false},
            {name: 'rpcf_edit_dialup_service_ex (0x1509)', id: 0x1509, isEnabled: false},
            {name: 'rpcf_get_once_service (0x210a)', id: 0x210a, isEnabled: false},
            {name: 'rpcf_get_once_service_new (0x2215)', id: 0x2215, isEnabled: false},
            {name: 'rpcf_get_periodic_service_ex (0x2230)', id: 0x2230, isEnabled: false},
            {name: 'rpcf_get_iptraffic_service_ex (0x2234)', id: 0x2234, isEnabled: false},
            {name: 'rpcf_get_hotspot_service_ex (0x2232)', id: 0x2232, isEnabled: false},
            {name: 'rpcf_get_dialup_service_ex (0x2233)', id: 0x2233, isEnabled: false},
            {name: 'rpcf_get_traffic_aggregation_interval (0x10203)', id: 0x10203, isEnabled: false},
            {name: 'rpcf_set_traffic_aggregation_interval (0x10204)', id: 0x10204, isEnabled: false},
            {name: 'rpcf_get_hotspot_networks (0x10201)', id: 0x10201, isEnabled: false},
            {name: 'rpcf_set_hotspot_networks (0x10202)', id: 0x10202, isEnabled: false}]},
        {liname: 'Delete',
          funcs: [{name: 'rpcf_is_service_used (0x10001)', id: 0x10001, isEnabled: false},
            {name: 'rpcf_remove_service (0x210e)', id: 0x210e, isEnabled: false}]}],
      mainTrfTmplSrv: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_services_list (0x2101)', id: 0x2101, isEnabled: false}]},
        {liname: 'Add',
          funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false},
            {name: 'rpcf_get_tclasses (0x2300)', id: 0x2300, isEnabled: false},
            {name: 'rpcf_get_bytes_in_kb (0x10002)', id: 0x10002, isEnabled: false},
            {name: 'rpcf_get_time_ranges (0x10350)', id: 0x10350, isEnabled: false},
            {name: 'rpcf_add_once_service_ex (0x1500)', id: 0x1500, isEnabled: false},
            {name: 'rpcf_add_periodic_service_ex (0x1522)', id: 0x1522, isEnabled: false},
            {name: 'rpcf_add_iptraffic_service_ex (0x1510)', id: 0x1510, isEnabled: false},
            {name: 'rpcf_add_hotspot_service_ex (0x1506)', id: 0x1506, isEnabled: false},
            {name: 'rpcf_add_dialup_service_ex (0x1508)', id: 0x1508, isEnabled: false},
            {name: 'rpcf_set_traffic_aggregation_interval (0x10204)', id: 0x10204, isEnabled: false},
            {name: 'rpcf_set_hotspot_networks (0x10202)', id: 0x10202, isEnabled: false}]},
        {liname: 'Delete',
          funcs: [{name: 'rpcf_is_service_used (0x10001)', id: 0x10001, isEnabled: false},
            {name: 'rpcf_remove_service (0x210e)', id: 0x210e, isEnabled: false}]}],
      mainTrfChP: [{liname: 'Refresh', funcs: [{name: 'rpcf_charge_policy_list (0x15102)', id: 0x15102, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_charge_policy (0x15103)', id: 0x15103, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_charge_policy_list (0x15102)', id: 0x15102, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_charge_policy_list (0x15102)', id: 0x15102, isEnabled: false},
            {name: 'rpcf_edit_charge_policy (0x15104)', id: 0x15104, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_charge_policy (0x15105)', id: 0x15105, isEnabled: false}]}],
      mainTrfTR: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_time_ranges (0x10350)', id: 0x10350, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_time_range (0x10351)', id: 0x10351, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_save_time_range (0x10352)', id: 0x10352, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_del_time_range (0x10353)', id: 0x10353, isEnabled: false}]}],
      mainTrfTrfClasses: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_tclasses (0x2300)', id: 0x2300, isEnabled: false}]},
        {liname: 'Add',
          funcs: [{name: 'rpcf_get_time_ranges (0x10350)', id: 0x10350, isEnabled: false},
            {name: 'rpcf_add_tclass2 (0x2305)', id: 0x2305, isEnabled: false}]},
        {liname: 'Read',
          funcs: [{name: 'rpcf_get_tclass (0x2306)', id: 0x2306, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_tclass (0x2306)', id: 0x2306, isEnabled: false},
            {name: 'rpcf_get_time_ranges (0x10350)', id: 0x10350, isEnabled: false},
            {name: 'rpcf_edit_tclass (0x2307)', id: 0x2307, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_tclass (0x2304)', id: 0x2304, isEnabled: false}]}],
      mainTrfTrfPlans: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_tariffs_list (0x3024)', id: 0x3024, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_tariff_new (0x3041)', id: 0x3041, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_tariff_new (0x3040)', id: 0x3040, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_tariff_new (0x3040)', id: 0x3040, isEnabled: false},
            {name: 'rpcf_edit_tariff_new (0x3042)', id: 0x3042, isEnabled: false},
            {name: 'rpcf_add_once_service_ex (0x1500)', id: 0x1500, isEnabled: false},
            {name: 'rpcf_edit_once_service_ex (0x1501)', id: 0x1501, isEnabled: false},
            {name: 'rpcf_add_periodic_service_ex (0x1522)', id: 0x1522, isEnabled: false},
            {name: 'rpcf_edit_periodic_service_ex (0x1523)', id: 0x1523, isEnabled: false},
            {name: 'rpcf_add_iptraffic_service_ex (0x1510)', id: 0x1510, isEnabled: false},
            {name: 'rpcf_edit_iptraffic_service_ex (0x1511)', id: 0x1511, isEnabled: false},
            {name: 'rpcf_add_hotspot_service_ex (0x1506)', id: 0x1506, isEnabled: false},
            {name: 'rpcf_edit_hotspot_service_ex (0x1507)', id: 0x1507, isEnabled: false},
            {name: 'rpcf_add_dialup_service_ex (0x1508)', id: 0x1508, isEnabled: false},
            {name: 'rpcf_edit_dialup_service_ex (0x1509)', id: 0x1509, isEnabled: false},
            {name: 'rpcf_del_service_from_tariff (0x3015)', id: 0x3015, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_tariff (0x301b)', id: 0x301b, isEnabled: false}]}],
      mainTrfTelZones: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_tel_zone (0x10307)', id: 0x10307, isEnabled: false},
          {name: 'rpcf_tel_zones_list (0x10309)', id: 0x10309, isEnabled: false}]},
      {liname: 'Add', funcs: [{name: 'rpcf_add_tel_zone (0x10303)', id: 0x10303, isEnabled: false}]},
      {liname: 'Read', funcs: [{name: 'rpcf_tel_zones_list (0x10309)', id: 0x10309, isEnabled: false}]},
      {liname: 'Edit',
        funcs: [{name: 'rpcf_tel_zones_list (0x10309)', id: 0x10309, isEnabled: false},
          {name: 'rpcf_edit_tel_zone (0x10304)', id: 0x10304, isEnabled: false}]},
      {liname: 'Delete', funcs: [{name: 'rpcf_remove_tel_zone (0x10305)', id: 0x10305, isEnabled: false}]}],
      mainTrfTelDirs: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_tel_direction (0x10306)', id: 0x1030, isEnabled: false},
          {name: 'rpcf_get_tel_directions_count (0x1031e)', id: 0x1031e, isEnabled: false}]},
      {liname: 'Add', funcs: [{name: 'rpcf_tel_directions_list (0x1031d)', id: 0x1031d, isEnabled: false}]},
      {liname: 'Read',
        funcs: [{name: 'rpcf_tel_directions_list (0x1031d)', id: 0x1031, isEnabled: false},
          {name: 'rpcf_edit_tel_direction (0x10301)', id: 0x10301, isEnabled: false}]},
      {liname: 'Edit', funcs: [{name: 'rpcf_add_tel_direction (0x10300)', id: 0x10300, isEnabled: false}]},
      {liname: 'Delete', funcs: [{name: 'rpcf_remove_tel_direction (0x10302)', id: 0x1030, isEnabled: false}]}],
      mainTrfTelCoefScheme: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_coeff_scheme_list (0x4701)', id: 0x4701, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_coeff_scheme (0x4702)', id: 0x4702, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_edit_coeff_scheme (0x4703)', id: 0x4703, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_del_coeff_scheme (0x4704)', id: 0x4704, isEnabled: false}]}],
      mainTrfTelCoefShed: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_coeff_schedule_list (0x4706)', id: 0x4706, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_coeff_schedule (0x4707)', id: 0x4707, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_edit_coeff_schedule (0x4708)', id: 0x4708, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_del_coeff_schedule (0x4709)', id: 0x4709, isEnabled: false}]}],
      mainTrfTelContractType: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_contract_type_list (0x4801)', id: 0x4801, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_contract_type (0x4802)', id: 0x4802, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_edit_contract_type (0x4803)', id: 0x4803, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_del_contract_type (0x4804)', id: 0x4804, isEnabled: false}]}],
      RefBookPaymentM: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_payment_methods_list (0x3100)', id: 0x3100, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_payment_method (0x3101)', id: 0x3101, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_edit_payment_method (0x3102)', id: 0x3102, isEnabled: false}]}],
      RefBookCurrency: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_currency_list (0x2910)', id: 0x2910, isEnabled: false}]},
        {liname: 'Add',
          funcs: [{name: 'rpcf_add_currency (0x2911)', id: 0x2911, isEnabled: false},
            {name: 'get-currency-rate-RBC (0x2914)', id: 0x2914, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_edit_currency (0x2912)', id: 0x2912, isEnabled: false},
            {name: 'get-currency-rate-RBC (0x2914)', id: 0x2914, isEnabled: false},
            {name: '__rpcs_get_system_currency (0x101)', id: 0x101, isEnabled: false},
            {name: 'rpcf_get_currency_rate_history (0x2913)', id: 0x2913, isEnabled: false}]},
        {liname: 'Read',
          funcs: [{name: '__rpcs_get_system_currency (0x101)', id: 0x101, isEnabled: false},
            {name: 'rpcf_get_currency_rate_history (0x2913)', id: 0x2913, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_currency (0x2915)', id: 0x2915, isEnabled: false}]}],
      RefBookBuildings: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_houses_list (0x2810)', id: 0x2810, isEnabled: false}]},
        {liname: 'Add',
          funcs: [{name: 'rpcf_get_ipzones_list (0x2800)', id: 0x2800, isEnabled: false},
            {name: 'rpcf_add_house (0x2811)', id: 0x2811, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_house (0x2812)', id: 0x2812, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_house (0x2812)', id: 0x2812, isEnabled: false},
            {name: 'rpcf_get_ipzones_list (0x2800)', id: 0x2800, isEnabled: false},
            {name: 'rpcf_add_house (0x2811)', id: 0x2811, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_house (0x2815)', id: 0x2815, isEnabled: false}]}],
      RefBookStreets: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_streets_list (0x2816)', id: 0x2816, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_street (0x2817)', id: 0x2817, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_street (0x2818)', id: 0x2818, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_get_street (0x2818)', id: 0x2818, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_street (0x2819)', id: 0x2819, isEnabled: false}]}],
      RefBookBanks: [{liname: 'Refresh', funcs: [{name: '__rpcs_get_banks (0x6002)', id: 0x6002, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: '__rpcs_put_banks (0x6001)', id: 0x6001, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: '__rpcs_put_banks (0x6001)', id: 0x6001, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: '__rpcs_del_bank (0x6003)', id: 0x6003, isEnabled: false}]}],
      RefBookIPzones: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_ipzones_list (0x2800)', id: 0x2800, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_ipzone_ipv6 (0x2803)', id: 0x2803, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_ipzone_ipv6 (0x2804)', id: 0x2804, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_ipzone_ipv6 (0x2804)', id: 0x2804, isEnabled: false},
            {name: 'rpcf_add_ipzone_ipv6 (0x2803)', id: 0x2803, isEnabled: false}]}],
      SettingsParameters: [{liname: 'Refresh', funcs: [{name: 'Get-Registry-Setting-Groups, (0x103)', id: 0x103, isEnabled: false}]}],
      SettingsAdditionalParameters: [{liname: 'Refresh', funcs: [{name: '__rpcf_get_uaparam_list (0x440b)', id: 0x440b, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: '__rpcf_add_uaparam (0x440c)', id: 0x440c, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: '__rpcf_edit_uaparam (0x440e)', id: 0x440e, isEnabled: false}]},
        {liname: 'Delete',
          funcs: [{name: '__rpcf_remove_uaparam_new (0x4411)', id: 0x4411, isEnabled: false},
            {name: '__rpcf_is_uaparam_in_use (0x4412)', id: 0x4412, isEnabled: false}]}],
      SettingsFirewalls: [{liname: 'Refresh', funcs: [{name: '__rpcs_get_routers_list (0x5043)', id: 0x5043, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: '__rpcs_put_router (0x501d)', id: 0x501d, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: '__rpcs_put_router (0x501d)', id: 0x501d, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: '__rpcs_put_router (0x501d)', id: 0x501d, isEnabled: false}]}],
      SettingsFirewallrules: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_fwrules_list_new (0x5020)', id: 0x5020, isEnabled: false}]},
        {liname: 'Add',
          funcs: [{name: 'rpcf_add_fwrule_new (0x5021)', id: 0x5021, isEnabled: false},
            {name: 'Get-FW-Events (0x48)', id: 0x48, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_edit_fwrule_new (0x5022)', id: 0x5022, isEnabled: false},
            {name: 'Get-FW-Events (0x48)', id: 0x48, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_del_fwrule_new (0x5023)', id: 0x5023, isEnabled: false}]}],
      SettingsNASList: [{liname: 'Refresh', funcs: [{name: '__rpcs_get_nas_list (0x5040)', id: 0x5040, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: '__rpcs_put_nas (0x5103)', id: 0x5103, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: '__rpcs_get_nas (0x5102)', id: 0x5102, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: '__rpcs_get_nas (0x5102)', id: 0x5102, isEnabled: false},
            {name: '__rpcs_put_nas (0x5103)', id: 0x5103, isEnabled: false},
            {name: 'rpcf_get_radius_attr (0x10106)', id: 0x10106, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: '__rpcs_del_nas (0x501a)', id: 0x501a, isEnabled: false}]}],
      SettingsISGprofile: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_isg_profiles_list (0x1403)', id: 0x1403, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_isg_profile (0x1402)', id: 0x1402, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_isg_profile (0x1400)', id: 0x1400, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_isg_profile (0x1400)', id: 0x1400, isEnabled: false},
            {name: 'rpcf_edit_isg_profile (0x1401)', id: 0x1401, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_delete_isg_profile (0x1404)', id: 0x1404, isEnabled: false}]}],
      SettingsISGattributes: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_isg_auth_attr_list (0x1406)', id: 0x1406, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_isg_auth_attr (0x1407)', id: 0x1407, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_isg_auth_attr (0x1405)', id: 0x1405, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_isg_auth_attr (0x1405)', id: 0x1405, isEnabled: false},
            {name: 'rpcf_edit_isg_auth_attr (0x1408)', id: 0x1408, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_delete_isg_auth_attr (0x1409)', id: 0x1409, isEnabled: false}]}],
      SettingsDocumentTemplates: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_document_templates_list (0x4606)', id: 0x4606, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_create_document_template (0x4602)', id: 0x4602, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_document_template (0x4604)', id: 0x4604, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_document_template (0x4605)', id: 0x4605, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_document_template (0x4605)', id: 0x4605, isEnabled: false},
            {name: 'rpcf_edit_document_template (0x4603)', id: 0x4603, isEnabled: false}]},
        {liname: 'Update templates from DB', funcs: [{name: '28727 (0x7037)', id: 0x7037, isEnabled: false}]},
        {liname: 'Set default document template', funcs: [{name: '28709 (0x7025)', id: 0x7025, isEnabled: false}]}],
      SettingsProfiles: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_document_profiles_list (0x460e)', id: 0x460e, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_create_document_profile (0x4607)', id: 0x4607, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_document_profile (0x4609)', id: 0x4609, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_document_profile (0x460d)', id: 0x460d, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_document_profile (0x460d)', id: 0x460d, isEnabled: false},
            {name: 'rpcf_edit_document_profile (0x4608)', id: 0x4608, isEnabled: false}]}],
      SettingsReplacements: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_document_replacement_list (0x460a)', id: 0x460a, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_set_document_replacement (0x460b)', id: 0x460b, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_unset_document_replacement (0x460c)', id: 0x460c, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_set_document_replacement (0x460b)', id: 0x460b, isEnabled: false}]}],
      SettingsIPPools: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_ippools_list (0x1067)', id: 0x1067, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_ippool (0x1068)', id: 0x1068, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_ippool (0x1066)', id: 0x1066, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_ippool (0x1066)', id: 0x1066, isEnabled: false},
            {name: 'rpcf_edit_ippool (0x1069)', id: 0x1069, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_del_ippool (0x1064)', id: 0x1064, isEnabled: false}]}],
      SettingsDynamicshaping: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_shaped_services (0x12006)', id: 0x12006, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_shaping (0x1200f)', id: 0x1200f, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_shaping (0x1200e)', id: 0x1200e, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_shaping (0x1200e)', id: 0x1200e, isEnabled: false},
            {name: 'rpcf_edit_shaping (0x12010)', id: 0x12010, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_delete_shaping (0x12011)', id: 0x12011, isEnabled: false}]}],
      SettingsCompanies: [{liname: 'Refresh', funcs: [{name: '__rpcf_get_suppliers_list (0x8014)', id: 0x8014, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: '__rpcf_add_supplier (0x8046)', id: 0x8046, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: '__rpcf_get_supplier (0x8043)', id: 0x8043, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: '__rpcf_get_supplier (0x8043)', id: 0x8043, isEnabled: false},
            {name: '__rpcf_edit_supplier (0x8045)', id: 0x8045, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: '__rpcf_delete_supplier (0x8017)', id: 0x8017, isEnabled: false}]}],
      SettingsTelephoneoperators: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_suppliers_zones (0x8019)', id: 0x8019, isEnabled: false},
          {name: '__rpcf_get_suppliers_list (0x8014)', id: 0x8014, isEnabled: false}]},
      {liname: 'Add', funcs: [{name: '__rpcf_add_supplier (0x8046)', id: 0x8046, isEnabled: false}]},
      {liname: 'Read',
        funcs: [{name: 'rpcf_get_suppliers_zones (0x8019)', id: 0x8019, isEnabled: false},
          {name: '__rpcf_get_supplier (0x8043)', id: 0x8043, isEnabled: false}]},
      {liname: 'Edit',
        funcs: [{name: 'rpcf_get_suppliers_zones (0x8019)', id: 0x8019, isEnabled: false},
          {name: '__rpcf_get_supplier (0x8043)', id: 0x8043, isEnabled: false},
          {name: '__rpcf_edit_supplier (0x8045)', id: 0x8045, isEnabled: false}]},
      {liname: 'Delete', funcs: [{name: '__rpcf_delete_supplier (0x8017)', id: 0x8017, isEnabled: false}]}],
      SettingsEmergencyCalls: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_tel_emergency_calls (0x15032)', id: 0x15032, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_tel_emergency_calls (0x15032)', id: 0x15032, isEnabled: false},
            {name: 'rpcf_set_tel_emergency_calls (0x15033)', id: 0x15033, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_set_tel_emergency_calls (0x15033)', id: 0x15033, isEnabled: false}]},
        {liname: 'Add', funcs: []}],
      SettingsRADIUSaccounts: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_radius_accounts_list (0x10154)', id: 0x10154, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_radius_account (0x10152)', id: 0x10152, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_edit_radius_account (0x10151)', id: 0x10151, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_radius_account (0x10153)', id: 0x10153, isEnabled: false}]}],
      SettingsArchiveDB: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_archive_list (0xfd)', id: 0xfd, isEnabled: false},
          {name: 'rpcf_refresh_archives (0xfb)', id: 0xfb, isEnabled: false},
          {name: 'rpcf_verify_archives (0xfc)', id: 0xfc, isEnabled: false}]}],
      SettingsNetFlowProviders: [{liname: 'Refresh',
        funcs: [{name: '__rpcs_get_nf_providers_list (0x5061)', id: 0x5061, isEnabled: false},
          {name: '__rpcs_get_traffic_collectors_list (0x5064)', id: 0x5064, isEnabled: false}]},
      {liname: 'Add', funcs: [{name: '__rpcs_put_nf_provider (0x5062)', id: 0x5062, isEnabled: false}]},
      {liname: 'Edit', funcs: [{name: '__rpcs_put_nf_provider (0x5062)', id: 0x5062, isEnabled: false}]},
      {liname: 'Delete', funcs: [{name: '__rpcs_del_nf_provider (0x5063)', id: 0x5063, isEnabled: false}]}],
      SettingsTrafficcollectors: [{liname: 'Refresh', funcs: [{name: '__rpcs_get_traffic_collectors_list (0x5064)', id: 0x5064, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: '__rpcs_put_traffic_collector (0x5065)', id: 0x5065, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: '__rpcs_put_traffic_collector (0x5065)', id: 0x5065, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: '__rpcs_del_traffic_collector (0x5066)', id: 0x5066, isEnabled: false}]}],
      MainAddSymbols: [{liname: 'Refresh', funcs: [{name: 'liburfa-symtab (0x44)', id: 0x44, isEnabled: false}]}],
      MainAddLibURFA: [{liname: 'Refresh', funcs: [{name: 'liburfa-list (0x40)', id: 0x40, isEnabled: false}]},
        {liname: 'Liburfa-load', funcs: [{name: 'Get-Core-Version-String (0x41)', id: 0x41, isEnabled: false}]},
        {liname: 'Liburfa-unload', funcs: [{name: '66 (0x42)', id: 0x42, isEnabled: false}]},
        {liname: 'Liburfa-reload', funcs: [{name: '67 (0x43)', id: 0x43, isEnabled: false}]}],
      MainAddConn: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_session_list (0x2123)', id: 0x2123, isEnabled: false}]}],
      MainAddHotspotSessions: [{liname: 'Refresh', funcs: [{name: 'hotspot-sessions-list (0x4308)', id: 0x4308, isEnabled: false}]}],
      MainAddRADIUSSessions: [{liname: 'Refresh', funcs: [{name: 'rpcf_radius_get_active_sessions (0x1073)', id: 0x1073, isEnabled: false}]}],
      MainAddRADIUSAttributes: [{liname: 'Refresh', funcs: [{name: 'rpcf_radius_get_attributes_list (0x1065)', id: 0x1065, isEnabled: false}]}],
      MainAddChangepassword: [{liname: 'Refresh', funcs: [{name: 'rpcf_change_own_password (0x2124)', id: 0x2124, isEnabled: false}]}],
      MainInterfaceTray: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_tray_settings (0x212a)', id: 0x212a, isEnabled: false},
          {name: 'rpcf_save_tray_settings (0x212b)', id: 0x212b, isEnabled: false}]}],
      MainInterfaceCashier: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_cashier_settings (0x212c)', id: 0x212c, isEnabled: false},
          {name: 'rpcf_save_cashier_settings (0x212d)', id: 0x212d, isEnabled: false}]}],
      MainInterfaceSwitch: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_switch_tariff_settings (0x15014)', id: 0x15014, isEnabled: false}]},
        {liname: 'Add',
          funcs: [{name: 'rpcf_add_switch_tariff_settings (0x15015)', id: 0x15015, isEnabled: false},
            {name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_edit_switch_tariff_settings (0x15016)', id: 0x15016, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_delete_switch_tariff_settings (0x15003)', id: 0x15003, isEnabled: false}]}],
      MainInterfaceVoluntary: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_voluntary_suspension_settings (0x15010)', id: 0x15010, isEnabled: false}]},
        {liname: 'Add',
          funcs: [{name: 'rpcf_add_voluntary_suspension_settings (0x15011)', id: 0x15011, isEnabled: false},
            {name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_edit_voluntary_suspension_settings (0x15012)', id: 0x15012, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_delete_voluntary_suspension_settings (0x15013)', id: 0x15013, isEnabled: false}]}],
      MainInterfacePromised: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_promised_payment_settings (0x15034)', id: 0x15034, isEnabled: false}]},
        {liname: 'Add',
          funcs: [{name: 'rpcf_add_promised_payment_settings (0x15035)', id: 0x15035, isEnabled: false},
            {name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_edit_promised_payment_settings (0x15036)', id: 0x15036, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_delete_promised_payment_settings (0x15023)', id: 0x15023, isEnabled: false}]}],
      MainInterfaceInternal: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_funds_flow_settings (0x15024)', id: 0x15024, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_edit_funds_flow_settings (0x15026)', id: 0x15026, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_delete_funds_flow_settings (0x15027)', id: 0x15027, isEnabled: false}]}],
      MainAbout: [{liname: 'Refresh',
        funcs: [{name: '__rpcs_get_version_info (0x5013)', id: 0x5013, isEnabled: false},
          {name: 'Get-Core-Version (0x45)', id: 0x45, isEnabled: false},
          {name: 'Get-Core-BUILD (0x46)', id: 0x46, isEnabled: false}]},
      {liname: 'RefreshLicenses', funcs: [{name: 'rpcf_get_license_list (0x2122)', id: 0x2122, isEnabled: false}]}],
      Main1C: [{liname: '1C Settings',
        funcs: [{name: 'rpcf_ic_get_settings (0x14001)', id: 0x14001, isEnabled: false},
          {name: 'rpcf_ic_save_settings (0x14002)', id: 0x14002, isEnabled: false}]},
      {liname: '1C Syncronized Users',
        funcs: [{name: 'rpcf_ic_get_users_list (0x14003)', id: 0x14003, isEnabled: false},
          {name: 'rpcf_set_ic_status (0x14006)', id: 0x14006, isEnabled: false}]},
      {liname: '1C Invoices',
        funcs: [{name: 'rpcf_ic_get_invoices_list (0x14004)', id: 0x14004, isEnabled: false},
          {name: 'rpcf_set_ic_status (0x14006)', id: 0x14006, isEnabled: false}]},
      {liname: '1C Payments',
        funcs: [{name: 'rpcf_ic_get_payments_list (0x14005)', id: 0x14005, isEnabled: false},
          {name: 'rpcf_set_ic_status (0x14006)', id: 0x14006, isEnabled: false}]}],
      MainInventorySwitchtypes: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_switch_types_list (0x508)', id: 0x508, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_edit_switch_type (0x507)', id: 0x507, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_switch_type (0x505)', id: 0x505, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_get_switch_type (0x505)', id: 0x505, isEnabled: false}]},
        {liname: 'Delete',
          funcs: [{name: 'rpcf_remove_switch_type (0x502)', id: 0x502, isEnabled: false},
            {name: 'rpcf_get_type_switches_count (0x1157)', id: 0x1157, isEnabled: false}]}],
      MainInventorySwitches: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_switches_list (0x1154)', id: 0x1154, isEnabled: false},
          {name: 'rpcf_get_switches_count (0x1155)', id: 0x1155, isEnabled: false}]},
      {liname: 'Add', funcs: [{name: 'rpcf_add_switch (0x1151)', id: 0x1151, isEnabled: false}]},
      {liname: 'Read', funcs: [{name: 'rpcf_get_switch (0x1150)', id: 0x1150, isEnabled: false}]},
      {liname: 'Edit',
        funcs: [{name: 'rpcf_get_switch (0x1150)', id: 0x1150, isEnabled: false},
          {name: 'rpcf_edit_switch (0x1153)', id: 0x1153, isEnabled: false}]},
      {liname: 'Delete', funcs: [{name: 'rpcf_remove_switch (0x1152)', id: 0x1152, isEnabled: false}]}],
      MainInventoryDHCPpools: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_dhcp_pools_list (0x704)', id: 0x704, isEnabled: false}]},
        {liname: 'Add', funcs: [{name: 'rpcf_add_dhcp_pool (0x701)', id: 0x701, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_dhcp_pool (0x700)', id: 0x700, isEnabled: false}]},
        {liname: 'Edit',
          funcs: [{name: 'rpcf_get_dhcp_pool (0x700)', id: 0x700, isEnabled: false},
            {name: 'rpcf_edit_dhcp_pool (0x703)', id: 0x703, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_dhcp_pool (0x702)', id: 0x702, isEnabled: false}]}],
      MainInventoryDHCPlease: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_leases_list (0x1350)', id: 0x1350, isEnabled: false}]}],
      UWTrfTechnical: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_user_account_list (0x2033)', id: 0x2033, isEnabled: false},
          {name: 'rpcf_get_tech_param_by_uid (0x9000)', id: 0x9000, isEnabled: false}]},
      {liname: 'Add',
        funcs: [{name: 'rpcf_get_tech_param_type (0x9002)', id: 0x9002, isEnabled: false},
          {name: 'rpcf_get_techparam_slink_by_uid (0x9003)', id: 0x9003, isEnabled: false},
          {name: 'rpcf_add_tech_param (0x9004)', id: 0x9004, isEnabled: false}]},
      {liname: 'Edit',
        funcs: [{name: 'rpcf_save_tech_param (0x9005)', id: 0x9005, isEnabled: false},
          {name: 'rpcf_get_techparam_slink_by_uid (0x9003)', id: 0x9003, isEnabled: false},
          {name: 'rpcf_add_tech_param (0x9004)', id: 0x9004, isEnabled: false}]},
      {liname: 'Delete', funcs: [{name: 'rpcf_del_tech_param (0x9001)', id: 0x9001, isEnabled: false}]}],
      UWTrfIPTV: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_user_account_list (0x2033)', id: 0x2033, isEnabled: false},
          {name: 'rpcf_get_activation_codes (0x450b)', id: 0x450b, isEnabled: false}]},
      {liname: 'Add', funcs: [{name: 'rpcf_new_activation_code (0x450c)', id: 0x450c, isEnabled: false}]}],
      UWTrfAccounts: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_user_account_list (0x2033)', id: 0x2033, isEnabled: false},
          {name: 'rpcf_get_accountinfo (0x15109)', id: 0x15109, isEnabled: false},
          {name: 'rpcf_get_requirement_payment (0x15111)', id: 0x15111, isEnabled: false}]},
      {liname: 'Add',
        funcs: [{name: 'rpcf_get_core_time (0x11112)', id: 0x11112, isEnabled: false},
          {name: 'Get-Setting-Compat (0x4404)', id: 0x4404, isEnabled: false},
          {name: 'rpcf_add_account (0x1510a)', id: 0x1510a, isEnabled: false},
          {name: 'rpcf_save_account (0x1510b)', id: 0x1510b, isEnabled: false},
          {name: 'rpcf_set_account_external_id (0x2038)', id: 0x2038, isEnabled: false},
          {name: 'rpcf_is_account_external_id_used (0x203a)', id: 0x203a, isEnabled: false}]},
      {liname: 'Delete', funcs: [{name: 'rpcf_remove_account (0x2034)', id: 0x2034, isEnabled: false}]},
      {liname: 'Edit',
        funcs: [{name: 'rpcf_get_core_time (0x11112)', id: 0x11112, isEnabled: false},
          {name: 'rpcf_get_accountinfo (0x15109)', id: 0x15109, isEnabled: false},
          {name: 'rpcf_save_account (0x1510b)', id: 0x1510b, isEnabled: false},
          {name: 'rpcf_set_account_external_id (0x2038)', id: 0x2038, isEnabled: false},
          {name: 'rpcf_get_account_external_id (0x2039)', id: 0x2039, isEnabled: false},
          {name: 'rpcf_is_account_external_id_used (0x203a)', id: 0x203a, isEnabled: false}]}],
      UWTrfTarifflinks: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_user_tariffs (0x3017)', id: 0x3017, isEnabled: false},
          {name: 'rpcf_get_user_account_list (0x2033)', id: 0x2033, isEnabled: false}]},
      {liname: 'Add',
        funcs: [{name: 'rpcf_get_tariffs_list (0x3024)', id: 0x3024, isEnabled: false},
          {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: 'rpcf_link_user_tariff (0x301f)', id: 0x301f, isEnabled: false},
          {name: 'rpcf_get_tps_for_user (0x301a)', id: 0x301a, isEnabled: false},
          {name: 'rpcf_get_dialup_service (0x210c)', id: 0x210c, isEnabled: false}]},
      {liname: 'Edit',
        funcs: [{name: 'rpcf_link_user_tariff (0x301f)', id: 0x301f, isEnabled: false},
          {name: 'rpcf_get_tariffs_list (0x3024)', id: 0x3024, isEnabled: false},
          {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: 'rpcf_get_user_tariffs (0x3017)', id: 0x3017, isEnabled: false}]},
      {liname: 'Read',
        funcs: [{name: 'rpcf_get_tariffs_list (0x3024)', id: 0x3024, isEnabled: false},
          {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: 'rpcf_get_user_tariffs (0x3017)', id: 0x3017, isEnabled: false}]},
      {liname: 'Delete', funcs: [{name: 'rpcf_unlink_user_tariff (0x3019)', id: 0x3019, isEnabled: false}]},
      {liname: 'History', funcs: [{name: 'rpcf_get_tariffs_history (0x301c)', id: 0x301c, isEnabled: false}]},
      {liname: 'AddSL',
        funcs: [{name: 'rpcf_get_tps_for_user (0x301a)', id: 0x301a, isEnabled: false},
          {name: 'rpcf_get_core_time (0x11112)', id: 0x11112, isEnabled: false},
          {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: '__rpcs_get_routers_list (0x5043)', id: 0x5043, isEnabled: false},
          {name: 'rpcf_get_userinfo (0x2006)', id: 0x2006, isEnabled: false},
          {name: '__rpcf_get_uaparam_list (0x440b)', id: 0x440b, isEnabled: false},
          {name: 'rpcf_get_free_ips_for_house (0x15101)', id: 0x15101, isEnabled: false},
          {name: 'rpcf_get_bytes_in_kb (0x10002)', id: 0x10002, isEnabled: false},
          {name: 'rpcf_get_tclasses (0x2300)', id: 0x2300, isEnabled: false}]}],
      UWTrfServicelinks: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_all_services_for_user (0x2700)', id: 0x2700, isEnabled: false},
          {name: 'rpcf_get_user_account_list (0x2033)', id: 0x2033, isEnabled: false}]},
      {liname: 'Add',
        funcs: [{name: 'rpcf_get_userinfo (0x2006)', id: 0x2006, isEnabled: false},
          {name: 'rpcf_get_services_list (0x2101)', id: 0x2101, isEnabled: false},
          {name: 'rpcf_get_tclasses (0x2300)', id: 0x2300, isEnabled: false},
          {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: 'rpcf_get_free_ips_for_house (0x15101)', id: 0x15101, isEnabled: false},
          {name: '__rpcf_get_uaparam_list (0x440b)', id: 0x440b, isEnabled: false},
          {name: '__rpcs_get_routers_list (0x5043)', id: 0x5043, isEnabled: false},
          {name: 'rpcf_get_bytes_in_kb (0x10002)', id: 0x10002, isEnabled: false},
          {name: 'rpcf_get_core_time (0x11112)', id: 0x11112, isEnabled: false},
          {name: 'rpcf_add_once_service_link_ex (0x2920)', id: 0x2920, isEnabled: false},
          {name: 'rpcf_add_periodic_service_link_ex (0x2946)', id: 0x2946, isEnabled: false},
          {name: 'rpcf_add_dialup_service_link_ex (0x2944)', id: 0x2944, isEnabled: false},
          {name: 'rpcf_add_hotspot_service_link_ex (0x2943)', id: 0x2943, isEnabled: false},
          {name: 'rpcf_add_iptraffic_service_link_ipv6 (0x2950)', id: 0x2950, isEnabled: false}]},
      {liname: 'Edit',
        funcs: [{name: 'rpcf_delete_quota (0x20ff)', id: 0x20ff, isEnabled: false},
          {name: 'rpcf_edit_once_service_link_ex (0x2921)', id: 0x2921, isEnabled: false},
          {name: 'rpcf_edit_periodic_service_link_ex (0x2947)', id: 0x2947, isEnabled: false},
          {name: 'rpcf_edit_dialup_service_link_ex (0x2945)', id: 0x2945, isEnabled: false},
          {name: 'rpcf_edit_hotspot_service_link_ex (0x2942)', id: 0x2942, isEnabled: false},
          {name: 'rpcf_edit_iptraffic_service_link_ipv6 (0x2951)', id: 0x2951, isEnabled: false},
          {name: 'rpcf_get_periodic_service_link (0x272a)', id: 0x272a, isEnabled: false},
          {name: 'rpcf_get_iptraffic_service_link_ipv6 (0x272f)', id: 0x272f, isEnabled: false},
          {name: 'rpcf_get_hotspot_service_link (0x272c)', id: 0x272c, isEnabled: false},
          {name: 'rpcf_get_dialup_service_link (0x272d)', id: 0x272d, isEnabled: false},
          {name: 'rpcf_get_once_service_link (0x2704)', id: 0x2704, isEnabled: false},
          {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: '__rpcs_get_routers_list (0x5043)', id: 0x5043, isEnabled: false},
          {name: 'rpcf_get_userinfo (0x2006)', id: 0x2006, isEnabled: false},
          {name: '__rpcf_get_uaparam_list (0x440b)', id: 0x440b, isEnabled: false},
          {name: 'rpcf_get_free_ips_for_house (0x15101)', id: 0x15101, isEnabled: false},
          {name: 'rpcf_get_bytes_in_kb (0x10002)', id: 0x10002, isEnabled: false},
          {name: 'rpcf_get_tclasses (0x2300)', id: 0x2300, isEnabled: false}]},
      {liname: 'Read',
        funcs: [{name: 'rpcf_delete_quota (0x20ff)', id: 0x20ff, isEnabled: false},
          {name: 'rpcf_edit_once_service_link_ex (0x2921)', id: 0x2921, isEnabled: false},
          {name: 'rpcf_edit_periodic_service_link_ex (0x2947)', id: 0x2947, isEnabled: false},
          {name: 'rpcf_edit_dialup_service_link_ex (0x2945)', id: 0x2945, isEnabled: false},
          {name: 'rpcf_edit_hotspot_service_link_ex (0x2942)', id: 0x2942, isEnabled: false},
          {name: 'rpcf_edit_iptraffic_service_link_ipv6 (0x2951)', id: 0x2951, isEnabled: false},
          {name: 'rpcf_get_periodic_service_link (0x272a)', id: 0x272a, isEnabled: false},
          {name: 'rpcf_get_iptraffic_service_link_ipv6 (0x272f)', id: 0x272f, isEnabled: false},
          {name: 'rpcf_get_hotspot_service_link (0x272c)', id: 0x272c, isEnabled: false},
          {name: 'rpcf_get_dialup_service_link (0x272d)', id: 0x272d, isEnabled: false},
          {name: 'rpcf_get_once_service_link (0x2704)', id: 0x2704, isEnabled: false},
          {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: '__rpcs_get_routers_list (0x5043)', id: 0x5043, isEnabled: false},
          {name: 'rpcf_get_userinfo (0x2006)', id: 0x2006, isEnabled: false},
          {name: '__rpcf_get_uaparam_list (0x440b)', id: 0x440b, isEnabled: false},
          {name: 'rpcf_get_free_ips_for_house (0x15101)', id: 0x15101, isEnabled: false},
          {name: 'rpcf_get_bytes_in_kb (0x10002)', id: 0x10002, isEnabled: false},
          {name: 'rpcf_get_tclasses (0x2300)', id: 0x2300, isEnabled: false}]},
      {liname: 'Delete', funcs: [{name: 'rpcf_delete_slink (0x5100)', id: 0x5100, isEnabled: false}]},
      {liname: 'Prepaid',
        funcs: [{name: 'rpcf_get_tclasses (0x2300)', id: 0x2300, isEnabled: false},
          {name: '__rpcs_get_prepaid_units (0x5500)', id: 0x5500, isEnabled: false},
          {name: '__rpcs_put_prepaid_units (0x5501)', id: 0x5501, isEnabled: false}]},
      {liname: 'Set Radius',
        funcs: [{name: 'rpcf_get_radius_attr (0x10106)', id: 0x10106, isEnabled: false},
          {name: 'rpcf_set_radius_attr (0x10105)', id: 0x10105, isEnabled: false}]}],
      UWUserGroups: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_groups_for_user (0x2550)', id: 0x2550, isEnabled: false}]},
        {liname: 'Add',
          funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false},
            {name: 'rpcf_add_group_to_user (0x2552)', id: 0x2552, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_user_from_group (0x2408)', id: 0x2408, isEnabled: false}]}],
      UWUserAdditional: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_user_contacts_new (0x2040)', id: 0x2040, isEnabled: false},
          {name: 'rpcf_edit_user_contact (0x2043)', id: 0x2043, isEnabled: false},
          {name: 'rpcf_get_user_contacts (0x2021)', id: 0x2021, isEnabled: false}]},
      {liname: 'Read', funcs: [{name: 'rpcf_get_user_contact (0x2041)', id: 0x2041, isEnabled: false}]},
      {liname: 'Edit',
        funcs: [{name: 'rpcf_get_user_contact (0x2041)', id: 0x2041, isEnabled: false},
          {name: 'rpcf_edit_user_contact (0x2043)', id: 0x2043, isEnabled: false}]},
      {liname: 'Add', funcs: [{name: 'rpcf_add_user_contact (0x2042)', id: 0x2042, isEnabled: false}]},
      {liname: 'Delete', funcs: [{name: 'rpcf_del_user_contact (0x2023)', id: 0x2023, isEnabled: false}]}],
      UWUserDocuments: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_contract_list (0x4611)', id: 0x4611, isEnabled: false}]},
        {liname: 'Add',
          funcs: [{name: 'rpcf_create_contract (0x4613)', id: 0x4613, isEnabled: false},
            {name: 'rpcf_upload_contract (0x4614)', id: 0x4614, isEnabled: false},
            {name: 'rpcf_get_document_templates_list (0x4606)', id: 0x4606, isEnabled: false}]},
        {liname: 'Read', funcs: [{name: 'rpcf_get_contract (0x4612)', id: 0x4612, isEnabled: false}]},
        {liname: 'Edit', funcs: [{name: 'rpcf_get_contract (0x4612)', id: 0x4612, isEnabled: false}]},
        {liname: 'Delete', funcs: [{name: 'rpcf_remove_contract (0x4615)', id: 0x4615, isEnabled: false}]}],
      UWUserGenerate: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_document (0x4620)', id: 0x4620, isEnabled: false}]}],
      UWDealerLinkdealer: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_dealers_list (0x13019)', id: 0x13019, isEnabled: false},
          {name: 'rpcf_grant_privileges_to_dealer (0x1301a)', id: 0x1301a, isEnabled: false}]}],
      UWContractsSigncontract: [{liname: 'Refresh', funcs: [{name: '28724 (0x7034)', id: 0x7034, isEnabled: false}]}],
      ReportsBlockings: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false},
          {name: 'rpcf_blocks_report_ex (0x300b)', id: 0x300b, isEnabled: false}]}],
      ReportsTraffic: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false},
          {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: 'rpcf_get_currency_list (0x2910)', id: 0x2910, isEnabled: false},
          {name: 'rpcf_get_tclasses (0x2300)', id: 0x2300, isEnabled: false},
          {name: 'rpcf_traffic_report_ex (0x3009)', id: 0x3009, isEnabled: false}]}],
      ReportsPayments: [{liname: 'Refresh', funcs: [{name: 'rpcf_payments_report_new (0x3030)', id: 0x3030, isEnabled: false}]}],
      ReportsInternalTransfer: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_funds_flow_report (0x501c)', id: 0x501c, isEnabled: false}]}],
      ReportsSessions: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: 'rpcf_get_currency_list (0x2910)', id: 0x2910, isEnabled: false},
          {name: '__rpcs_get_dhs_report (0x5019)', id: 0x5019, isEnabled: false}]}],
      ReportsGeneral: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false},
          {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: 'rpcf_get_currency_list (0x2910)', id: 0x2910, isEnabled: false},
          {name: 'rpcf_general_report_new (0x3025)', id: 0x3025, isEnabled: false}]}],
      ReportsTelephony: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: 'rpcf_get_tel_report (0x5037)', id: 0x5037, isEnabled: false}]}],
      ReportsServices: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false},
          {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: 'rpcf_get_currency_list (0x2910)', id: 0x2910, isEnabled: false},
          {name: 'rpcf_service_report_new (0x3021)', id: 0x3021, isEnabled: false}]}],
      ReportsOthercharges: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false},
          {name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: 'rpcf_get_currency_list (0x2910)', id: 0x2910, isEnabled: false},
          {name: 'rpcf_other_charges_report (0x3023)', id: 0x3023, isEnabled: false}]}],
      ReportsDetailedTraffic: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_tclasses (0x2300)', id: 0x2300, isEnabled: false},
          {name: 'rpcf_request_traffic_detailed (0x502a)', id: 0x502a, isEnabled: false},
          {name: 'rpcf_get_traffic_detailed (0x502b)', id: 0x502b, isEnabled: false}]}],
      ReportsUserLog: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_user_log (0x2136)', id: 0x2136, isEnabled: false}]}],
      ReportsExpiringPayments: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false},
          {name: 'rpcf_payments_timed_report (0x3006)', id: 0x3006, isEnabled: false}]}],
      ReportsInvoices: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false},
          {name: '__rpcf_get_invoices_list (0x8001)', id: 0x8001, isEnabled: false},
          {name: '__rpcf_get_invoices_doc_list (0x8041)', id: 0x8041, isEnabled: false}]}],
      ReportsGraphicReport: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_graph_data_dialup (0x5092)', id: 0x5092, isEnabled: false},
          {name: 'rpcf_get_graph_data_iptraffic (0x5091)', id: 0x5091, isEnabled: false},
          {name: 'rpcf_get_graph_data_telephony (0x5093)', id: 0x5093, isEnabled: false}]}],
      ReportsCustomreport: [{liname: 'Refresh', funcs: [{name: 'rpcf_custom_services_report (0x3114)', id: 0x3114, isEnabled: false}]}],
      ReportsTelephonydir: [{liname: 'Refresh',
        funcs: [{name: 'rpcf_get_accounting_periods (0x2600)', id: 0x2600, isEnabled: false},
          {name: 'rpcf_tel_directions_report (0x5060)', id: 0x5060, isEnabled: false}]}],
      ReportsDHCPlease: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_dhcp_leases_report (0x1354)', id: 0x1354, isEnabled: false}]}],
      ReportsGroups: [{liname: 'Refresh', funcs: [{name: 'rpcf_get_groups_list (0x2400)', id: 0x2400, isEnabled: false}]}],
      ReportsNewinvoice: [{liname: 'Refresh', funcs: [{name: 'rpcf_new_invoice (0x10205)', id: 0x10205, isEnabled: false}]}],
      ReportsSendmail: [{liname: 'Refresh', funcs: [{name: '__rpcf_sendInvoice2mail (0x8004)', id: 0x8004, isEnabled: false}]}],
      ReportsCancelpayment: [{liname: 'Refresh', funcs: [{name: 'rpcf_cancel_payment_for_account (0x3111)', id: 0x3111, isEnabled: false}]}],
      baseFunc: {button: false, check: false},
      mainView: {button: false, check: false},
      userAndGroup: {button: false, check: false},
      messages: {button: false, check: false},
      Tariffication: {button: false, check: false},
      Refbook: {button: false, check: false},
      editUserWindow: {button: false, check: false},
      Settings: {button: false, check: false},
      Additional: {button: false, check: false},
      Interfaces: {button: false, check: false},
      About: {button: false, check: false},
      userEdit: {button: false, check: false},
      f1C: {button: false, check: false},
      Devices: {button: false, check: false},
      UETariffication: {button: false, check: false},
      reports: {button: false, check: false},
      Users: {button: false, check: false},
      Orders: {button: false, check: false},
      Charges: {button: false, check: false},
      DialupAndVPN: {button: false, check: false},
      MainReport: {button: false, check: false},
      Telephony: {button: false, check: false},
      ServicesReports: {button: false, check: false},
      OtherCharges: {button: false, check: false},
      Dealer: {button: false, check: false},
      TrafficDetail: {button: false, check: false},
      UsersCharges: {button: false, check: false},
      BurnPayments: {button: false, check: false},
      Invoices: {button: false, check: false},
      GraphReport: {button: false, check: false},
      PersonalServices: {button: false, check: false},
      TelDir: {button: false, check: false},
      DHCPLeases: {button: false, check: false},
      GroupsReport: {button: false, check: false},
      NewInvoicesReports: {button: false, check: false},
      EmailSend: {button: false, check: false},
      PaymentRollBack: {button: false, check: false},
      DisconnectRADIUSSession: {button: false, check: false},
      DropRADIUSSession: {button: false, check: false},
      DropHotspotSession: {button: false, check: false},
      Provider: {button: false, check: false},
      DealerFunc: {button: false, check: false},
      Cashier: {button: false, check: false},
      Other: {button: false, check: false},
      WebInterfaceFunctions: {button: false, check: false},
      UaGUsers: {button: false, check: false},
      Blocks: {button: false, check: false},
      Traffic: {button: false, check: false},
      Payments: {button: false, check: false},
      UaGDealers: {button: false, check: false},
      UaGGroups: {button: false, check: false},
      UaGIPgroups: {button: false, check: false},
      UaGSysGroups: {button: false, check: false},
      UaGSysUsers: {button: false, check: false},
      UaGCardPool: {button: false, check: false},
      msgIncoming: {button: false, check: false},
      msgOutgoing: {button: false, check: false},
      msgNew: {button: false, check: false},
      msgDeleted: {button: false, check: false},
      tarifficationAccPeriod: {button: false, check: false},
      tarifficationServices: {button: false, check: false},
      tarifficationTemplServ: {button: false, check: false},
      tarifficationChargePolicies: {button: false, check: false},
      tarifficationTimeRanges: {button: false, check: false},
      tarifficationTimeRangesRefresh: {button: false, check: false},
      tarifficationTimeRangesAdd: {button: false, check: false},
      tarifficationTimeRangesDelete: {button: false, check: false},
      tarifficationTimeRangesEdit: {button: false, check: false},
      tarifficationTrafficClasses: {button: false, check: false},
      tarifficationTariffPlans: {button: false, check: false},
      tarifficationTelZones: {button: false, check: false},
      tarifficationTelDirs: {button: false, check: false},
      tarifficationCoefScheme: {button: false, check: false},
      tarifficationCoefSchedule: {button: false, check: false},
      tarifficationContractType: {button: false, check: false},
      RBPaymentMethods: {button: false, check: false},
      RBCurrency: {button: false, check: false},
      RBBuildings: {button: false, check: false},
      RBStreets: {button: false, check: false},
      RBBanks: {button: false, check: false},
      RBIPzones: {button: false, check: false},
      StgsParameters: {button: false, check: false},
      StgsAddParams: {button: false, check: false},
      StgsFirewalls: {button: false, check: false},
      StgsFrwRoles: {button: false, check: false},
      StgsNASlist: {button: false, check: false},
      StgsISGprofile: {button: false, check: false},
      StgsISGAttr: {button: false, check: false},
      StgsDocTemplates: {button: false, check: false},
      StgsProfilesDocs: {button: false, check: false},
      StgsReplInDoc: {button: false, check: false},
      StgsIpPools: {button: false, check: false},
      StgsDynamicShaping: {button: false, check: false},
      StgsCompanies: {button: false, check: false},
      StgsTelOperators: {button: false, check: false},
      StgsEmrgsCalls: {button: false, check: false},
      StgsRadAccs: {button: false, check: false},
      StgsArchiveDB: {button: false, check: false},
      StgsReplInDocs: {button: false, check: false},
      StgsNetFlowProvider: {button: false, check: false},
      StgsTrafficCollectors: {button: false, check: false},
      AdditionalSymbols: {button: false, check: false},
      AdditionalLibURFAPlugins: {button: false, check: false},
      AdditionalConnections: {button: false, check: false},
      AdditionalHSsession: {button: false, check: false},
      AdditionalRadSession: {button: false, check: false},
      AdditionalRadAttrs: {button: false, check: false},
      AdditionalChangePass: {button: false, check: false},
      InterfacesTraysettings: {button: false, check: false},
      InterfacesCashierSettings: {button: false, check: false},
      InterfacesSwitchtariff: {button: false, check: false},
      InterfacesVoluntary: {button: false, check: false},
      InterfacesPromised: {button: false, check: false},
      InterfacesInternal: {button: false, check: false},
      AboutRefresh: {button: false, check: false},
      AboutLicensesrefresh: {button: false, check: false},
      f1CSettings: {button: false, check: false},
      f1CSyncronized: {button: false, check: false},
      f1CInvoices: {button: false, check: false},
      f1CPayments: {button: false, check: false},
      Inventory: {button: false, check: false},
      Inventorytypes: {button: false, check: false},
      InventorySwitches: {button: false, check: false},
      Inventorypools: {button: false, check: false},
      Inventorylease: {button: false, check: false},
      UaGUsersRefresh: {button: false, check: false},
      UaGUsersAdd: {button: false, check: false},
      UaGUsersView: {button: false, check: false},
      UaGUsersEdit: {button: false, check: false},
      UaGUsersSearch: {button: false, check: false},
      UaGUsersNew: {button: false, check: false},
      UaGUsersPayment: {button: false, check: false},
      UaGUsersAddtogroup: {button: false, check: false},
      UaGUsersChange: {button: false, check: false},
      UaGDealerRefresh: {button: false, check: false},
      UaGDealerAdd: {button: false, check: false},
      UaGDealerRead: {button: false, check: false},
      UaGDealerEdit: {button: false, check: false},
      UaGDealerDelete: {button: false, check: false},
      UaGGroupsRefresh: {button: false, check: false},
      UaGGroupsAdd: {button: false, check: false},
      UaGGroupsRead: {button: false, check: false},
      UaGGroupsEdit: {button: false, check: false},
      UaGGroupsDelete: {button: false, check: false},
      UaGGroupsOp: {button: false, check: false},
      UaGSysGroupsRefresh: {button: false, check: false},
      UaGSysGroupsAdd: {button: false, check: false},
      UaGSysGroupsRead: {button: false, check: false},
      UaGSysGroupsEdit: {button: false, check: false},
      UaGSysGroupsDelete: {button: false, check: false},
      UaGSysUsersRefresh: {button: false, check: false},
      UaGSysUsersAdd: {button: false, check: false},
      UaGSysUsersRead: {button: false, check: false},
      UaGSysUsersEdit: {button: false, check: false},
      UaGSysUsersDelete: {button: false, check: false},
      UaGCardPoolRefresh: {button: false, check: false},
      UaGCardPoolAddcardowner: {button: false, check: false},
      UaGCardPoolRemove: {button: false, check: false},
      UaGCardPoolMove: {button: false, check: false},
      UaGCardPoolBlock: {button: false, check: false},
      UaGCardPoolUnblock: {button: false, check: false},
      UaGCardPoolRead: {button: false, check: false},
      UaGCardPoolAdd: {button: false, check: false},
      UaGCardPoolSearch: {button: false, check: false},
      tarifficationAccPeriodRefresh: {button: false, check: false},
      tarifficationAccPeriodAdd: {button: false, check: false},
      tarifficationAccPeriodRead: {button: false, check: false},
      tarifficationAccPeriodEdit: {button: false, check: false},
      tarifficationServicesRefresh: {button: false, check: false},
      tarifficationServicesAdd: {button: false, check: false},
      tarifficationServicesEdit: {button: false, check: false},
      tarifficationServicesDelete: {button: false, check: false},
      clicktarifficationTemplServRefresh: {button: false, check: false},
      clicktarifficationTemplServAdd: {button: false, check: false},
      clicktarifficationTemplServDelete: {button: false, check: false},
      tarifficationChargePoliciesRefresh: {button: false, check: false},
      tarifficationChargePoliciesAdd: {button: false, check: false},
      tarifficationChargePoliciesDelete: {button: false, check: false},
      tarifficationChargePoliciesRead: {button: false, check: false},
      tarifficationChargePoliciesEdit: {button: false, check: false},
      tarifficationTrafficClassesRefresh: {button: false, check: false},
      tarifficationTrafficClassesAdd: {button: false, check: false},
      tarifficationTrafficClassesDelete: {button: false, check: false},
      tarifficationTrafficClassesEdit: {button: false, check: false},
      tarifficationTrafficClassesRead: {button: false, check: false},
      tarifficationTariffPlansRefresh: {button: false, check: false},
      tarifficationTariffPlansAdd: {button: false, check: false},
      tarifficationTariffPlansDelete: {button: false, check: false},
      tarifficationTariffPlansEdit: {button: false, check: false},
      tarifficationTariffPlansRead: {button: false, check: false},
      tarifficationTelZonesRefresh: {button: false, check: false},
      tarifficationTelZonesAdd: {button: false, check: false},
      tarifficationTelZonesDelete: {button: false, check: false},
      tarifficationTelZonesEdit: {button: false, check: false},
      tarifficationTelZonesRead: {button: false, check: false},
      tarifficationTelDirsRefresh: {button: false, check: false},
      tarifficationTelDirsAdd: {button: false, check: false},
      tarifficationTelDirsDelete: {button: false, check: false},
      tarifficationTelDirsEdit: {button: false, check: false},
      tarifficationTelDirsRead: {button: false, check: false},
      tarifficationCoefSchemeRefresh: {button: false, check: false},
      tarifficationCoefSchemeAdd: {button: false, check: false},
      tarifficationCoefSchemeDelete: {button: false, check: false},
      tarifficationCoefSchemeEdit: {button: false, check: false},
      tarifficationCoefScheduleRefresh: {button: false, check: false},
      tarifficationCoefScheduleAdd: {button: false, check: false},
      tarifficationCoefScheduleDelete: {button: false, check: false},
      tarifficationCoefScheduleEdit: {button: false, check: false},
      tarifficationContractTypeRefresh: {button: false, check: false},
      tarifficationContractTypeAdd: {button: false, check: false},
      tarifficationContractTypeDelete: {button: false, check: false},
      tarifficationContractTypeEdit: {button: false, check: false},
      RBPaymentMethodsRefresh: {button: false, check: false},
      RBPaymentMethodsAdd: {button: false, check: false},
      RBPaymentMethodsEdit: {button: false, check: false},
      RBCurrencyRefresh: {button: false, check: false},
      RBCurrencyAdd: {button: false, check: false},
      RBCurrencyEdit: {button: false, check: false},
      RBCurrencyDelete: {button: false, check: false},
      RBCurrencyRead: {button: false, check: false},
      RBBuildingsRefresh: {button: false, check: false},
      RBBuildingsAdd: {button: false, check: false},
      RBBuildingsEdit: {button: false, check: false},
      RBBuildingsDelete: {button: false, check: false},
      RBBuildingsRead: {button: false, check: false},
      RBStreetsRefresh: {button: false, check: false},
      RBStreetsAdd: {button: false, check: false},
      RBStreetsEdit: {button: false, check: false},
      RBStreetsDelete: {button: false, check: false},
      RBStreetsRead: {button: false, check: false},
      RBBanksRefresh: {button: false, check: false},
      RBBanksAdd: {button: false, check: false},
      RBBanksEdit: {button: false, check: false},
      RBBanksDelete: {button: false, check: false},
      RBIPzonesRefresh: {button: false, check: false},
      RBIPzonesAdd: {button: false, check: false},
      RBIPzonesEdit: {button: false, check: false},
      RBIPzonesRead: {button: false, check: false},
      StgsParametersRefresh: {button: false, check: false},
      StgsAddParamsRefresh: {button: false, check: false},
      StgsAddParamsAdd: {button: false, check: false},
      StgsAddParamsEdit: {button: false, check: false},
      StgsAddParamsDelete: {button: false, check: false},
      StgsFirewallsRefresh: {button: false, check: false},
      StgsFirewallsAdd: {button: false, check: false},
      StgsFirewallsEdit: {button: false, check: false},
      StgsFirewallsDelete: {button: false, check: false},
      StgsFrwRolesRefresh: {button: false, check: false},
      StgsFrwRolesAdd: {button: false, check: false},
      StgsFrwRolesEdit: {button: false, check: false},
      StgsFrwRolesDelete: {button: false, check: false},
      StgsNASlistRefresh: {button: false, check: false},
      StgsNASlistAdd: {button: false, check: false},
      StgsNASlistEdit: {button: false, check: false},
      StgsNASlistDelete: {button: false, check: false},
      StgsNASlistRead: {button: false, check: false},
      StgsISGprofileRefresh: {button: false, check: false},
      StgsISGprofileAdd: {button: false, check: false},
      StgsISGprofileEdit: {button: false, check: false},
      StgsISGprofileDelete: {button: false, check: false},
      StgsISGprofileRead: {button: false, check: false},
      StgsISGAttrRefresh: {button: false, check: false},
      StgsISGAttrAdd: {button: false, check: false},
      StgsISGAttrEdit: {button: false, check: false},
      StgsISGAttrDelete: {button: false, check: false},
      StgsISGAttrRead: {button: false, check: false},
      StgsDocTemplatesRefresh: {button: false, check: false},
      StgsDocTemplatesAdd: {button: false, check: false},
      StgsDocTemplatesEdit: {button: false, check: false},
      StgsDocTemplatesDelete: {button: false, check: false},
      StgsDocTemplatesRead: {button: false, check: false},
      StgsDocTemplatesOthers: {button: false, check: false},
      StgsProfilesDocsRefresh: {button: false, check: false},
      StgsProfilesDocsAdd: {button: false, check: false},
      StgsProfilesDocsEdit: {button: false, check: false},
      StgsProfilesDocsDelete: {button: false, check: false},
      StgsProfilesDocsRead: {button: false, check: false},
      StgsReplInDocRefresh: {button: false, check: false},
      StgsReplInDocAdd: {button: false, check: false},
      StgsReplInDocEdit: {button: false, check: false},
      StgsReplInDocDelete: {button: false, check: false},
      StgsIpPoolsRefresh: {button: false, check: false},
      StgsIpPoolsAdd: {button: false, check: false},
      StgsIpPoolsEdit: {button: false, check: false},
      StgsIpPoolsDelete: {button: false, check: false},
      StgsIpPoolsRead: {button: false, check: false},
      StgsDynamicShapingRefresh: {button: false, check: false},
      StgsDynamicShapingAdd: {button: false, check: false},
      StgsDynamicShapingEdit: {button: false, check: false},
      StgsDynamicShapingDelete: {button: false, check: false},
      StgsDynamicShapingRead: {button: false, check: false},
      StgsCompaniesRefresh: {button: false, check: false},
      StgsCompaniesAdd: {button: false, check: false},
      StgsCompaniesEdit: {button: false, check: false},
      StgsCompaniesDelete: {button: false, check: false},
      StgsCompaniesRead: {button: false, check: false},
      StgsTelOperatorsRefresh: {button: false, check: false},
      StgsTelOperatorsAdd: {button: false, check: false},
      StgsTelOperatorsEdit: {button: false, check: false},
      StgsTelOperatorsDelete: {button: false, check: false},
      StgsTelOperatorsRead: {button: false, check: false},
      StgsEmrgsCallsRefresh: {button: false, check: false},
      StgsEmrgsCallsAdd: {button: false, check: false},
      StgsEmrgsCallsEdit: {button: false, check: false},
      StgsEmrgsCallsDelete: {button: false, check: false},
      StgsRadAccsRefresh: {button: false, check: false},
      StgsRadAccsAdd: {button: false, check: false},
      StgsRadAccsEdit: {button: false, check: false},
      StgsRadAccsDelete: {button: false, check: false},
      StgsNetFlowProviderRefresh: {button: false, check: false},
      StgsNetFlowProviderAdd: {button: false, check: false},
      StgsNetFlowProviderEdit: {button: false, check: false},
      StgsNetFlowProviderDelete: {button: false, check: false},
      StgsTrafficCollectorsRefresh: {button: false, check: false},
      StgsTrafficCollectorsAdd: {button: false, check: false},
      StgsTrafficCollectorsEdit: {button: false, check: false},
      StgsTrafficCollectorsDelete: {button: false, check: false},
      AdditionalLibURFAPluginsRefresh: {button: false, check: false},
      AdditionalLibURFAPluginsLoad: {button: false, check: false},
      AdditionalLibURFAPluginsUnload: {button: false, check: false},
      AdditionalLibURFAPluginsReload: {button: false, check: false},
      InterfacesSwitchtariffRefresh: {button: false, check: false},
      InterfacesSwitchtariffAdd: {button: false, check: false},
      InterfacesSwitchtariffEdit: {button: false, check: false},
      InterfacesSwitchtariffDelete: {button: false, check: false},
      InterfacesVoluntaryRefresh: {button: false, check: false},
      InterfacesVoluntaryAdd: {button: false, check: false},
      InterfacesVoluntaryEdit: {button: false, check: false},
      InterfacesVoluntaryDelete: {button: false, check: false},
      InterfacesPromisedRefresh: {button: false, check: false},
      InterfacesPromisedAdd: {button: false, check: false},
      InterfacesPromisedEdit: {button: false, check: false},
      InterfacesPromisedDelete: {button: false, check: false},
      InterfacesInternalRefresh: {button: false, check: false},
      InterfacesInternalAdd: {button: false, check: false},
      InterfacesInternalEdit: {button: false, check: false},
      InterfacesInternalDelete: {button: false, check: false},
      InventorytypesRefresh: {button: false, check: false},
      InventorytypesAdd: {button: false, check: false},
      InventorytypesEdit: {button: false, check: false},
      InventorytypesDelete: {button: false, check: false},
      InventorytypesRead: {button: false, check: false},
      InventorySwitchesRefresh: {button: false, check: false},
      InventorySwitchesAdd: {button: false, check: false},
      InventorySwitchesEdit: {button: false, check: false},
      InventorySwitchesDelete: {button: false, check: false},
      InventorySwitchesRead: {button: false, check: false},
      InventorypoolsRefresh: {button: false, check: false},
      InventorypoolsAdd: {button: false, check: false},
      InventorypoolsEdit: {button: false, check: false},
      InventorypoolsDelete: {button: false, check: false},
      InventorypoolsRead: {button: false, check: false},
      UETarifficationTP: {button: false, check: false},
      UETarifficationIPTVac: {button: false, check: false},
      UETarifficationAccs: {button: false, check: false},
      UETarifficationTL: {button: false, check: false},
      UETarifficationSL: {button: false, check: false},
      UEUsers: {button: false, check: false},
      UEUsersGroups: {button: false, check: false},
      UEUsersAdds: {button: false, check: false},
      UEUsersDocs: {button: false, check: false},
      UEUsersGenUsr: {button: false, check: false},
      MainAddSymbolRefresh: {button: false, check: false},
      UWTrfTechParamRefresh: {button: false, check: false},
      UWTrfTechParamAdd: {button: false, check: false},
      UWTrfTechParamEdit: {button: false, check: false},
      UWTrfTechParamDelete: {button: false, check: false},
      UWTrfTechParamRead: {button: false, check: false},
      UWTrfIPTVacRefresh: {button: false, check: false},
      UWTrfIPTVacAdd: {button: false, check: false},
      UWTrfAccRefresh: {button: false, check: false},
      UWTrfAccAdd: {button: false, check: false},
      UWTrfAccEdit: {button: false, check: false},
      UWTrfAccDelete: {button: false, check: false},
      UWTrfSLRefresh: {button: false, check: false},
      UWTrfSLAdd: {button: false, check: false},
      UWTrfSLEdit: {button: false, check: false},
      UWTrfSLDelete: {button: false, check: false},
      UWTrfSLRead: {button: false, check: false},
      UWTrfSLPrepaid: {button: false, check: false},
      UWTrfSLSetRadius: {button: false, check: false},
      UWTrfTLRefresh: {button: false, check: false},
      UWTrfTLAdd: {button: false, check: false},
      UWTrfTLEdit: {button: false, check: false},
      UWTrfTLDelete: {button: false, check: false},
      UWTrfTLRead: {button: false, check: false},
      UWTrfTLHistory: {button: false, check: false},
      UWTrfTLAddSl: {button: false, check: false},
      UWTrfTLGroups: {button: false, check: false},
      UWTrfTLDoc: {button: false, check: false},
      UWTrfTLGen: {button: false, check: false},
      UWUserGroupRefresh: {button: false, check: false},
      UWUserGroupAdd: {button: false, check: false},
      UWUserGroupDelete: {button: false, check: false},
      UWUserAddContactsRefresh: {button: false, check: false},
      UWUserAddContactsAdd: {button: false, check: false},
      UWUserAddContactsDelete: {button: false, check: false},
      UWUserAddContactsEdit: {button: false, check: false},
      UWUserAddContactsRead: {button: false, check: false},
      UWUserDocsRefresh: {button: false, check: false},
      UWUserDocsAdd: {button: false, check: false},
      UWUserDocsDelete: {button: false, check: false},
      UWUserDocsEdit: {button: false, check: false},
      UWUserDocsRead: {button: false, check: false},
      baseFuncsIDs: [{name: 'rpcf_whoami ', id: 0x4417, isEnabled: false},
        {name: 'Get-Core-Version ', id: 0x45, isEnabled: false},
        {name: 'Get-Core-Version-String ', id: 0x41, isEnabled: false},
        {name: 'Get-Core-BUILD ', id: 0x46, isEnabled: false},
        {name: 'rpcf_get_core_time ', id: 0x11112, isEnabled: false},
        {name: 'rpcf_get_timezone ', id: 0x11113, isEnabled: false}],
      DisconnectRADIUSSessionFuncsIDs: [{name: 'rpcf_radius_disconnect_session', id: 0x1071, isEnabled: false}],
      DropRADIUSSessionFuncsIDs: [{name: 'rpcf_radius_drop_session', id: 0x1072, isEnabled: false}],
      DropHotspotSessionFuncsIDs: [{name: 'rpcf_hotspot2_close', id: 0x4306, isEnabled: false}],
      ProviderFuncsIDs: [{name: 'rpcs_get_banks', id: 0x6002, isEnabled: false}],
      DealerFuncsIDs: [],
      OtherFuncsIDs: [{name: 'Get-Core-Stats', id: 0x47, isEnabled: false},
        {name: 'Get-FW-Subst', id: 0x49, isEnabled: false},
        {name: 'urfaclient-call', id: 0xa2, isEnabled: false},
        {name: 'rpcf_archivate', id: 0xfe, isEnabled: false},
        {name: 'Temporary-lock-db-write', id: 0xff, isEnabled: false},
        {name: 'Check-License', id: 0x102, isEnabled: false},
        {name: 'Get-Registry-Settings-Form', id: 0x104, isEnabled: false},
        {name: 'Set-Registry-Setting', id: 0x105, isEnabled: false},
        {name: 'rpcf_add_switch_type', id: 0x506, isEnabled: false},
        {name: 'rpcf_radius_chap_autoadd', id: 0x1006, isEnabled: false},
        {name: 'rpcf_radius_drop_session_by_slink', id: 0x1074, isEnabled: false},
        {name: 'rpcf_give_dhcp_options_list', id: 0x1101, isEnabled: false},
        {name: 'rpcf_remove_dhcp_options', id: 0x1102, isEnabled: false},
        {name: 'rpcf_add_dhcp_option', id: 0x1107, isEnabled: false},
        {name: 'rpcf_search_switches', id: 0x1156, isEnabled: false},
        {name: 'rpcf_get_switch_ports_usage', id: 0x1158, isEnabled: false},
        {name: 'rpcf_get_switch_dhcp_pool_links', id: 0x1160, isEnabled: false},
        {name: 'rpcf_edit_switch_dhcp_pool_links', id: 0x1163, isEnabled: false},
        {name: 'rpcf_search_users_lite', id: 0x1202, isEnabled: false},
        {name: 'rpcf_make_lease_expired', id: 0x1351, isEnabled: false},
        {name: 'rpcf_remove_lease', id: 0x1352, isEnabled: false},
        {name: 'rpcf_get_isg_auth_attr_data', id: 0x1410, isEnabled: false},
        {name: 'rpcf_get_isg_auth_attr_data_list', id: 0x1411, isEnabled: false},
        {name: 'rpcf_add_isg_auth_attr_data', id: 0x1412, isEnabled: false},
        {name: 'rpcf_edit_isg_auth_attr_data', id: 0x1413, isEnabled: false},
        {name: 'rpcf_delete_isg_auth_attr_data', id: 0x1414, isEnabled: false},
        {name: 'rpcf_get_login_for_slink', id: 0x200d, isEnabled: false},
        {name: 'rpcf_block_account', id: 0x2037, isEnabled: false},
        {name: 'rpcf_change_account_balance', id: 0x2045, isEnabled: false},
        {name: 'rpcf_get_iptraffic_service', id: 0x2105, isEnabled: false},
        {name: 'rpcf_add_periodic_service', id: 0x2106, isEnabled: false},
        {name: 'rpcf_add_iptraffic_service', id: 0x2107, isEnabled: false},
        {name: 'rpcf_add_hotspot_service', id: 0x2108, isEnabled: false},
        {name: 'rpcf_get_hotspot_service', id: 0x2109, isEnabled: false},
        {name: 'rpcf_add_once_service', id: 0x210b, isEnabled: false},
        {name: 'rpcf_add_dialup_service', id: 0x210d, isEnabled: false},
        {name: 'rpcf_get_hotspot_services_list', id: 0x210f, isEnabled: false},
        {name: 'rpcf_get_fictive_services_list', id: 0x2110, isEnabled: false},
        {name: 'rpcf_add_once_service_new', id: 0x2116, isEnabled: false},
        {name: 'rpcf_add_periodic_service_batch', id: 0x2120, isEnabled: false},
        {name: 'rpcf_add_iptraffic_service_batch', id: 0x2121, isEnabled: false},
        {name: 'rpcf_get_periodic_service', id: 0x2144, isEnabled: false},
        {name: 'rpcf_get_group_id_by_name', id: 0x240c, isEnabled: false},
        {name: 'rpcf_get_once_service_link_new', id: 0x2556, isEnabled: false},
        {name: 'rpcf_get_first_accounting_period_id', id: 0x2601, isEnabled: false},
        {name: 'rpcf_add_discount_period', id: 0x2603, isEnabled: false},
        {name: 'rpcf_expire_discount_period', id: 0x2606, isEnabled: false},
        {name: 'rpcf_get_all_discount_periods', id: 0x2607, isEnabled: false},
        {name: 'rpcf_get_iptraffic_service_link', id: 0x2702, isEnabled: false},
        {name: 'rpcf_add_ipzone', id: 0x2801, isEnabled: false},
        {name: 'rpcf_get_ipzone', id: 0x2802, isEnabled: false},
        {name: 'rpcf_get_ ip -mac from arp cache', id: 0x2814, isEnabled: false},
        {name: 'rpcf_get_ipgroup', id: 0x2902, isEnabled: false},
        {name: 'rpcf_add_iptraffic_service_link_ex', id: 0x2928, isEnabled: false},
        {name: 'rpcf_edit_iptraffic_service_link_ex', id: 0x2929, isEnabled: false},
        {name: 'rpcf_check_radius_logins', id: 0x293c, isEnabled: false},
        {name: 'rpcf_enable_turbo_mode', id: 0x293d, isEnabled: false},
        {name: 'rpcf_blocks_report', id: 0x3004, isEnabled: false},
        {name: 'rpcf_payments_report_owner', id: 0x3008, isEnabled: false},
        {name: 'rpcf_edit_block', id: 0x300c, isEnabled: false},
        {name: 'rpcf_delete_block', id: 0x300d, isEnabled: false},
        {name: 'rpcf_add_tariff', id: 0x3012, isEnabled: false},
        {name: 'rpcf_edit_tariff', id: 0x3013, isEnabled: false},
        {name: 'rpcf_get_tariff_id_by_name', id: 0x301d, isEnabled: false},
        {name: 'rpcf_get_tplink_for_user', id: 0x301e, isEnabled: false},
        {name: 'rpcf_add_payment_for_account', id: 0x3110, isEnabled: false},
        {name: 'card-add', id: 0x4202, isEnabled: false},
        {name: 'rpcf_add_hotspot_user', id: 0x4292, isEnabled: false},
        {name: '__rpcf_get_sysuser_name', id: 0x4408, isEnabled: false},
        {name: '__rpcf_del_uaparam', id: 0x440d, isEnabled: false},
        {name: 'rpcf_add_iptv_service_link', id: 0x4504, isEnabled: false},
        {name: 'rpcf_edit_iptv_service_link', id: 0x4505, isEnabled: false},
        {name: 'rpcf_get_iptv_service_link', id: 0x4506, isEnabled: false},
        {name: 'rpcf_create_access_card', id: 0x4509, isEnabled: false},
        {name: 'rpcf_get_access_card_status', id: 0x450a, isEnabled: false},
        {name: 'rpcf_get_media_contents', id: 0x450d, isEnabled: false},
        {name: 'rpcf_get_media_groups', id: 0x450e, isEnabled: false},
        {name: 'rpcf_add_vod_service_link', id: 0x4514, isEnabled: false},
        {name: 'rpcf_edit_vod_service_link', id: 0x4515, isEnabled: false},
        {name: 'rpcf_get_vod_service_link', id: 0x4516, isEnabled: false},
        {name: 'rpcf_get_iptv_custom_data', id: 0x4517, isEnabled: false},
        {name: 'rpcf_set_iptv_custom_data', id: 0x4518, isEnabled: false},
        {name: 'rpcf_irdeto_pair_chipset', id: 0x4519, isEnabled: false},
        {name: 'rpcf_irdeto_unpair_all_chipsets', id: 0x451a, isEnabled: false},
        {name: 'rpcf_irdeto_overwrite_parental_pin_code', id: 0x451b, isEnabled: false},
        {name: 'rpcf_irdeto_synchronize', id: 0x451c, isEnabled: false},
        {name: 'rpcf_irdeto_activate', id: 0x451d, isEnabled: false},
        {name: 'rpcf_irdeto_deactivate', id: 0x451e, isEnabled: false},
        {name: 'rpcf_add_iptv_service', id: 0x4520, isEnabled: false},
        {name: 'rpcf_edit_iptv_service', id: 0x4521, isEnabled: false},
        {name: 'rpcf_get_iptv_service', id: 0x4522, isEnabled: false},
        {name: 'rpcf_add_vod_service', id: 0x4530, isEnabled: false},
        {name: 'rpcf_edit_vod_service', id: 0x4531, isEnabled: false},
        {name: 'rpcf_get_vod_service', id: 0x4532, isEnabled: false},
        {name: 'rpcf_set_document_profile_for_user', id: 0x460f, isEnabled: false},
        {name: 'rpcf_get_document_profile_for_user', id: 0x4610, isEnabled: false},
        {name: 'rpcf_upload_document', id: 0x4621, isEnabled: false},
        {name: 'rpcf_remove_document', id: 0x4622, isEnabled: false},
        {name: 'rpcf_revert_document', id: 0x4623, isEnabled: false},
        {name: 'rpcf_get_coeff_scheme', id: 0x4700, isEnabled: false},
        {name: 'rpcf_get_coeff_schedule', id: 0x4705, isEnabled: false},
        {name: 'rpcf_get_coeff_schedule_link', id: 0x4710, isEnabled: false},
        {name: 'rpcf_get_coeff_schedule_link_list', id: 0x4711, isEnabled: false},
        {name: 'rpcf_add_coeff_schedule_link', id: 0x4712, isEnabled: false},
        {name: 'rpcf_edit_coeff_schedule_link', id: 0x4713, isEnabled: false},
        {name: 'rpcf_del_coeff_schedule_link', id: 0x4714, isEnabled: false},
        {name: 'rpcf_get_contract_type', id: 0x4800, isEnabled: false},
        {name: '__rpcf_get_messages_list', id: 0x5000, isEnabled: false},
        {name: '__rpcf_add_message', id: 0x5001, isEnabled: false},
        {name: '__rpcs_del_router', id: 0x5012, isEnabled: false},
        {name: '__rpcs_update_message_state', id: 0x5029, isEnabled: false},
        {name: 'rpcf_set_traffic_quota_on_link', id: 0x5033, isEnabled: false},
        {name: 'rpcf_put_unif_iptr', id: 0x5511, isEnabled: false},
        {name: 'rpcf_get_doc_invoices_entries', id: 0x7040, isEnabled: false},
        {name: 'rpcf_reverse_invoice_entry', id: 0x7041, isEnabled: false},
        {name: 'rpcf_delete_invoice', id: 0x7042, isEnabled: false},
        {name: '__rpcf_get_currency_rate_to_date', id: 0x8003, isEnabled: false},
        {name: '__rpcf_sendDocument2mail', id: 0x8005, isEnabled: false},
        {name: '__rpcf_make_payment_for_supplier', id: 0x8018, isEnabled: false},
        {name: 'rpcf_get_supplier_id_for_service', id: 0x8021, isEnabled: false},
        {name: 'rpcf_set_supplier_id_for_service', id: 0x8022, isEnabled: false},
        {name: 'rpcf_get_suppliers_directions', id: 0x8023, isEnabled: false},
        {name: 'rpcf_cportal_get_daily_accouting_period', id: 0x8100, isEnabled: false},
        {name: 'rpcf_cportal_check_user', id: 0x8101, isEnabled: false},
        {name: 'rpcf_cportal_add_user', id: 0x8102, isEnabled: false},
        {name: 'rpcf_get_user_staticsets', id: 0x9020, isEnabled: false},
        {name: 'rpcf_get_periodic_component_of_cost', id: 0x10000, isEnabled: false},
        {name: 'rpcf_get_radius_account', id: 0x10150, isEnabled: false},
        {name: 'rpcf_put_tel_call', id: 0x10310, isEnabled: false},
        {name: 'rpcf_is_tel_number_used', id: 0x10311, isEnabled: false},
        {name: 'rpcf_add_tel_supplier_service', id: 0x10312, isEnabled: false},
        {name: 'rpcf_edit_tel_supplier_service', id: 0x10313, isEnabled: false},
        {name: 'rpcf_get_tel_supplier_service', id: 0x10314, isEnabled: false},
        {name: 'rpcf_delete_tel_supplier_service', id: 0x10315, isEnabled: false},
        {name: 'rpcf_tel_supplier_payments_report', id: 0x10316, isEnabled: false},
        {name: 'rpcf_get_service_id_for_supplier', id: 0x10318, isEnabled: false},
        {name: 'rpcf_get_tel_number_list', id: 0x10319, isEnabled: false},
        {name: 'rpcf_get_founded_tel_dirs_count', id: 0x1031f, isEnabled: false},
        {name: 'rpcf_put_tel_call_list', id: 0x10320, isEnabled: false},
        {name: 'rpcf_validate_tel_supplier_dirs', id: 0x10321, isEnabled: false},
        {name: 'rpcf_tel_supplier_charges_report', id: 0x10322, isEnabled: false},
        {name: 'rpcf_tel_supplier_invoices_report', id: 0x10324, isEnabled: false},
        {name: 'rpcf_tel_supplier_users_report', id: 0x10325, isEnabled: false},
        {name: 'rpcf_search_tel_dirs', id: 0x1032b, isEnabled: false},
        {name: 'rpcf_add_tel_service_link', id: 0x1033a, isEnabled: false},
        {name: 'rpcf_edit_tel_service_link', id: 0x1033b, isEnabled: false},
        {name: 'rpcf_get_tel_service_link', id: 0x1033c, isEnabled: false},
        {name: 'rpcf_add_tel_service', id: 0x1043d, isEnabled: false},
        {name: 'rpcf_edit_tel_service', id: 0x1043e, isEnabled: false},
        {name: 'rpcf_get_tel_service', id: 0x1043f, isEnabled: false},
        {name: 'rpcf_get_slink_shaping', id: 0x12009, isEnabled: false},
        {name: 'rpcf_report_dealer_users', id: 0x1300e, isEnabled: false},
        {name: 'rpcf_report_dealer_payments', id: 0x1300f, isEnabled: false},
        {name: 'rpcf_report_dealer_payments_ex', id: 0x13010, isEnabled: false},
        {name: 'rpcf_get_dealer_contacts', id: 0x13011, isEnabled: false},
        {name: 'rpcf_submit_dealer_contact', id: 0x13012, isEnabled: false},
        {name: 'rpcf_delete_dealer_contact', id: 0x13013, isEnabled: false},
        {name: 'rpcf_verify_dealer_cache', id: 0x1301d, isEnabled: false},
        {name: 'rpcf_blocks_report_for_dealer', id: 0x1301f, isEnabled: false},
        {name: 'rpcf_general_report_for_dealer', id: 0x13020, isEnabled: false},
        {name: 'rpcf_payments_report_for_dealer', id: 0x13022, isEnabled: false},
        {name: 'rpcf_service_report_for_dealer', id: 0x13023, isEnabled: false},
        {name: 'rpcf_traffic_report_for_dealer', id: 0x13024, isEnabled: false},
        {name: 'rpcf_dhs_report_for_dealer', id: 0x13025, isEnabled: false},
        {name: 'rpcf_invoices_list_for_dealer', id: 0x13026, isEnabled: false},
        {name: 'rpcf_tel_report_for_dealer', id: 0x13028, isEnabled: false},
        {name: 'rpcf_change_priority_switch_tariff_settings', id: 0x15020, isEnabled: false},
        {name: 'rpcf_add_funds_flow_settings', id: 0x15025, isEnabled: false},
        {name: 'rpcf_set_charge_policy_for_service', id: 0x15106, isEnabled: false},
        {name: 'rpcf_get_charge_policy_for_service', id: 0x15107, isEnabled: false},
        {name: 'rpcf_get_periodic_link_stats', id: 0x15108, isEnabled: false},
        {name: 'rpcf_add_user_log', id: 0x1510c, isEnabled: false},
        {name: 'rpcf_add_ip_to_slink', id: 0x1510d, isEnabled: false},
        {name: 'rpcf_remove_ip_from_slink', id: 0x1510e, isEnabled: false},
        {name: 'rpcf_get_multiple_linking_for_service', id: 0x1510f, isEnabled: false},
        {name: 'rpcf_set_multiple_linking_for_service', id: 0x15110, isEnabled: false}],
      CashierFuncsIDs: [{name: 'Get-Core-Version', id: 0x45, isEnabled: false},
        {name: 'Get-Core-BUILD', id: 0x46, isEnabled: false},
        {name: 'rpcf_search_users_new', id: 0x1206, isEnabled: false},
        {name: 'rpcf_get_userinfo', id: 0x2006, isEnabled: false},
        {name: 'rpcf_get_user_by_account', id: 0x2026, isEnabled: false},
        {name: 'rpcf_get_user_account_list', id: 0x2033, isEnabled: false},
        {name: 'rpcf_get_cashier_settings', id: 0x212c, isEnabled: false},
        {name: 'rpcf_get_accounting_periods', id: 0x2600, isEnabled: false},
        {name: 'rpcf_get_currency_list', id: 0x2910, isEnabled: false},
        {name: 'rpcf_payments_report_owner_ex', id: 0x300a, isEnabled: false},
        {name: 'rpcf_add_payment_for_account_notify', id: 0x3113, isEnabled: false},
        {name: 'rpcf_whoami', id: 0x4417, isEnabled: false},
        {name: 'rpcf_get_core_time', id: 0x11112, isEnabled: false},
        {name: 'rpcf_get_accountinfo', id: 0x15109, isEnabled: false}],
      WebInterfaceFunctionsFuncsIDs: [{name: 'rpcf_radius_user_autoadd', id: 0x1005, isEnabled: false},
        {name: 'rpcf_edit_user_new', id: 0x2126, isEnabled: false},
        {name: 'hotspot-refresh-hnas', id: 0x4305, isEnabled: false},
        {name: 'rpcf_hotspot2_close', id: 0x4306, isEnabled: false},
        {name: 'Get-Setting-Compat', id: 0x4404, isEnabled: false}]
    }
  },
  methods: {
    clickEditUserWindow () {
      this.editUserWindow.button ? this.editUserWindow.button = false : this.editUserWindow.button = true
    },
    clickMainView () {
      this.mainView.button ? this.mainView.button = false : this.mainView.button = true
    },
    clickuserAndGroup () {
      this.userAndGroup.button ? this.userAndGroup.button = false : this.userAndGroup.button = true
    },
    clickmessages () {
      this.messages.button ? this.messages.button = false : this.messages.button = true
    },
    clickTariffication () {
      this.Tariffication.button ? this.Tariffication.button = false : this.Tariffication.button = true
    },
    clickRefbook () {
      this.Refbook.button ? this.Refbook.button = false : this.Refbook.button = true
    },
    clickSettings () {
      this.Settings.button ? this.Settings.button = false : this.Settings.button = true
    },
    clickAdditional () {
      this.Additional.button ? this.Additional.button = false : this.Additional.button = true
    },
    clickInterfaces () {
      this.Interfaces.button ? this.Interfaces.button = false : this.Interfaces.button = true
    },
    clickAbout () {
      this.About.button ? this.About.button = true : this.About.button = false
    },
    click1C () {
      this.f1C.button ? this.f1C.button = false : this.f1C.button = true
    },
    clickDevices () {
      this.Devices.button ? this.Devices.button = false : this.Devices.button = true
    },
    clickUETariffication () {
      this.UETariffication.button ? this.UETariffication.button = false : this.UETariffication.button = true
    },
    clickUsers () {
      this.UEUsers.button ? this.UEUsers.button = false : this.UEUsers.button = true
    },
    clickReports () {
      this.reports.button ? this.reports.button = false : this.reports.button = true
    },
    clickDealer () {
      this.Dealer.button ? this.Dealer.button = false : this.Dealer.button = true
    },
    clickOrders () {
      this.Orders.button ? this.Orders.button = false : this.Orders.button = true
    },
    clickCharges () {
      this.Charges.button ? this.Charges.button = false : this.Charges.button = true
    },
    clickDialupAndVPN () {
      this.DialupAndVPN.button ? this.DialupAndVPN.button = false : this.DialupAndVPN.button = true
    },
    clickMainReport () {
      this.MainReport.button ? this.MainReport.button = false : this.MainReport.button = true
    },
    clickTelephony () {
      this.Telephony.button ? this.Telephony.button = false : this.Telephony.button = true
    },
    clickServicesReports () {
      this.ServicesReports.button ? this.ServicesReports.button = false : this.ServicesReports.button = true
    },
    clickOtherCharges () {
      this.OtherCharges.button ? this.OtherCharges.button = false : this.OtherCharges.button = true
    },
    clickTrafficDetail () {
      this.TrafficDetail.button ? this.TrafficDetail.button = false : this.TrafficDetail.button = true
    },
    clickUsersCharges () {
      this.UsersCharges.button ? this.UsersCharges.button = false : this.UsersCharges.button = true
    },
    clickBurnPayments () {
      this.BurnPayments.button ? this.BurnPayments.button = false : this.BurnPayments.button = true
    },
    clickInvoices () {
      this.Invoices.button ? this.Invoices.button = false : this.Invoices.button = true
    },
    clickGraphReport () {
      this.GraphReport.button ? this.GraphReport.button = false : this.GraphReport.button = true
    },
    clickPersonalServices () {
      this.PersonalServices.button ? this.PersonalServices.button = false : this.PersonalServices.button = true
    },
    clickTelDir () {
      this.TelDir.button ? this.TelDir.button = false : this.TelDir.button = true
    },
    clickDHCPLeases () {
      this.DHCPLeases.button ? this.DHCPLeases.button = false : this.DHCPLeases.button = true
    },
    clickGroupsReport () {
      this.GroupsReport.button ? this.GroupsReport.button = false : this.GroupsReport.button = true
    },
    clickNewInvoicesReports () {
      this.NewInvoicesReports.button ? this.NewInvoicesReports.button = false : this.NewInvoicesReports.button = true
    },
    clickEmailSend () {
      this.EmailSend.button ? this.EmailSend.button = false : this.EmailSend.button = true
    },
    clickPaymentRollBack () {
      this.PaymentRollBack.button ? this.PaymentRollBack.button = false : this.PaymentRollBack.button = true
    },
    clickDisconnectRADIUSSession () {
      this.DisconnectRADIUSSession.button ? this.DisconnectRADIUSSession.button = false : this.DisconnectRADIUSSession.button = true
    },
    clickDropRADIUSSession () {
      this.DropRADIUSSession.button ? this.DropRADIUSSession.button = false : this.DropRADIUSSession.button = true
    },
    clickDropHotspotSession () {
      this.DropHotspotSession.button ? this.DropHotspotSession.button = false : this.DropHotspotSession.button = true
    },
    clickProvider () {
      this.Provider.button ? this.Provider.button = false : this.Provider.button = true
    },
    clickDealerFunc () {
      this.DealerFunc.button ? this.DealerFunc.button = false : this.DealerFunc.button = true
    },
    clickCashier () {
      this.Cashier.button ? this.Cashier.button = false : this.Cashier.button = true
    },
    clickOther () {
      this.Other.button ? this.Other.button = false : this.Other.button = true
    },
    clickWebInterfaceFunctions () {
      this.WebInterfaceFunctions.button ? this.WebInterfaceFunctions.button = false : this.WebInterfaceFunctions.button = true
    },
    clickUaGUsers () {
      this.UaGUsers.button ? this.UaGUsers.button = false : this.UaGUsers.button = true
    },
    clickBlocks () {
      this.Blocks.button ? this.Blocks.button = false : this.Blocks.button = true
    },
    clickTraffic () {
      this.Traffic.button ? this.Traffic.button = false : this.Traffic.button = true
    },
    clickPayments () {
      this.Payments.button ? this.Payments.button = false : this.Payments.button = true
    },
    clickUaGDealers () {
      this.UaGDealers.button ? this.UaGDealers.button = false : this.UaGDealers.button = true
    },
    clickUaGGroups () {
      this.UaGGroups.button ? this.UaGGroups.button = false : this.UaGGroups.button = true
    },
    clickUaGIPgroups () {
      this.UaGIPgroups.button ? this.UaGIPgroups.button = false : this.UaGIPgroups.button = true
    },
    clickUaGSysGroups () {
      this.UaGSysGroups.button ? this.UaGSysGroups.button = false : this.UaGSysGroups.button = true
    },
    clickUaGSysUsers () {
      this.UaGSysUsers.button ? this.UaGSysUsers.button = false : this.UaGSysUsers.button = true
    },
    clickUaGCardPool () {
      this.UaGCardPool.button ? this.UaGCardPool.button = false : this.UaGCardPool.button = true
    },
    clickmsgIncoming () {
      this.msgIncoming.button ? this.msgIncoming.button = false : this.msgIncoming.button = true
    },
    clickmsgOutgoing () {
      this.msgOutgoing.button ? this.msgOutgoing.button = false : this.msgOutgoing.button = true
    },
    clickmsgNew () {
      this.msgNew.button ? this.msgNew.button = false : this.msgNew.button = true
    },
    clickmsgDeleted () {
      this.msgDeleted.button ? this.msgDeleted.button = false : this.msgDeleted.button = true
    },
    clicktarifficationAccPeriod () {
      this.tarifficationAccPeriod.button ? this.tarifficationAccPeriod.button = false : this.tarifficationAccPeriod.button = true
    },
    clicktarifficationServices () {
      this.tarifficationServices.button ? this.tarifficationServices.button = false : this.tarifficationServices.button = true
    },
    clicktarifficationTemplServ () {
      this.tarifficationTemplServ.button ? this.tarifficationTemplServ.button = false : this.tarifficationTemplServ.button = true
    },
    clicktarifficationChargePolicies () {
      this.tarifficationChargePolicies.button ? this.tarifficationChargePolicies.button = false : this.tarifficationChargePolicies.button = true
    },
    clicktarifficationTimeRanges () {
      this.tarifficationTimeRanges.button ? this.tarifficationTimeRanges.button = false : this.tarifficationTimeRanges.button = true
    },
    clicktarifficationTrafficClasses () {
      this.tarifficationTrafficClasses.button ? this.tarifficationTrafficClasses.button = false : this.tarifficationTrafficClasses.button = true
    },
    clicktarifficationTariffPlans () {
      this.tarifficationTariffPlans.button ? this.tarifficationTariffPlans.button = false : this.tarifficationTariffPlans.button = true
    },
    clicktarifficationTelZones () {
      this.tarifficationTelZones.button ? this.tarifficationTelZones.button = false : this.tarifficationTelZones.button = true
    },
    clicktarifficationTelDirs () {
      this.tarifficationTelDirs.button ? this.tarifficationTelDirs.button = false : this.tarifficationTelDirs.button = true
    },
    clicktarifficationCoefScheme () {
      this.tarifficationCoefScheme.button ? this.tarifficationCoefScheme.button = false : this.tarifficationCoefScheme.button = true
    },
    clicktarifficationCoefSchedule () {
      this.tarifficationCoefSchedule.button ? this.tarifficationCoefSchedule.button = false : this.tarifficationCoefSchedule.button = true
    },
    clicktarifficationContractType () {
      this.tarifficationContractType.button ? this.tarifficationContractType.button = false : this.tarifficationContractType.button = true
    },
    click_RBPaymentMethods () {
      this.RBPaymentMethods.button ? this.RBPaymentMethods.button = false : this.RBPaymentMethods.button = true
    },
    click_RBCurrency () {
      this.RBCurrency.button ? this.RBCurrency.button = false : this.RBCurrency.button = true
    },
    click_RBBuildings () {
      this.RBBuildings.button ? this.RBBuildings.button = false : this.RBBuildings.button = true
    },
    click_RBStreets () {
      this.RBStreets.button ? this.RBStreets.button = false : this.RBStreets.button = true
    },
    click_RBBanks () {
      this.RBBanks.button ? this.RBBanks.button = false : this.RBBanks.button = true
    },
    click_RBIPzones () {
      this.RBIPzones.button ? this.RBIPzones.button = false : this.RBIPzones.button = true
    },
    click_StgsParameters () {
      this.StgsParameters.button ? this.StgsParameters.button = false : this.StgsParameters.button = true
    },
    click_StgsAddParams () {
      this.StgsAddParams.button ? this.StgsAddParams.button = false : this.StgsAddParams.button = true
    },
    click_StgsFirewalls () {
      this.StgsFirewalls.button ? this.StgsFirewalls.button = false : this.StgsFirewalls.button = true
    },
    click_StgsFrwRoles () {
      this.StgsFrwRoles.button ? this.StgsFrwRoles.button = false : this.StgsFrwRoles.button = true
    },
    click_StgsNASlist () {
      this.StgsNASlist.button ? this.StgsNASlist.button = false : this.StgsNASlist.button = true
    },
    click_StgsISGprofile () {
      this.StgsISGprofile.button ? this.StgsISGprofile.button = false : this.StgsISGprofile.button = true
    },
    click_StgsISGAttr () {
      this.StgsISGAttr.button ? this.StgsISGAttr.button = false : this.StgsISGAttr.button = true
    },
    click_StgsDocTemplates () {
      this.StgsDocTemplates.button ? this.StgsDocTemplates.button = false : this.StgsDocTemplates.button = true
    },
    click_StgsProfilesDocs () {
      this.StgsProfilesDocs.button ? this.StgsProfilesDocs.button = false : this.StgsProfilesDocs.button = true
    },
    click_StgsReplInDoc () {
      this.StgsReplInDoc.button ? this.StgsReplInDoc.button = false : this.StgsReplInDoc.button = true
    },
    click_StgsIpPools () {
      this.StgsIpPools.button ? this.StgsIpPools.button = false : this.StgsIpPools.button = true
    },
    click_StgsDynamicShaping () {
      this.StgsDynamicShaping.button ? this.StgsDynamicShaping.button = false : this.StgsDynamicShaping.button = true
    },
    click_StgsCompanies () {
      this.StgsCompanies.button ? this.StgsCompanies.button = false : this.StgsCompanies.button = true
    },
    click_StgsTelOperators () {
      this.StgsTelOperators.button ? this.StgsTelOperators.button = false : this.StgsTelOperators.button = true
    },
    click_StgsEmrgsCalls () {
      this.StgsEmrgsCalls.button ? this.StgsEmrgsCalls.button = false : this.StgsEmrgsCalls.button = true
    },
    click_StgsRadAccs () {
      this.StgsRadAccs.button ? this.StgsRadAccs.button = false : this.StgsRadAccs.button = true
    },
    click_StgsArchiveDB () {
      this.StgsArchiveDB.button ? this.StgsArchiveDB.button = false : this.StgsArchiveDB.button = true
    },
    click_StgsReplInDocs () {
      this.StgsReplInDocs.button ? this.StgsReplInDocs.button = false : this.StgsReplInDocs.button = true
    },
    click_StgsNetFlowProvider () {
      this.StgsNetFlowProvider.button ? this.StgsNetFlowProvider.button = false : this.StgsNetFlowProvider.button = true
    },
    click_StgsTrafficCollectors () {
      this.StgsTrafficCollectors.button ? this.StgsTrafficCollectors.button = false : this.StgsTrafficCollectors.button = true
    }
  },
  watch: {
    'baseFunc.check': function (newValue, oldValue) {
      newValue ? this.baseFuncsIDs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.baseFuncsIDs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGUsersRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainUgUsers[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgUsers[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGUsersAdd.check': function (newValue, oldValue) {
      newValue ? this.mainUgUsers[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgUsers[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGUsersView.check': function (newValue, oldValue) {
      newValue ? this.mainUgUsers[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgUsers[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGUsersEdit.check': function (newValue, oldValue) {
      newValue ? this.mainUgUsers[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgUsers[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGUsersSearch.check': function (newValue, oldValue) {
      newValue ? this.mainUgUsers[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgUsers[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGUsersNew.check': function (newValue, oldValue) {
      newValue ? this.mainUgUsers[5].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgUsers[5].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGUsersPayment.check': function (newValue, oldValue) {
      newValue ? this.mainUgUsers[6].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgUsers[6].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGUsersAddtogroup.check': function (newValue, oldValue) {
      newValue ? this.mainUgUsers[7].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgUsers[7].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGUsersChange.check': function (newValue, oldValue) {
      newValue ? this.mainUgUsers[8].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgUsers[8].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGUsers.check': function (newValue, oldValue) {
      this.UaGUsersRefresh.check = newValue
      this.UaGUsersAdd.check = newValue
      this.UaGUsersView.check = newValue
      this.UaGUsersEdit.check = newValue
      this.UaGUsersSearch.check = newValue
      this.UaGUsersNew.check = newValue
      this.UaGUsersPayment.check = newValue
      this.UaGUsersAddtogroup.check = newValue
      this.UaGUsersChange.check = newValue
    },
    'msgIncoming.check': function (newValue, oldValue) {
      newValue ? this.mainMessages[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainMessages[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'msgOutgoing.check': function (newValue, oldValue) {
      newValue ? this.mainMessages[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainMessages[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'msgNew.check': function (newValue, oldValue) {
      newValue ? this.mainMessages[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainMessages[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'msgDeleted.check': function (newValue, oldValue) {
      newValue ? this.mainMessages[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainMessages[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'messages.check': function (newValue, oldValue) {
      this.msgIncoming.check = newValue
      this.msgOutgoing.check = newValue
      this.msgNew.check = newValue
      this.msgDeleted.check = newValue
    },
    'tarifficationAccPeriodRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainTrfAccPer[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfAccPer[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationAccPeriodAdd.check': function (newValue, oldValue) {
      newValue ? this.mainTrfAccPer[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfAccPer[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationAccPeriodRead.check': function (newValue, oldValue) {
      newValue ? this.mainTrfAccPer[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfAccPer[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationAccPeriodEdit.check': function (newValue, oldValue) {
      newValue ? this.mainTrfAccPer[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfAccPer[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationAccPeriod.check': function (newValue, oldValue) {
      this.tarifficationAccPeriodRefresh.check = newValue
      this.tarifficationAccPeriodAdd.check = newValue
      this.tarifficationAccPeriodRead.check = newValue
      this.tarifficationAccPeriodEdit.check = newValue
    },
    'tarifficationServicesRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainTrfSrv[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfSrv[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationServicesAdd.check': function (newValue, oldValue) {
      newValue ? this.mainTrfSrv[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfSrv[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationServicesEdit.check': function (newValue, oldValue) {
      newValue ? this.mainTrfSrv[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfSrv[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationServicesDelete.check': function (newValue, oldValue) {
      newValue ? this.mainTrfSrv[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfSrv[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationServices.check': function (newValue, oldValue) {
      this.tarifficationServicesRefresh.check = newValue
      this.tarifficationServicesAdd.check = newValue
      this.tarifficationServicesEdit.check = newValue
      this.tarifficationServicesDelete.check = newValue
    },
    'clicktarifficationTemplServRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTmplSrv[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTmplSrv[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'clicktarifficationTemplServAdd.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTmplSrv[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTmplSrv[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'clicktarifficationTemplServDelete.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTmplSrv[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTmplSrv[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTemplServ.check': function (newValue, oldValue) {
      this.clicktarifficationTemplServRefresh.check = newValue
      this.clicktarifficationTemplServAdd.check = newValue
      this.clicktarifficationTemplServDelete.check = newValue
    },

    'tarifficationChargePolicies.check': function (newValue, oldValue) {
      this.tarifficationChargePoliciesRefresh.check = newValue
      this.tarifficationChargePoliciesAdd.check = newValue
      this.tarifficationChargePoliciesRead.check = newValue
      this.tarifficationChargePoliciesEdit.check = newValue
      this.tarifficationChargePoliciesDelete.check = newValue
    },
    'tarifficationChargePoliciesRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainTrfChP[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfChP[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationChargePoliciesAdd.check': function (newValue, oldValue) {
      newValue ? this.mainTrfChP[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfChP[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationChargePoliciesRead.check': function (newValue, oldValue) {
      newValue ? this.mainTrfChP[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfChP[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationChargePoliciesEdit.check': function (newValue, oldValue) {
      newValue ? this.mainTrfChP[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfChP[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationChargePoliciesDelete.check': function (newValue, oldValue) {
      newValue ? this.mainTrfChP[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfChP[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },

    'tarifficationTimeRangesRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTR[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTR[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTimeRangesAdd.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTR[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTR[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTimeRangesEdit.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTR[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTR[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTimeRangesDelete.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTR[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTR[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTimeRanges.check': function (newValue, oldValue) {
      this.tarifficationTimeRangesRefresh.check = newValue
      this.tarifficationTimeRangesAdd.check = newValue
      this.tarifficationTimeRangesEdit.check = newValue
      this.tarifficationTimeRangesDelete.check = newValue
    },
    'tarifficationTrafficClassesRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTrfClasses[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTrfClasses[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTrafficClassesAdd.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTrfClasses[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTrfClasses[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTrafficClassesRead.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTrfClasses[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTrfClasses[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTrafficClassesEdit.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTrfClasses[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTrfClasses[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTrafficClassesDelete.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTrfClasses[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTrfClasses[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTariffPlansAdd.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTrfPlans[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTrfPlans[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTariffPlansRead.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTrfPlans[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTrfPlans[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTariffPlansEdit.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTrfPlans[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTrfPlans[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTariffPlansDelete.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTrfPlans[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTrfPlans[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTelZonesRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelZones[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelZones[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTelZonesAdd.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelZones[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelZones[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTelZonesRead.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelZones[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelZones[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTelZonesEdit.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelZones[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelZones[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTelZonesDelete.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelZones[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelZones[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTelDirsRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelDirs[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelDirs[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTelDirsRead.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelDirs[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelDirs[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTelDirsEdit.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelDirs[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelDirs[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTelDirsAdd.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelDirs[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelDirs[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationTelDirsDelete.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelDirs[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelDirs[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationCoefSchemeRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelCoefScheme[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelCoefScheme[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationCoefSchemeAdd.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelCoefScheme[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelCoefScheme[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationCoefSchemeEdit.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelCoefScheme[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelCoefScheme[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationCoefSchemeDelete.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelCoefScheme[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelCoefScheme[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationCoefScheduleRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelCoefShed[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelCoefShed[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationCoefScheduleAdd.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelCoefShed[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelCoefShed[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationCoefScheduleEdit.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelCoefShed[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelCoefShed[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationCoefScheduleDelete.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelCoefShed[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelCoefShed[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationContractTypeRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelContractType[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelContractType[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationContractTypeAdd.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelContractType[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelContractType[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationContractTypeEdit.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelContractType[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelContractType[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationContractTypeDelete.check': function (newValue, oldValue) {
      newValue ? this.mainTrfTelContractType[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainTrfTelContractType[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'tarifficationContractType.check': function (newValue, oldValue) {
      this.tarifficationContractTypeRefresh.check = newValue
      this.tarifficationContractTypeAdd.check = newValue
      this.tarifficationContractTypeEdit.check = newValue
      this.tarifficationContractTypeDelete.check = newValue
    },
    'tarifficationTrafficClasses.check': function (newValue, oldValue) {
      this.tarifficationTrafficClassesRefresh.check = newValue
      this.tarifficationTrafficClassesAdd.check = newValue
      this.tarifficationTrafficClassesRead.check = newValue
      this.tarifficationTrafficClassesEdit.check = newValue
      this.tarifficationTrafficClassesDelete.check = newValue
    },
    'tarifficationTariffPlans.check': function (newValue, oldValue) {
      this.tarifficationTariffPlansAdd.check = newValue
      this.tarifficationTariffPlansRead.check = newValue
      this.tarifficationTariffPlansEdit.check = newValue
      this.tarifficationTariffPlansDelete.check = newValue
    },
    'tarifficationTelZones.check': function (newValue, oldValue) {
      this.tarifficationTelZonesRefresh.check = newValue
      this.tarifficationTelZonesAdd.check = newValue
      this.tarifficationTelZonesRead.check = newValue
      this.tarifficationTelZonesEdit.check = newValue
      this.tarifficationTelZonesDelete.check = newValue
    },
    'tarifficationTelDirs.check': function (newValue, oldValue) {
      this.tarifficationTelDirsRead.check = newValue
      this.tarifficationTelDirsEdit.check = newValue
      this.tarifficationTelDirsAdd.check = newValue
      this.tarifficationTelDirsDelete.check = newValue
    },
    'tarifficationCoefScheme.check': function (newValue, oldValue) {
      this.tarifficationCoefSchemeRefresh.check = newValue
      this.tarifficationCoefSchemeAdd.check = newValue
      this.tarifficationCoefSchemeEdit.check = newValue
      this.tarifficationCoefSchemeDelete.check = newValue
    },
    'tarifficationCoefSchedule.check': function (newValue, oldValue) {
      this.tarifficationCoefScheduleRefresh.check = newValue
      this.tarifficationCoefScheduleAdd.check = newValue
      this.tarifficationCoefScheduleEdit.check = newValue
      this.tarifficationCoefScheduleDelete.check = newValue
    },

    'Tariffication.check': function (newValue, oldValue) {
      this.tarifficationAccPeriod.check = newValue
      this.tarifficationServices.check = newValue
      this.tarifficationTemplServ.check = newValue
      this.tarifficationChargePolicies.check = newValue
      this.tarifficationTimeRanges.check = newValue
      this.tarifficationTrafficClasses.check = newValue
      this.tarifficationTariffPlans.check = newValue
      this.tarifficationTelZones.check = newValue
      this.tarifficationTelDirs.check = newValue
      this.tarifficationCoefScheme.check = newValue
      this.tarifficationCoefSchedule.check = newValue
      this.tarifficationContractType.check = newValue
    },
    'Refbook.check': function (newValue, oldValue) {
      this.RBPaymentMethods.check = newValue
      this.RBCurrency.check = newValue
      this.RBBuildings.check = newValue
      this.RBStreets.check = newValue
      this.RBBanks.check = newValue
      this.RBIPzones.check = newValue
    },
    'RBPaymentMethods.check': function (newValue, oldValue) {
      this.RBPaymentMethodsRefresh.check = newValue
      this.RBPaymentMethodsAdd.check = newValue
      this.RBPaymentMethodsEdit.check = newValue
    },
    'RBPaymentMethodsRefresh.check': function (newValue, oldValue) {
      newValue ? this.RefBookPaymentM[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookPaymentM[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBPaymentMethodsAdd.check': function (newValue, oldValue) {
      newValue ? this.RefBookPaymentM[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookPaymentM[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBPaymentMethodsEdit.check': function (newValue, oldValue) {
      newValue ? this.RefBookPaymentM[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookPaymentM[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBCurrencyRefresh.check': function (newValue, oldValue) {
      newValue ? this.RefBookCurrency[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookCurrency[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBCurrencyAdd.check': function (newValue, oldValue) {
      newValue ? this.RefBookCurrency[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookCurrency[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBCurrencyEdit.check': function (newValue, oldValue) {
      newValue ? this.RefBookCurrency[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookCurrency[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBCurrencyDelete.check': function (newValue, oldValue) {
      newValue ? this.RefBookCurrency[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookCurrency[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBBuildingsRefresh.check': function (newValue, oldValue) {
      newValue ? this.RefBookBuildings[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookBuildings[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBBuildingsAdd.check': function (newValue, oldValue) {
      newValue ? this.RefBookBuildings[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookBuildings[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBBuildingsRead.check': function (newValue, oldValue) {
      newValue ? this.RefBookBuildings[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookBuildings[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBBuildingsEdit.check': function (newValue, oldValue) {
      newValue ? this.RefBookBuildings[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookBuildings[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBBuildingsDelete.check': function (newValue, oldValue) {
      newValue ? this.RefBookBuildings[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookBuildings[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBStreetsRefresh.check': function (newValue, oldValue) {
      newValue ? this.RefBookStreets[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookStreets[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBStreetsAdd.check': function (newValue, oldValue) {
      newValue ? this.RefBookStreets[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookStreets[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBStreetsRead.check': function (newValue, oldValue) {
      newValue ? this.RefBookStreets[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookStreets[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBStreetsEdit.check': function (newValue, oldValue) {
      newValue ? this.RefBookStreets[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookStreets[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBStreetsDelete.check': function (newValue, oldValue) {
      newValue ? this.RefBookStreets[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookStreets[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBBanksRefresh.check': function (newValue, oldValue) {
      newValue ? this.RefBookBanks[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookBanks[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBBanksAdd.check': function (newValue, oldValue) {
      newValue ? this.RefBookBanks[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookBanks[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBBanksEdit.check': function (newValue, oldValue) {
      newValue ? this.RefBookBanks[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookBanks[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBBanksDelete.check': function (newValue, oldValue) {
      newValue ? this.RefBookBanks[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookBanks[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBIPzonesRefresh.check': function (newValue, oldValue) {
      newValue ? this.RefBookIPzones[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookIPzones[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBIPzonesAdd.check': function (newValue, oldValue) {
      newValue ? this.RefBookIPzones[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookIPzones[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBIPzonesRead.check': function (newValue, oldValue) {
      newValue ? this.RefBookIPzones[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookIPzones[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBIPzonesEdit.check': function (newValue, oldValue) {
      newValue ? this.RefBookIPzones[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.RefBookIPzones[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'RBCurrency.check': function (newValue, oldValue) {
      this.RBCurrencyRefresh.check = newValue
      this.RBCurrencyAdd.check = newValue
      this.RBCurrencyEdit.check = newValue
      this.RBCurrencyDelete.check = newValue
    },
    'RBBuildings.check': function (newValue, oldValue) {
      this.RBBuildingsRefresh.check = newValue
      this.RBBuildingsAdd.check = newValue
      this.RBBuildingsRead.check = newValue
      this.RBBuildingsEdit.check = newValue
      this.RBBuildingsDelete.check = newValue
    },

    'RBStreets.check': function (newValue, oldValue) {
      this.RBStreetsRefresh.check = newValue
      this.RBStreetsAdd.check = newValue
      this.RBStreetsRead.check = newValue
      this.RBStreetsEdit.check = newValue
      this.RBStreetsDelete.check = newValue
    },

    'RBBanks.check': function (newValue, oldValue) {
      this.RBBanksRefresh.check = newValue
      this.RBBanksAdd.check = newValue
      this.RBBanksEdit.check = newValue
      this.RBBanksDelete.check = newValue
    },
    'RBIPzones.check': function (newValue, oldValue) {
      this.RBIPzonesRefresh.check = newValue
      this.RBIPzonesAdd.check = newValue
      this.RBIPzonesRead.check = newValue
      this.RBIPzonesEdit.check = newValue
    },

    'StgsParametersRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsParameters[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsParameters[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsAddParamsAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsAdditionalParameters[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsAdditionalParameters[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsAddParamsEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsAdditionalParameters[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsAdditionalParameters[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsAddParamsDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsAdditionalParameters[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsAdditionalParameters[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsFirewallsRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsFirewalls[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsFirewalls[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsFirewallsAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsFirewalls[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsFirewalls[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsFirewallsEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsFirewalls[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsFirewalls[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsFirewallsDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsFirewalls[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsFirewalls[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsFrwRolesRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsFirewallrules[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsFirewallrules[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsFrwRolesAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsFirewallrules[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsFirewallrules[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsFrwRolesEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsFirewallrules[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsFirewallrules[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsFrwRolesDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsFirewallrules[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsFirewallrules[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsNASlistRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsNASList[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsNASList[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsNASlistAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsNASList[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsNASList[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsNASlistRead.check': function (newValue, oldValue) {
      newValue ? this.SettingsNASList[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsNASList[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsNASlistEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsNASList[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsNASList[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsNASlistDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsNASList[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsNASList[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsISGprofileRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsISGprofile[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsISGprofile[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsISGprofileAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsISGprofile[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsISGprofile[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsISGprofileRead.check': function (newValue, oldValue) {
      newValue ? this.SettingsISGprofile[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsISGprofile[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsISGprofileEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsISGprofile[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsISGprofile[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsISGprofileDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsISGprofile[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsISGprofile[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsISGAttrRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsISGattributes[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsISGattributes[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsISGAttrAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsISGattributes[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsISGattributes[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsISGAttrRead.check': function (newValue, oldValue) {
      newValue ? this.SettingsISGattributes[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsISGattributes[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsISGAttrEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsISGattributes[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsISGattributes[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsISGAttrDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsISGattributes[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsISGattributes[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsDocTemplatesRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsDocumentTemplates[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsDocumentTemplates[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsDocTemplatesAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsDocumentTemplates[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsDocumentTemplates[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsDocTemplatesDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsDocumentTemplates[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsDocumentTemplates[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsDocTemplatesRead.check': function (newValue, oldValue) {
      newValue ? this.SettingsDocumentTemplates[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsDocumentTemplates[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsDocTemplatesEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsDocumentTemplates[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsDocumentTemplates[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsDocTemplatesOthers.check': function (newValue, oldValue) {
      newValue ? this.SettingsDocumentTemplates[5].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsDocumentTemplates[5].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsReplInDocRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsReplacements[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsReplacements[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsReplInDocAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsReplacements[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsReplacements[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsReplInDocDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsReplacements[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsReplacements[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsReplInDocEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsReplacements[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsReplacements[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsIpPoolsRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsIPPools[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsIPPools[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsIpPoolsAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsIPPools[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsIPPools[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsIpPoolsRead.check': function (newValue, oldValue) {
      newValue ? this.SettingsIPPools[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsIPPools[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsIpPoolsEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsIPPools[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsIPPools[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsIpPoolsDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsIPPools[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsIPPools[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsDynamicShapingRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsDynamicshaping[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsDynamicshaping[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsDynamicShapingAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsDynamicshaping[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsDynamicshaping[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsDynamicShapingRead.check': function (newValue, oldValue) {
      newValue ? this.SettingsDynamicshaping[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsDynamicshaping[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsDynamicShapingEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsDynamicshaping[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsDynamicshaping[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsDynamicShapingDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsDynamicshaping[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsDynamicshaping[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsCompaniesRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsCompanies[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsCompanies[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsCompaniesAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsCompanies[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsCompanies[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsCompaniesRead.check': function (newValue, oldValue) {
      newValue ? this.SettingsCompanies[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsCompanies[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsCompaniesEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsCompanies[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsCompanies[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsCompaniesDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsCompanies[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsCompanies[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsTelOperatorsRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsTelephoneoperators[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsTelephoneoperators[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsTelOperatorsAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsTelephoneoperators[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsTelephoneoperators[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsTelOperatorsRead.check': function (newValue, oldValue) {
      newValue ? this.SettingsTelephoneoperators[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsTelephoneoperators[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsTelOperatorsEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsTelephoneoperators[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsTelephoneoperators[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsTelOperatorsDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsTelephoneoperators[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsTelephoneoperators[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsEmrgsCallsRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsEmergencyCalls[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsEmergencyCalls[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsEmrgsCallsEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsEmergencyCalls[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsEmergencyCalls[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsEmrgsCallsDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsEmergencyCalls[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsEmergencyCalls[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsEmrgsCallsAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsEmergencyCalls[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsEmergencyCalls[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsRadAccsRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsRADIUSaccounts[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsRADIUSaccounts[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsRadAccsAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsRADIUSaccounts[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsRADIUSaccounts[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsRadAccsEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsRADIUSaccounts[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsRADIUSaccounts[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsRadAccsDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsRADIUSaccounts[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsRADIUSaccounts[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsArchiveDB.check': function (newValue, oldValue) {
      newValue ? this.SettingsArchiveDB[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsArchiveDB[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsNetFlowProviderRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsNetFlowProviders[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsNetFlowProviders[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsNetFlowProviderAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsNetFlowProviders[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsNetFlowProviders[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsNetFlowProviderEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsNetFlowProviders[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsNetFlowProviders[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsNetFlowProviderDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsNetFlowProviders[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsNetFlowProviders[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsTrafficCollectorsRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsTrafficcollectors[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsTrafficcollectors[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsTrafficCollectorsAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsTrafficcollectors[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsTrafficcollectors[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsTrafficCollectorsEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsTrafficcollectors[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsTrafficcollectors[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsTrafficCollectorsDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsTrafficcollectors[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsTrafficcollectors[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsParameters.check': function (newValue, oldValue) {
      this.StgsParametersRefresh.check = newValue
    },
    'Settings.check': function (newValue, oldValue) {
      this.StgsParameters.check = newValue
      this.StgsAddParams.check = newValue
      this.StgsFirewalls.check = newValue
      this.StgsFrwRoles.check = newValue
      this.StgsNASlist.check = newValue
      this.StgsISGprofile.check = newValue
      this.StgsISGAttr.check = newValue
      this.StgsDocTemplates.check = newValue
      this.StgsReplInDoc.check = newValue
      this.StgsIpPools.check = newValue
      this.StgsDynamicShaping.check = newValue
      this.StgsCompanies.check = newValue
      this.StgsTelOperators.check = newValue
      this.StgsEmrgsCalls.check = newValue
      this.StgsRadAccs.check = newValue
      this.StgsArchiveDB.check = newValue
      this.StgsNetFlowProvider.check = newValue
      this.StgsTrafficCollectors.check = newValue
      this.StgsProfilesDocs.check = newValue
    },
    'StgsAddParams.check': function (newValue, oldValue) {
      this.StgsAddParamsAdd.check = newValue
      this.StgsAddParamsEdit.check = newValue
      this.StgsAddParamsDelete.check = newValue
    },
    'StgsFirewalls.check': function (newValue, oldValue) {
      this.StgsFirewallsRefresh.check = newValue
      this.StgsFirewallsAdd.check = newValue
      this.StgsFirewallsEdit.check = newValue
      this.StgsFirewallsDelete.check = newValue
    },
    'StgsFrwRoles.check': function (newValue, oldValue) {
      this.StgsFrwRolesRefresh.check = newValue
      this.StgsFrwRolesAdd.check = newValue
      this.StgsFrwRolesEdit.check = newValue
      this.StgsFrwRolesDelete.check = newValue
    },
    'StgsNASlist.check': function (newValue, oldValue) {
      this.StgsNASlistRefresh.check = newValue
      this.StgsNASlistAdd.check = newValue
      this.StgsNASlistRead.check = newValue
      this.StgsNASlistEdit.check = newValue
      this.StgsNASlistDelete.check = newValue
    },
    'StgsISGprofile.check': function (newValue, oldValue) {
      this.StgsISGprofileRefresh.check = newValue
      this.StgsISGprofileAdd.check = newValue
      this.StgsISGprofileRead.check = newValue
      this.StgsISGprofileEdit.check = newValue
      this.StgsISGprofileDelete.check = newValue
    },
    'StgsISGAttr.check': function (newValue, oldValue) {
      this.StgsISGAttrRefresh.check = newValue
      this.StgsISGAttrAdd.check = newValue
      this.StgsISGAttrRead.check = newValue
      this.StgsISGAttrEdit.check = newValue
      this.StgsISGAttrDelete.check = newValue
    },
    'StgsDocTemplates.check': function (newValue, oldValue) {
      this.StgsDocTemplatesRefresh.check = newValue
      this.StgsDocTemplatesAdd.check = newValue
      this.StgsDocTemplatesDelete.check = newValue
      this.StgsDocTemplatesRead.check = newValue
      this.StgsDocTemplatesEdit.check = newValue
      this.StgsDocTemplatesOthers.check = newValue
    },
    'StgsReplInDoc.check': function (newValue, oldValue) {
      this.StgsReplInDocRefresh.check = newValue
      this.StgsReplInDocAdd.check = newValue
      this.StgsReplInDocDelete.check = newValue
      this.StgsReplInDocEdit.check = newValue
    },
    'StgsIpPools.check': function (newValue, oldValue) {
      this.StgsIpPoolsRefresh.check = newValue
      this.StgsIpPoolsAdd.check = newValue
      this.StgsIpPoolsRead.check = newValue
      this.StgsIpPoolsEdit.check = newValue
      this.StgsIpPoolsDelete.check = newValue
    },
    'StgsDynamicShaping.check': function (newValue, oldValue) {
      this.StgsDynamicShapingRefresh.check = newValue
      this.StgsDynamicShapingAdd.check = newValue
      this.StgsDynamicShapingRead.check = newValue
      this.StgsDynamicShapingEdit.check = newValue
      this.StgsDynamicShapingDelete.check = newValue
    },
    'StgsCompanies.check': function (newValue, oldValue) {
      this.StgsCompaniesRefresh.check = newValue
      this.StgsCompaniesAdd.check = newValue
      this.StgsCompaniesRead.check = newValue
      this.StgsCompaniesEdit.check = newValue
      this.StgsCompaniesDelete.check = newValue
    },
    'StgsTelOperators.check': function (newValue, oldValue) {
      this.StgsTelOperatorsRefresh.check = newValue
      this.StgsTelOperatorsAdd.check = newValue
      this.StgsTelOperatorsRead.check = newValue
      this.StgsTelOperatorsEdit.check = newValue
      this.StgsTelOperatorsDelete.check = newValue
    },
    'StgsEmrgsCalls.check': function (newValue, oldValue) {
      this.StgsEmrgsCallsRefresh.check = newValue
      this.StgsEmrgsCallsEdit.check = newValue
      this.StgsEmrgsCallsDelete.check = newValue
      this.StgsEmrgsCallsAdd.check = newValue
    },
    'StgsRadAccs.check': function (newValue, oldValue) {
      this.StgsRadAccsRefresh.check = newValue
      this.StgsRadAccsAdd.check = newValue
      this.StgsRadAccsEdit.check = newValue
      this.StgsRadAccsDelete.check = newValue
    },
    'StgsNetFlowProvider.check': function (newValue, oldValue) {
      this.StgsNetFlowProviderRefresh.check = newValue
      this.StgsNetFlowProviderAdd.check = newValue
      this.StgsNetFlowProviderEdit.check = newValue
      this.StgsNetFlowProviderDelete.check = newValue
    },
    'StgsTrafficCollectors.check': function (newValue, oldValue) {
      this.StgsTrafficCollectorsRefresh.check = newValue
      this.StgsTrafficCollectorsAdd.check = newValue
      this.StgsTrafficCollectorsEdit.check = newValue
      this.StgsTrafficCollectorsDelete.check = newValue
    },
    'StgsProfilesDocs.check': function (newValue, oldValue) {
      this.StgsProfilesDocsRefresh.check = newValue
      this.StgsProfilesDocsAdd.check = newValue
      this.StgsProfilesDocsDelete.check = newValue
      this.StgsProfilesDocsRead.check = newValue
      this.StgsProfilesDocsEdit.check = newValue
    },
    'StgsProfilesDocsRefresh.check': function (newValue, oldValue) {
      newValue ? this.SettingsProfiles[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsProfiles[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsProfilesDocsAdd.check': function (newValue, oldValue) {
      newValue ? this.SettingsProfiles[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsProfiles[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsProfilesDocsDelete.check': function (newValue, oldValue) {
      newValue ? this.SettingsProfiles[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsProfiles[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsProfilesDocsRead.check': function (newValue, oldValue) {
      newValue ? this.SettingsProfiles[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsProfiles[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'StgsProfilesDocsEdit.check': function (newValue, oldValue) {
      newValue ? this.SettingsProfiles[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.SettingsProfiles[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Additional.check': function (newValue, oldValue) {
      this.AdditionalSymbols.check = newValue
      this.AdditionalLibURFAPlugins.check = newValue
      this.AdditionalConnections.check = newValue
      this.AdditionalHSsession.check = newValue
      this.AdditionalRadSession.check = newValue
      this.AdditionalRadAttrs.check = newValue
      this.AdditionalChangePass.check = newValue
    },
    'AdditionalLibURFAPlugins.check': function (newValue, oldValue) {
      this.AdditionalLibURFAPluginsRefresh.check = newValue
      this.AdditionalLibURFAPluginsLoad.check = newValue
      this.AdditionalLibURFAPluginsUnload.check = newValue
      this.AdditionalLibURFAPluginsReload.check = newValue
    },
    'AdditionalSymbols.check': function (newValue, oldValue) {
      newValue ? this.MainAddSymbols[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainAddSymbols[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'AdditionalLibURFAPluginsRefresh.check': function (newValue, oldValue) {
      newValue ? this.MainAddLibURFA[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainAddLibURFA[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'AdditionalLibURFAPluginsLoad.check': function (newValue, oldValue) {
      newValue ? this.MainAddLibURFA[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainAddLibURFA[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'AdditionalLibURFAPluginsUnload.check': function (newValue, oldValue) {
      newValue ? this.MainAddLibURFA[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainAddLibURFA[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'AdditionalLibURFAPluginsReload.check': function (newValue, oldValue) {
      newValue ? this.MainAddLibURFA[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainAddLibURFA[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'AdditionalConnections.check': function (newValue, oldValue) {
      newValue ? this.MainAddConn[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainAddConn[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'AdditionalHSsession.check': function (newValue, oldValue) {
      newValue ? this.MainAddHotspotSessions[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainAddHotspotSessions[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'AdditionalRadSession.check': function (newValue, oldValue) {
      newValue ? this.MainAddRADIUSSessions[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainAddRADIUSSessions[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'AdditionalRadAttrs.check': function (newValue, oldValue) {
      newValue ? this.MainAddRADIUSAttributes[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainAddRADIUSAttributes[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'AdditionalChangePass.check': function (newValue, oldValue) {
      newValue ? this.MainAddChangepassword[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainAddChangepassword[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Interfaces.check': function (newValue, oldValue) {
      this.InterfacesTraysettings.check = newValue
      this.InterfacesCashierSettings.check = newValue
      this.InterfacesSwitchtariff.check = newValue
      this.InterfacesVoluntary.check = newValue
      this.InterfacesPromised.check = newValue
      this.InterfacesInternal.check = newValue
    },
    'InterfacesSwitchtariff.check': function (newValue, oldValue) {
      this.InterfacesSwitchtariffRefresh.check = newValue
      this.InterfacesSwitchtariffAdd.check = newValue
      this.InterfacesSwitchtariffEdit.check = newValue
      this.InterfacesSwitchtariffDelete.check = newValue
    },
    'InterfacesVoluntary.check': function (newValue, oldValue) {
      this.InterfacesVoluntaryRefresh.check = newValue
      this.InterfacesVoluntaryAdd.check = newValue
      this.InterfacesVoluntaryEdit.check = newValue
      this.InterfacesVoluntaryDelete.check = newValue
    },
    'InterfacesPromised.check': function (newValue, oldValue) {
      this.InterfacesPromisedRefresh.check = newValue
      this.InterfacesPromisedAdd.check = newValue
      this.InterfacesPromisedEdit.check = newValue
      this.InterfacesPromisedDelete.check = newValue
    },
    'InterfacesInternal.check': function (newValue, oldValue) {
      this.InterfacesInternalRefresh.check = newValue
      this.InterfacesInternalEdit.check = newValue
      this.InterfacesInternalDelete.check = newValue
    },
    'InterfacesTraysettings.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceTray[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceTray[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesCashierSettings.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceCashier[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceCashier[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesSwitchtariffRefresh.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceSwitch[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceSwitch[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesSwitchtariffAdd.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceSwitch[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceSwitch[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesSwitchtariffEdit.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceSwitch[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceSwitch[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesSwitchtariffDelete.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceSwitch[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceSwitch[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesVoluntaryRefresh.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceVoluntary[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceVoluntary[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesVoluntaryAdd.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceVoluntary[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceVoluntary[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesVoluntaryEdit.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceVoluntary[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceVoluntary[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesVoluntaryDelete.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceVoluntary[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceVoluntary[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesPromisedRefresh.check': function (newValue, oldValue) {
      newValue ? this.MainInterfacePromised[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfacePromised[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesPromisedAdd.check': function (newValue, oldValue) {
      newValue ? this.MainInterfacePromised[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfacePromised[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesPromisedEdit.check': function (newValue, oldValue) {
      newValue ? this.MainInterfacePromised[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfacePromised[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesPromisedDelete.check': function (newValue, oldValue) {
      newValue ? this.MainInterfacePromised[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfacePromised[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesInternalRefresh.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceInternal[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceInternal[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesInternalEdit.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceInternal[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceInternal[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InterfacesInternalDelete.check': function (newValue, oldValue) {
      newValue ? this.MainInterfaceInternal[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInterfaceInternal[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'AboutRefresh.check': function (newValue, oldValue) {
      newValue ? this.MainAbout[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainAbout[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'AboutLicensesrefresh.check': function (newValue, oldValue) {
      newValue ? this.MainAbout[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainAbout[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'f1CSettings.check': function (newValue, oldValue) {
      newValue ? this.Main1C[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.Main1C[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'f1CSyncronized.check': function (newValue, oldValue) {
      newValue ? this.Main1C[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.Main1C[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'f1CInvoices.check': function (newValue, oldValue) {
      newValue ? this.Main1C[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.Main1C[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'f1CPayments.check': function (newValue, oldValue) {
      newValue ? this.Main1C[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.Main1C[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'About.check': function (newValue, oldValue) {
      this.AboutRefresh.check = newValue
      this.AboutLicensesrefresh.check = newValue
    },
    'f1C.check': function (newValue, oldValue) {
      this.f1CSettings.check = newValue
      this.f1CSyncronized.check = newValue
      this.f1CInvoices.check = newValue
      this.f1CPayments.check = newValue
    },
    'Inventory.check': function (newValue, oldValue) {
      this.Inventorytypes.check = newValue
      this.InventorySwitches.check = newValue
      this.Inventorypools.check = newValue
      this.Inventorylease.check = newValue
    },
    'Inventorytypes.check': function (newValue, oldValue) {
      this.InventorytypesRefresh.check = newValue
      this.InventorytypesAdd.check = newValue
      this.InventorytypesRead.check = newValue
      this.InventorytypesEdit.check = newValue
      this.InventorytypesDelete.check = newValue
    },
    'InventorySwitches.check': function (newValue, oldValue) {
      this.InventorySwitchesRefresh.check = newValue
      this.InventorySwitchesAdd.check = newValue
      this.InventorySwitchesRead.check = newValue
      this.InventorySwitchesEdit.check = newValue
      this.InventorySwitchesDelete.check = newValue
    },
    'Inventorypools.check': function (newValue, oldValue) {
      this.InventorypoolsRefresh.check = newValue
      this.InventorypoolsAdd.check = newValue
      this.InventorypoolsRead.check = newValue
      this.InventorypoolsEdit.check = newValue
      this.InventorypoolsDelete.check = newValue
    },
    'InventorytypesRefresh.check': function (newValue, oldValue) {
      newValue ? this.MainInventorySwitchtypes[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventorySwitchtypes[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorytypesAdd.check': function (newValue, oldValue) {
      newValue ? this.MainInventorySwitchtypes[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventorySwitchtypes[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorytypesRead.check': function (newValue, oldValue) {
      newValue ? this.MainInventorySwitchtypes[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventorySwitchtypes[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorytypesEdit.check': function (newValue, oldValue) {
      newValue ? this.MainInventorySwitchtypes[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventorySwitchtypes[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorytypesDelete.check': function (newValue, oldValue) {
      newValue ? this.MainInventorySwitchtypes[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventorySwitchtypes[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorySwitchesRefresh.check': function (newValue, oldValue) {
      newValue ? this.MainInventorySwitches[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventorySwitches[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorySwitchesAdd.check': function (newValue, oldValue) {
      newValue ? this.MainInventorySwitches[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventorySwitches[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorySwitchesRead.check': function (newValue, oldValue) {
      newValue ? this.MainInventorySwitches[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventorySwitches[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorySwitchesEdit.check': function (newValue, oldValue) {
      newValue ? this.MainInventorySwitches[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventorySwitches[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorySwitchesDelete.check': function (newValue, oldValue) {
      newValue ? this.MainInventorySwitches[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventorySwitches[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorypoolsRefresh.check': function (newValue, oldValue) {
      newValue ? this.MainInventoryDHCPpools[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventoryDHCPpools[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorypoolsAdd.check': function (newValue, oldValue) {
      newValue ? this.MainInventoryDHCPpools[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventoryDHCPpools[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorypoolsRead.check': function (newValue, oldValue) {
      newValue ? this.MainInventoryDHCPpools[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventoryDHCPpools[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorypoolsEdit.check': function (newValue, oldValue) {
      newValue ? this.MainInventoryDHCPpools[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventoryDHCPpools[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'InventorypoolsDelete.check': function (newValue, oldValue) {
      newValue ? this.MainInventoryDHCPpools[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventoryDHCPpools[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Inventorylease.check': function (newValue, oldValue) {
      newValue ? this.MainInventoryDHCPlease[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.MainInventoryDHCPlease[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfTechParamRefresh.check': function (newValue, oldValue) {
      newValue ? this.UWTrfTechnical[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfTechnical[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfTechParamAdd.check': function (newValue, oldValue) {
      newValue ? this.UWTrfTechnical[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfTechnical[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfTechParamEdit.check': function (newValue, oldValue) {
      newValue ? this.UWTrfTechnical[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfTechnical[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfTechParamDelete.check': function (newValue, oldValue) {
      newValue ? this.UWTrfTechnical[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfTechnical[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfIPTVacRefresh.check': function (newValue, oldValue) {
      newValue ? this.UWTrfIPTV[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfIPTV[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfIPTVacAdd.check': function (newValue, oldValue) {
      newValue ? this.UWTrfIPTV[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfIPTV[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfAccRefresh.check': function (newValue, oldValue) {
      newValue ? this.UWTrfAccounts[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfAccounts[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfAccAdd.check': function (newValue, oldValue) {
      newValue ? this.UWTrfAccounts[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfAccounts[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfAccDelete.check': function (newValue, oldValue) {
      newValue ? this.UWTrfAccounts[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfAccounts[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfAccEdit.check': function (newValue, oldValue) {
      newValue ? this.UWTrfAccounts[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfAccounts[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },

    'UWTrfTLRefresh.check': function (newValue, oldValue) {
      newValue ? this.UWTrfTarifflinks[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfTarifflinks[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfTLAdd.check': function (newValue, oldValue) {
      newValue ? this.UWTrfTarifflinks[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfTarifflinks[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfTLEdit.check': function (newValue, oldValue) {
      newValue ? this.UWTrfTarifflinks[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfTarifflinks[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfTLRead.check': function (newValue, oldValue) {
      newValue ? this.UWTrfTarifflinks[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfTarifflinks[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfTLDelete.check': function (newValue, oldValue) {
      newValue ? this.UWTrfTarifflinks[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfTarifflinks[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfTLHistory.check': function (newValue, oldValue) {
      newValue ? this.UWTrfTarifflinks[5].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfTarifflinks[5].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfTLAddSl.check': function (newValue, oldValue) {
      newValue ? this.UWTrfTarifflinks[6].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfTarifflinks[6].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfSLRefresh.check': function (newValue, oldValue) {
      newValue ? this.UWTrfServicelinks[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfServicelinks[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfSLAdd.check': function (newValue, oldValue) {
      newValue ? this.UWTrfServicelinks[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfServicelinks[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfSLEdit.check': function (newValue, oldValue) {
      newValue ? this.UWTrfServicelinks[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfServicelinks[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfSLRead.check': function (newValue, oldValue) {
      newValue ? this.UWTrfServicelinks[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfServicelinks[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfSLDelete.check': function (newValue, oldValue) {
      newValue ? this.UWTrfServicelinks[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfServicelinks[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfSLPrepaid.check': function (newValue, oldValue) {
      newValue ? this.UWTrfServicelinks[5].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfServicelinks[5].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWTrfSLSetRadius.check': function (newValue, oldValue) {
      newValue ? this.UWTrfServicelinks[6].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWTrfServicelinks[6].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UETariffication.check': function (newValue, oldValue) {
      this.UETarifficationTP.check = newValue
      this.UETarifficationIPTVac.check = newValue
      this.UETarifficationAccs.check = newValue
      this.UETarifficationTL.check = newValue
      this.UETarifficationSL.check = newValue
    },
    'UETarifficationTP.check': function (newValue, oldValue) {
      this.UWTrfTechParamRefresh.check = newValue
      this.UWTrfTechParamAdd.check = newValue
      this.UWTrfTechParamEdit.check = newValue
      this.UWTrfTechParamDelete.check = newValue
    },
    'UETarifficationIPTVac.check': function (newValue, oldValue) {
      this.UWTrfIPTVacRefresh.check = newValue
      this.UWTrfIPTVacAdd.check = newValue
    },
    'UETarifficationAccs.check': function (newValue, oldValue) {
      this.UWTrfAccRefresh.check = newValue
      this.UWTrfAccAdd.check = newValue
      this.UWTrfAccDelete.check = newValue
      this.UWTrfAccEdit.check = newValue
    },
    'UETarifficationTL.check': function (newValue, oldValue) {
      this.UWTrfTLRefresh.check = newValue
      this.UWTrfTLAdd.check = newValue
      this.UWTrfTLEdit.check = newValue
      this.UWTrfTLRead.check = newValue
      this.UWTrfTLDelete.check = newValue
      this.UWTrfTLHistory.check = newValue
      this.UWTrfTLAddSl.check = newValue
    },
    'UETarifficationSL.check': function (newValue, oldValue) {
      this.UWTrfSLRefresh.check = newValue
      this.UWTrfSLAdd.check = newValue
      this.UWTrfSLEdit.check = newValue
      this.UWTrfSLRead.check = newValue
      this.UWTrfSLDelete.check = newValue
      this.UWTrfSLPrepaid.check = newValue
      this.UWTrfSLSetRadius.check = newValue
    },
    'UEUsers.check': function (newValue, oldValue) {
      this.UEUsersGroups.check = newValue
      this.UEUsersAdds.check = newValue
      this.UEUsersDocs.check = newValue
      this.UEUsersGenUsr.check = newValue
    },
    'UEUsersGroups.check': function (newValue, oldValue) {
      this.UWUserGroupRefresh.check = newValue
      this.UWUserGroupAdd.check = newValue
      this.UWUserGroupDelete.check = newValue
    },
    'UEUsersAdds.check': function (newValue, oldValue) {
      this.UWUserAddContactsRefresh.check = newValue
      this.UWUserAddContactsRead.check = newValue
      this.UWUserAddContactsEdit.check = newValue
      this.UWUserAddContactsAdd.check = newValue
      this.UWUserAddContactsDelete.check = newValue
    },
    'UEUsersDocs.check': function (newValue, oldValue) {
      this.UWUserDocsRefresh.check = newValue
      this.UWUserDocsAdd.check = newValue
      this.UWUserDocsRead.check = newValue
      this.UWUserDocsEdit.check = newValue
      this.UWUserDocsDelete.check = newValue
    },
    'UWUserGroupRefresh.check': function (newValue, oldValue) {
      newValue ? this.UWUserGroups[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserGroups[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWUserGroupAdd.check': function (newValue, oldValue) {
      newValue ? this.UWUserGroups[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserGroups[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWUserGroupDelete.check': function (newValue, oldValue) {
      newValue ? this.UWUserGroups[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserGroups[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWUserAddContactsRefresh.check': function (newValue, oldValue) {
      newValue ? this.UWUserAdditional[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserAdditional[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWUserAddContactsRead.check': function (newValue, oldValue) {
      newValue ? this.UWUserAdditional[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserAdditional[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWUserAddContactsEdit.check': function (newValue, oldValue) {
      newValue ? this.UWUserAdditional[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserAdditional[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWUserAddContactsAdd.check': function (newValue, oldValue) {
      newValue ? this.UWUserAdditional[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserAdditional[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWUserAddContactsDelete.check': function (newValue, oldValue) {
      newValue ? this.UWUserAdditional[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserAdditional[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWUserDocsRefresh.check': function (newValue, oldValue) {
      newValue ? this.UWUserDocuments[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserDocuments[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWUserDocsAdd.check': function (newValue, oldValue) {
      newValue ? this.UWUserDocuments[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserDocuments[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWUserDocsRead.check': function (newValue, oldValue) {
      newValue ? this.UWUserDocuments[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserDocuments[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWUserDocsEdit.check': function (newValue, oldValue) {
      newValue ? this.UWUserDocuments[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserDocuments[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UWUserDocsDelete.check': function (newValue, oldValue) {
      newValue ? this.UWUserDocuments[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserDocuments[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UEUsersGenUsr.check': function (newValue, oldValue) {
      newValue ? this.UWUserGenerate[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWUserGenerate[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Dealer.check': function (newValue, oldValue) {
      newValue ? this.UWDealerLinkdealer[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWDealerLinkdealer[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Orders.check': function (newValue, oldValue) {
      newValue ? this.UWContractsSigncontract[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.UWContractsSigncontract[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Blocks.check': function (newValue, oldValue) {
      newValue ? this.ReportsBlockings[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsBlockings[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Traffic.check': function (newValue, oldValue) {
      newValue ? this.ReportsTraffic[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsTraffic[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Payments.check': function (newValue, oldValue) {
      newValue ? this.ReportsPayments[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsPayments[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Charges.check': function (newValue, oldValue) {
      newValue ? this.ReportsInternalTransfer[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsInternalTransfer[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'DialupAndVPN.check': function (newValue, oldValue) {
      newValue ? this.ReportsSessions[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsSessions[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'MainReport.check': function (newValue, oldValue) {
      newValue ? this.ReportsGeneral[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsGeneral[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Telephony.check': function (newValue, oldValue) {
      newValue ? this.ReportsTelephony[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsTelephony[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'ServicesReports.check': function (newValue, oldValue) {
      newValue ? this.ReportsServices[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsServices[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'OtherCharges.check': function (newValue, oldValue) {
      newValue ? this.ReportsOthercharges[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsOthercharges[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'TrafficDetail.check': function (newValue, oldValue) {
      newValue ? this.ReportsDetailedTraffic[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsDetailedTraffic[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UsersCharges.check': function (newValue, oldValue) {
      newValue ? this.ReportsUserLog[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsUserLog[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'BurnPayments.check': function (newValue, oldValue) {
      newValue ? this.ReportsExpiringPayments[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsExpiringPayments[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Invoices.check': function (newValue, oldValue) {
      newValue ? this.ReportsInvoices[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsInvoices[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'GraphReport.check': function (newValue, oldValue) {
      newValue ? this.ReportsGraphicReport[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsGraphicReport[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'PersonalServices.check': function (newValue, oldValue) {
      newValue ? this.ReportsCustomreport[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsCustomreport[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'TelDir.check': function (newValue, oldValue) {
      newValue ? this.ReportsTelephonydir[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsTelephonydir[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'DHCPLeases.check': function (newValue, oldValue) {
      newValue ? this.ReportsDHCPlease[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsDHCPlease[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'GroupsReport.check': function (newValue, oldValue) {
      newValue ? this.ReportsGroups[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsGroups[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'NewInvoicesReports.check': function (newValue, oldValue) {
      newValue ? this.ReportsNewinvoice[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsNewinvoice[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'EmailSend.check': function (newValue, oldValue) {
      newValue ? this.ReportsSendmail[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsSendmail[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'PaymentRollBack.check': function (newValue, oldValue) {
      newValue ? this.ReportsCancelpayment[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ReportsCancelpayment[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'reports.check': function (newValue, oldValue) {
      this.Blocks.check = newValue
      this.Traffic.check = newValue
      this.Payments.check = newValue
      this.Charges.check = newValue
      this.DialupAndVPN.check = newValue
      this.MainReport.check = newValue
      this.Telephony.check = newValue
      this.ServicesReports.check = newValue
      this.OtherCharges.check = newValue
      this.TrafficDetail.check = newValue
      this.UsersCharges.check = newValue
      this.BurnPayments.check = newValue
      this.Invoices.check = newValue
      this.GraphReport.check = newValue
      this.PersonalServices.check = newValue
      this.TelDir.check = newValue
      this.DHCPLeases.check = newValue
      this.GroupsReport.check = newValue
      this.NewInvoicesReports.check = newValue
      this.EmailSend.check = newValue
      this.PaymentRollBack.check = newValue
    },
    'DisconnectRADIUSSession.check': function (newValue, oldValue) {
      newValue ? this.DisconnectRADIUSSessionFuncsIDs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.DisconnectRADIUSSessionFuncsIDs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'DropRADIUSSession.check': function (newValue, oldValue) {
      newValue ? this.DropRADIUSSessionFuncsIDs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.DropRADIUSSessionFuncsIDs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'DropHotspotSession.check': function (newValue, oldValue) {
      newValue ? this.DropHotspotSessionFuncsIDs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.DropHotspotSessionFuncsIDs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Provider.check': function (newValue, oldValue) {
      newValue ? this.ProviderFuncsIDs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.ProviderFuncsIDs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },

    'DealerFunc.check': function (newValue, oldValue) {
      newValue ? this.DealerFuncsIDs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.DealerFuncsIDs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Cashier.check': function (newValue, oldValue) {
      newValue ? this.CashierFuncsIDs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.CashierFuncsIDs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'Other.check': function (newValue, oldValue) {
      newValue ? this.OtherFuncsIDs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.OtherFuncsIDs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'WebInterfaceFunctions.check': function (newValue, oldValue) {
      newValue ? this.WebInterfaceFunctionsFuncsIDs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.WebInterfaceFunctionsFuncsIDs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGDealerRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainUgDealers[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgDealers[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGDealerAdd.check': function (newValue, oldValue) {
      newValue ? this.mainUgDealers[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgDealers[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGDealerRead.check': function (newValue, oldValue) {
      newValue ? this.mainUgDealers[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgDealers[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGDealerEdit.check': function (newValue, oldValue) {
      newValue ? this.mainUgDealers[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgDealers[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGDealerDelete.check': function (newValue, oldValue) {
      newValue ? this.mainUgDealers[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgDealers[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGGroupsRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainUgGroups[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgGroups[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGGroupsAdd.check': function (newValue, oldValue) {
      newValue ? this.mainUgGroups[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgGroups[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGGroupsRead.check': function (newValue, oldValue) {
      newValue ? this.mainUgGroups[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgGroups[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGGroupsEdit.check': function (newValue, oldValue) {
      newValue ? this.mainUgGroups[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgGroups[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGGroupsDelete.check': function (newValue, oldValue) {
      newValue ? this.mainUgGroups[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgGroups[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGGroupsOp.check': function (newValue, oldValue) {
      newValue ? this.mainUgGroups[5].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgGroups[5].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGIPgroups.check': function (newValue, oldValue) {
      newValue ? this.mainUgIPGroups[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgIPGroups[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGSysGroupsRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainUgSysGroups[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgSysGroups[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGSysGroupsAdd.check': function (newValue, oldValue) {
      newValue ? this.mainUgSysGroups[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgSysGroups[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGSysGroupsRead.check': function (newValue, oldValue) {
      newValue ? this.mainUgSysGroups[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgSysGroups[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGSysGroupsEdit.check': function (newValue, oldValue) {
      newValue ? this.mainUgSysGroups[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgSysGroups[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGSysUsersRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainUgSysUsers[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgSysUsers[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGSysUsersAdd.check': function (newValue, oldValue) {
      newValue ? this.mainUgSysUsers[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgSysUsers[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGSysUsersRead.check': function (newValue, oldValue) {
      newValue ? this.mainUgSysUsers[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgSysUsers[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGSysUsersEdit.check': function (newValue, oldValue) {
      newValue ? this.mainUgSysUsers[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgSysUsers[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGSysUsersDelete.check': function (newValue, oldValue) {
      newValue ? this.mainUgSysUsers[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgSysUsers[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGCardPoolRefresh.check': function (newValue, oldValue) {
      newValue ? this.mainUgCardPools[0].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgCardPools[0].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGCardPoolAddcardowner.check': function (newValue, oldValue) {
      newValue ? this.mainUgCardPools[1].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgCardPools[1].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGCardPoolRemove.check': function (newValue, oldValue) {
      newValue ? this.mainUgCardPools[2].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgCardPools[2].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGCardPoolMove.check': function (newValue, oldValue) {
      newValue ? this.mainUgCardPools[3].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgCardPools[3].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGCardPoolBlock.check': function (newValue, oldValue) {
      newValue ? this.mainUgCardPools[4].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgCardPools[4].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGCardPoolUnblock.check': function (newValue, oldValue) {
      newValue ? this.mainUgCardPools[5].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgCardPools[5].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGCardPoolRead.check': function (newValue, oldValue) {
      newValue ? this.mainUgCardPools[6].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgCardPools[6].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGCardPoolAdd.check': function (newValue, oldValue) {
      newValue ? this.mainUgCardPools[7].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgCardPools[7].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGCardPoolSearch.check': function (newValue, oldValue) {
      newValue ? this.mainUgCardPools[8].funcs.forEach(el => {
        el.isEnabled = true
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, true)
        }.bind(this))
      }) : this.mainUgCardPools[8].funcs.forEach(el => {
        el.isEnabled = false
        this.enabledFids.forEach(function callback (value, index) {
          if (value.fid_id === el.id) this.$emit('allowanceFid', index, false)
        }.bind(this))
      })
    },
    'UaGDealers.check': function (newValue, oldValue) {
      this.UaGDealerRefresh.check = newValue
      this.UaGDealerAdd.check = newValue
      this.UaGDealerRead.check = newValue
      this.UaGDealerEdit.check = newValue
      this.UaGDealerDelete.check = newValue
    },
    'UaGGroups.check': function (newValue, oldValue) {
      this.UaGGroupsRefresh.check = newValue
      this.UaGGroupsAdd.check = newValue
      this.UaGGroupsRead.check = newValue
      this.UaGGroupsEdit.check = newValue
      this.UaGGroupsDelete.check = newValue
      this.UaGGroupsOp.check = newValue
    },
    'UaGSysGroups.check': function (newValue, oldValue) {
      this.UaGSysGroupsRefresh.check = newValue
      this.UaGSysGroupsAdd.check = newValue
      this.UaGSysGroupsRead.check = newValue
      this.UaGSysGroupsEdit.check = newValue
    },
    'UaGSysUsers.check': function (newValue, oldValue) {
      this.UaGSysUsersRefresh.check = newValue
      this.UaGSysUsersAdd.check = newValue
      this.UaGSysUsersRead.check = newValue
      this.UaGSysUsersEdit.check = newValue
      this.UaGSysUsersDelete.check = newValue
    },
    'UaGCardPool.check': function (newValue, oldValue) {
      this.UaGCardPoolRefresh.check = newValue
      this.UaGCardPoolAddcardowner.check = newValue
      this.UaGCardPoolRemove.check = newValue
      this.UaGCardPoolMove.check = newValue
      this.UaGCardPoolBlock.check = newValue
      this.UaGCardPoolUnblock.check = newValue
      this.UaGCardPoolRead.check = newValue
      this.UaGCardPoolAdd.check = newValue
      this.UaGCardPoolSearch.check = newValue
    },
    'userAndGroup.check': function (newValue, oldValue) {
      this.UaGUsers.check = newValue
      this.UaGDealers.check = newValue
      this.UaGGroups.check = newValue
      this.UaGIPgroups.check = newValue
      this.UaGSysGroups.check = newValue
      this.UaGSysUsers.check = newValue
      this.UaGCardPool.check = newValue
    },
    'mainView.check': function (newValue, oldValue) {
      this.userAndGroup.check = newValue
      this.messages.check = newValue
      this.Tariffication.check = newValue
      this.Refbook.check = newValue
      this.Settings.check = newValue
      this.Additional.check = newValue
      this.Interfaces.check = newValue
      this.About.check = newValue
      this.f1C.check = newValue
      this.Inventory.check = newValue
    },
    dealerfuncsgetter: function (val) {
      let copy = val
      copy.forEach(el => {
        if (el.fid_id > 0x70000000 && el.fid_id < 0x7fffffff) {
          let it = {name: el.fid_name, id: el.fid_id, isEnabled: false}
          this.DealerFuncsIDs.push(it)
        }
      })
    }
  },
  computed: {
    dealerfuncsgetter () {
      return this.$store.getters['Users/FIDS']
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_FIDS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/systemGroups/urfasTree.vue